import React, { useState, useEffect, useCallback, useRef } from "react";
import { apiQueryWithToken, apiQueryToUploadDataRegional } from "../../common/services/apiBaseUrlConfig";
import {
    MotifButton, MotifLabel, MotifFormField, MotifTable, MotifIcon, MotifSelect, MotifOption, MotifPagination,
    MotifTooltip, MotifCheckbox, MotifSearch, MotifInput, MotifErrorMessage,
    MotifBadge, MotifAccordion, MotifAccordionTrigger, MotifAccordionContent, MotifToast, MotifProgressBar,
    MotifTableHeaderRenderer
} from "@ey-xd/motif-react";

import { TableHeader } from "./TableHeader";
import { useLocation, useNavigate } from "react-router-dom";
import { MotifProgressLoader } from "@ey-xd/motif-react";
import { getAccount, getAccountByEmail, searchGraphUsers } from "../../common/services/commonService";
import { ViewFiles } from './ViewFiles'; // Import your MenuComponent

import { AddFiles } from "./addFiles";
import { FailedFilesUpload } from "./FailedFilesUpload"
import { lockIcon, infoIcon, waringIcon, IconoirCheck, syncIcon, IconoirCloudUpload, IconoirDownload, IconoirEye, IconoirEditPencil } from '../../common/MotifIcons';
// redux actions
import { ARC_POST_PROCESSING_POLL_INTERVAL_MS, isArcPostProcessingSettled } from './arcPostProcessingPoll';
import { partnersUploadCountSingleRequest, partnersUploadProcessingAU, partnersUploadProcessingEU, partnersUploadProcessingUS, resetPartnersEditEngagementStatus, partnersDownloadArcArchivesRequest, ARC_TERMINAL_UPLOAD_STATUSES } from './redux/partnerFileUploadSlice';
import { PendingFiles } from "./PendingFiles";
import AppliedFilterChips from "./AppliedFilterChips";
import useAppliedFilterChips from "./useAppliedFilterChips";
import { buildStaticOptionSets, getSetFilterValues } from "./appliedFilterChipsUtils";
import Dialog from "@mui/material/Dialog";
import DialogTitle from "@mui/material/DialogTitle";
import DialogContent from "@mui/material/DialogContent";
import DialogActions from "@mui/material/DialogActions";
import IconButton from "@mui/material/IconButton";
import CloseIcon from "@mui/icons-material/Close";
import { decryptSasUri } from "../../common/utility/cryptoUtils";
import debounce from 'lodash.debounce';
import Select from "react-select";
import useGetApplicationData from "../../common/redux/common/getApplicationData/useGetApplicationData";
import { useDispatch, useSelector } from "react-redux";
import { getApplicationData } from "../../common/redux/common/getApplicationData/getApplicationDataSlice";
import { getFilesEngagementData, getPartnerEditEngagementDetailsUS, getPartnerEditEngagementDetailsEU, getPartnerEditEngagementDetailsAU, getUtilityData, getPartnersFilesDeleteAU, getPartnersFilesDeleteUS, getPartnersFilesDeleteEU, getPartnersViewFilesContentUS, getPartnersViewFilesContentEU, getPartnersViewFilesContentAU, PartnersDeleteTempFilesOnPopupCloseUS, PartnersDeleteTempFilesOnPopupCloseAU, PartnersDeleteTempFilesOnPopupCloseEU, getPartnersFilesDownloadUS, getPartnersFilesDownloadEU, getPartnersFilesDownloadAU, resetPartnersFilesDownload, partnersEditEngagementStatusUS, partnersEditEngagementStatusEU, partnersEditEngagementStatusAU, partnersAccessGrantUS, partnersAccessGrantEU, partnersAccessGrantAU, partnersAccessRevokeUS, partnersAccessRevokeEU, partnersAccessRevokeAU } from "./redux/partnerFileUploadSlice";
import { ApiStatus } from "../../common/services/api-status.enum";
import usePartnerFileUpload from "./hooks/usePartnerFileUpload";
import { UNITED_KINGDOM, MAX_ARC_DOWNLOAD_SELECTION } from "../../common/contants/constants";
import AsyncAvatar from "../../common/async-avatar/async-avatar/AsyncAvatar";
import { ModuleRegistry, ClientSideRowModelModule, TextFilterModule, NumberFilterModule, PinnedRowModule } from 'ag-grid-community';
import { AgGridReact } from 'ag-grid-react';
import 'ag-grid-community/styles/ag-grid.css';
import 'ag-grid-community/styles/ag-theme-quartz.css';
import 'ag-grid-enterprise';
import { LicenseManager, SetFilterModule, ColumnsToolPanelModule, FiltersToolPanelModule, ColumnMenuModule, ContextMenuModule, RowGroupingModule, ClipboardModule } from 'ag-grid-enterprise';
import "./partnerFileUpload.scss";
import PlayIcon from "../../common/images/PlayIcon.png";
import PauseIcon from "../../common/images/PauseIcon.png";
import { Sort } from "@mui/icons-material";
import { EngagementQualification } from "./engagementQualification/EngagementQualification";
import {
    EDITABLE_ENGAGEMENT_EXPORT_COLUMNS,
    createEditableEngagementExportFile,
    downloadBlobFile,
    parseEditableEngagementImportFile,
    validateEditableEngagementImportRows,
} from "./engagementExportUtils";
import {
    buildGicsNameHierarchy,
    getGicsIndustryGroupOptions,
    getGicsIndustryOptions,
    getGicsSectorOptions,
    getGicsSubIndustryOptions,
    hasRequiredUploadMetadata,
    normalizeGicsRow,
    resolveGicsSelection,
    toGicsEditPayload,
} from "./gicsSectorUtils";
import { ENDPOINT } from "../../common/services/endpoint.config";
import logger from "../../common/utils/logger";
import OutageToast from "../outage/outageToast";
import PartnerUploadFooter from "./PartnerUploadFooter";
import { parseUtcToEpochMs } from "../../common/services/outageMonitor";

// Enable AG Grid Enterprise globally (local testing shows watermark without a license).
let AG_SET_FILTER_AVAILABLE = true;
if (LicenseManager && process.env.REACT_APP_AG_GRID_LICENSE) {
    LicenseManager.setLicenseKey(process.env.REACT_APP_AG_GRID_LICENSE);
}
ModuleRegistry.registerModules([
    // Community
    ClientSideRowModelModule,
    TextFilterModule,
    NumberFilterModule,
    PinnedRowModule,
    // Enterprise
    SetFilterModule,
    ColumnMenuModule,
    ContextMenuModule,
    ClipboardModule,
    ColumnsToolPanelModule,
    FiltersToolPanelModule,
    RowGroupingModule
]);

// Narrows a FIXED-LIST set-filter column's popup options to the values available under the OTHER active
// column filters, using the same getSetFilterValues logic that powers the applied-filter chips — so the
// popup list and the chip always agree. refreshValuesOnOpen re-narrows each time the popup is opened
// (i.e. after another column's filter changed). staticFilterOptionSets (read from the grid context)
// seeds the full option list.
// This is ONLY used for columns whose options come from a fixed list (region, country, service, etc.).
// Columns whose options come from the row data (partnerName, transactionType, dataSource, pendingFiles)
// intentionally have NO filterParams: AG Grid then derives their values from the grid and applies its
// built-in "available values" narrowing (it shows only values passing the other filters while keeping
// already-selected values visible). A values callback would switch those columns off that built-in path
// and can leave the popup empty, so we let AG Grid handle them natively.
const narrowedSetFilterParams = (colId) => ({
    values: (params) =>
        params.success(getSetFilterValues(params.api, params.context, colId, params.context?.staticFilterOptionSets)),
    refreshValuesOnOpen: true,
});

// ARC engagements are only submittable once they had password-protected pending files that
// were later unlocked. Once passwords are provided, totalPendingFile drops to 0 and is
// indistinguishable from "never had pending", so we persist the GUIDs that ever had pending
// files (survives reloads) to keep the Submit gating correct.
const ARC_HAD_PENDING_STORAGE_KEY = "arcEngagementsHadPendingFiles";

const readArcHadPendingSet = () => {
    try {
        const raw = localStorage.getItem(ARC_HAD_PENDING_STORAGE_KEY);
        const parsed = raw ? JSON.parse(raw) : [];
        return new Set(Array.isArray(parsed) ? parsed : []);
    } catch {
        return new Set();
    }
};

const persistArcHadPendingSet = (set) => {
    try {
        localStorage.setItem(ARC_HAD_PENDING_STORAGE_KEY, JSON.stringify([...set]));
    } catch {
        /* ignore storage write failures */
    }
};

// Region/Country only apply to buy-side engagements; the edit dialog hides them otherwise.
const ARC_MANDATORY_METADATA_FIELDS_BUY_SIDE = [
    "targetRegion",
    "targetCountry",
    "gicsSector",
    "industryGroup",
    "industry",
    "subindustry",
    "revenueRange",
];
const ARC_MANDATORY_METADATA_FIELDS_DEFAULT = [
    "gicsSector",
    "industryGroup",
    "industry",
    "subindustry",
    "revenueRange",
];

const isMetadataValueMissing = (value) => {
    const normalized = String(value ?? "").trim().toLowerCase();
    return !normalized || normalized === "select";
};

const isArcMetadataMissing = (row) => {
    if (String(row?.dataSource || "").toUpperCase() !== "ARC") return false;
    const isBuySide = String(row?.transactionType || "").trim().toLowerCase() === "buy-side";
    const mandatoryFields = isBuySide
        ? ARC_MANDATORY_METADATA_FIELDS_BUY_SIDE
        : ARC_MANDATORY_METADATA_FIELDS_DEFAULT;
    return mandatoryFields.some((field) => isMetadataValueMissing(row?.[field]));
};

// Human-readable list of the values selected behind a single column's AG Grid filter model, used
// for the applied-filter chip's count badge and its hover tooltip. Set filters expose their chosen
// values directly (null/empty shown as "(Blanks)" to match AG Grid's own label); text/number/date
// filters are condition-based, so list each condition's entered value.
const getFilterSelectionValues = (filterModel) => {
    if (!filterModel) return [];
    if (Array.isArray(filterModel.values)) {
        return filterModel.values.map((v) => (v === null || v === "" ? "(Blanks)" : String(v)));
    }
    const conditions = Array.isArray(filterModel.conditions)
        ? filterModel.conditions
        : [filterModel.condition1, filterModel.condition2].filter(Boolean);
    const source = conditions.length > 0 ? conditions : [filterModel];
    return source
        .map((c) => c?.filter ?? c?.dateFrom ?? "")
        .filter((v) => v !== "" && v != null)
        .map(String);
};

export const PartnerFileUpload = () => {
    const [searchValue, setSearchValue] = useState("");
    const [searchUser, setSearchUser] = useState("");
    const [isLoading, setIsLoading] = React.useState(false);
    const [isViewLoading, setIsViewLoading] = React.useState(false);
    const [isPendingFilesLoading, setIsPendingFilesLoading] = React.useState(false);
    const [isDeletePendingFiles, setIsDeletePendingFiles] = React.useState(false);
    const [fileData, setFileData] = useState([]);
    const [rowData, setRowData] = useState([]);
    const [engagementData, setEngagementData] = useState([]);
    const [pendingFilesData, setPendingFilesData] = useState([]);
    const [engagementIdList, setEngagementIdList] = useState([]);
    const navigation = useNavigate();
    const location = useLocation();
    const [isMenuOpen, setMenuOpen] = useState(false);
    const [showOutageToast, setShowOutageToast] = useState(false);
    const [outageInfo, setOutageInfo] = useState(null);
    // Tracks whether the user has manually dismissed the outage banner during this page visit.
    // Resets automatically whenever the component remounts (e.g. navigating away and back / re-login),
    // so the banner will show again on a fresh visit even if it was dismissed previously.
    const outageDismissedRef = useRef(false);
    // Timer that auto-hides the outage banner exactly when the announced outage
    // start time is reached, so the "prior" banner disappears the moment the
    // outage becomes active.
    const outageBannerHideTimeoutRef = useRef(null);
    const [isPendingFileOpen, setPendingFileOpen] = useState(false);
    const [isAddFilesOpen, setAddFilesOpen] = useState(null);
    const [isFailedUploadOpen, setFailedUploadOpen] = useState(false);
    const [totalPendingCount, setTotalPendingCount] = useState(0);
    const [menuItems, setMenuItems] = useState([]);
    const [isEditModalOpen, setIsEditModalOpen] = useState(false);
    const [userData, setUserData] = useState([]);
    const userDataRef = useRef([]);
    const [sectorId, setSectorId] = useState(0);
    const [industryGroupId, setIndustryGroupId] = useState(0);
    const [industryId, setIndustryId] = useState(0);
    const [subIndustryId, setSubIndustryId] = useState(0);
    const [engagementId, setEngagementId] = useState(0);
    const [engagementId_GUID, setEngagementId_GUID] = useState(0);
    const [marketSize, setMarketSize] = useState("");
    const [isSaveEnabled, setIsSaveEnabled] = useState(false);
    const [sslCompetancy, setSslCompetancy] = React.useState("");
    const [baseURL, setBaseURL] = useState("");
    const [selectedRow, setSelectedRow] = useState(0);
    const [hasInteracted, setInteraction] = useState(false);
    const [interactedEngagementId, setInteractedEngagementId] = useState(null);
    const [sectorName, setSectorName] = useState("");
    const [industryGroupName, setIndustryGroupName] = useState("");
    const [industryName, setIndustryName] = useState("");
    const [subIndustryName, setSubIndustryName] = useState("");
    const [isDialogOpen, setIsDialogOpen] = useState(false);
    const [currentPage, setCurrentPage] = useState(1);
    const rowsPerPage = 10; // You can make this dynamic too
    const startIndex = (currentPage - 1) * rowsPerPage;
    const endIndex = startIndex + rowsPerPage;
    const [isToastVisible, setIsToastVisible] = useState(false); // State to control toast visibility
    // State to store errors by engagementId
    const [engagementErrors, setEngagementErrors] = useState({});
    // Fetch errors for all engagement IDs on moun
    const [isEditMode, setEditMode] = useState(false);
    const [region, setRegion] = React.useState("");
    const [area, setArea] = React.useState("");
    const [country, setCountry] = React.useState("");
    const [dialogMode, setDialogMode] = useState(null);
    const [targetRegion, setTargetRegion] = React.useState("");
    const [targetArea, setTargetArea] = React.useState("");
    const [targetCountry, setTargetCountry] = React.useState("");
    const [serviceName, setServiceName] = React.useState("");
    const [competency, setCompetency] = React.useState("");
    const [practice, setPractice] = React.useState("");
    const [transactionType, setTransactionType] = React.useState("");
    const [toastMessage, setToastMessage] = useState('');
    const [showToast, setShowToast] = useState(false);
    const [buttonClicked, setButtonClicked] = React.useState("");
    const [checkedEngIds, setCheckedEngIds] = useState([]);
    const [inputValue, setInputValue] = useState('');
    const [gridApi, setGridApi] = useState(null);
    const [gridColumnApi, setGridColumnApi] = useState(null);
    const [savedColumnState, setSavedColumnState] = useState(null);
    const [isFileViewerOpen, setFileViewerOpen] = useState(false);
    const [decryptedFileUrl, setDecryptedFileUrl] = useState('');
    const [fileName, setFileName] = useState('');
    const [TempFileName, setTempFileName] = useState('');
    const [deleteDialogOpen, setDeleteDialogOpen] = useState(false);
    const [dataUploaderList, SetDataUploaderList] = useState([]);
    const userProfileDetails = JSON.parse(sessionStorage.getItem("profileDetails"));
    const isEPUser = userProfileDetails?.isEP === true;
    const isEngagementAdminUser = userProfileDetails?.isEngagementAdmin === true;
    const canAccessEngagementQualification = isEPUser || isEngagementAdminUser;
    const [manageDelegateMsg, SetManageDelegateMsg] = useState('');
    const [isDelegateToastVisible, setIsDelegateToastVisible] = useState(false);
    const [showManageAccessLoader, SetshowManageAccessLoader] = useState(false);
    const [openMDDialog, setOpenMDDialog] = React.useState(false);
    const [deleteOption, SetDeleteOption] = React.useState('');
    const [uploaderToDelete, SetUploaderToDelete] = React.useState('');
    const [selectedEngagementToRevoke, SetSelectedEngagementToRevoke] = React.useState([]);
    const [delegateAction, SetDelegateAction] = React.useState('');
    const [failedUploads, setFailedUploads] = useState([]);//1
    const failedUploadsRef = useRef([]);
    const [additionalTags, setAdditionalTags] = React.useState('');
    const [wordCount, setWordCount] = useState(0);
    const [isTagsDialogOpen, setIsTagsDialogOpen] = useState(false);
    const [tagsDialogInput, setTagsDialogInput] = useState('');
    const [tagsDialogList, setTagsDialogList] = useState([]);
    const [tagsDialogRow, setTagsDialogRow] = useState(null);
    const [tagsDialogError, setTagsDialogError] = useState('');
    const [openFailedUploadBadge, setOpenFailedUploadBadge] = useState(false);
    // Redux-provided upload counts (seeded from utility data, refreshed per engagement by saga)
    const uploadCountsState = useSelector(state => state?.partnerFileData?.partnersUploadCounts?.partnersUploadCountsData);
    const uploadCounts = uploadCountsState?.data || {};
    const uploadCountsStatus = uploadCountsState?.status;
    const uploadCountsRef = useRef(uploadCounts);
    const fileDataRef = useRef(fileData);
    const [uploadPercentage, setUploadPercentage] = useState({});
    const uploadPercentageRef = useRef({});
    const arcDownloadStatusRef = useRef({});
    // Tracks which engagements currently have an ARC download in progress so we can detect
    // when each one settles and refresh its failed-files list (drives the "Failed" badge).
    const arcDownloadActiveRef = useRef({});
    const arcHadPendingRef = useRef(readArcHadPendingSet());
    const [ShowErrorMsg, setShowErrorMsg] = useState(false);
    const dispatch = useDispatch();
    const [isFormDirty, setIsFormDirty] = useState(false);
    const { getApplicationDetail } = useGetApplicationData();
    const { utilityData, filesEngagementData, partnersEditEngagementDetailsData, partnersFilesDeleteData, partnersViewFilesContentData, partnersDeleteTempFilesOnPopupCloseData, partnersDownloadFilesContentData, partnersEditEngagementStatusData, partnersAccessGrantData, partnersAccessRevokeData, partnersUploadProcessingData, partnersEnableDisableClientData, plannedOutagePriorData, partnersDownloadArcArchivesData } = usePartnerFileUpload();
    const [tagsList, setTagsList] = useState([]);
    const [processedEngagements, setProcessedEngagements] = useState(0);
    const [failedUploadStatus, setFailedUploadStatus] = useState({});
    const failedUploadStatusRef = useRef({});
    const [failedUploadData, setFailedUploadData] = useState([]);
    const [isFailedUploadLoadData, setFailedUploadLoadData] = useState(true);
    const [updatedCountFailedUpload, setUpdatedCountFailedUpload] = useState("");
    const [showTagsDropdown, setShowTagsDropdown] = useState(false);
    const engagementPauseStatus = useRef({});
    const [postGrantRequests, setPostGrantRequests] = useState([]);
    const [postRevokeRequests, setPostRevokeRequests] = useState([]);
    const [openAlertDialog, setOpenAlertDialog] = useState(false);
    const [alertMessage, setAlertMessage] = useState("");
    const [, forceRender] = useState({});
    const [toolPanelState, setToolPanelState] = useState({ open: false, last: 'columns' });
    const [copied, setCopied] = React.useState(false);
    const [copiedValue, setCopiedValue] = React.useState('');

    const [failedIds, setFailedIds] = useState([]);
    const [ppIds, setPpIds] = useState([]);
    const [filesUploadedIds, setFilesUploadedIds] = useState([]);
    const [toggleChecked, setToggleChecked] = useState(false);
    const [openConvertClientDialog, setOpenConvertClientDialog] = useState(false);
    const [isConvertToastVisible, setIsConvertToastVisible] = useState(false);
    const [isConvertClientSuccessful, setIsConvertClientSuccessful] = useState(false);
    const [isConvertClientPartialSuccessful, setIsConvertClientPartialSuccessful] = useState(false);
    const [clientConversionMissingIds, setClientConversionMissingIds] = useState('');
    const [noFilesIds, setNoFilesIds] = useState([]);
    const [isEmailReminderToastVisible, setIsEmailReminderToastVisible] = useState(false);
    const [isEmailReminderSuccessful, setIsEmailReminderSuccessful] = useState(false);
    const [enableDisableEmailReminder, setEnableDisableEmailReminder] = useState(null);
    const [submittedIds, setSubmittedIds] = useState([]);
    const [isContactUsOpen, setIsContactUsOpen] = useState(false);
    const [contactMethod, setContactMethod] = useState('email');
    const [contactNotes, setContactNotes] = useState('');
    const [contactCountry, setContactCountry] = useState('');
    const [isContactSubmitting, setIsContactSubmitting] = useState(false);
    const [isContactToastVisible, setIsContactToastVisible] = useState(false);
    const [isContactToastSuccess, setIsContactToastSuccess] = useState(false);
    const [contactToastMessage, setContactToastMessage] = useState('');
    const initiateAutoProcess = useRef([]);
    const filteredDataRef = useRef([]);
    const lastSubmittedEngagementRef = useRef(null);
    const lastEditedEngagementRef = useRef(null);
    const persistedGridPageRef = useRef(0);
    const isRestoringGridPageRef = useRef(false);
    const [activeTab, setActiveTab] = useState(() => {
        const tabFromQuery = new URLSearchParams(window.location.search).get("tab");
        if (tabFromQuery === "engagementQualification") {
            return canAccessEngagementQualification ? "engagementQualification" : "dataUpload";
        }
        if (tabFromQuery === "dataUpload") {
            return tabFromQuery;
        }
        const storedTab = sessionStorage.getItem("partnerUploadActiveTab");
        if (storedTab === "engagementQualification") {
            return canAccessEngagementQualification ? "engagementQualification" : "dataUpload";
        }
        return "dataUpload";
    });
    const [isEditableExportLoading, setIsEditableExportLoading] = useState(false);
    const [isImportModalOpen, setIsImportModalOpen] = useState(false);
    const [importFile, setImportFile] = useState(null);
    const [importValidationResult, setImportValidationResult] = useState(null);
    const [isImportValidationLoading, setIsImportValidationLoading] = useState(false);
    const [isImportApplying, setIsImportApplying] = useState(false);
    const [importProcessResult, setImportProcessResult] = useState(null);
    const [importModalError, setImportModalError] = useState("");
    const isDataUploadTabActive = !canAccessEngagementQualification || activeTab === "dataUpload";

    useEffect(() => {
        const tabFromQuery = new URLSearchParams(location.search).get("tab");
        if (tabFromQuery === "engagementQualification") {
            setActiveTab(canAccessEngagementQualification ? "engagementQualification" : "dataUpload");
            return;
        }
        if (tabFromQuery === "dataUpload") {
            setActiveTab("dataUpload");
            return;
        }
        if (!canAccessEngagementQualification) {
            setActiveTab("dataUpload");
        }
    }, [canAccessEngagementQualification, location.search]);

    useEffect(() => {
        const effectiveTab = canAccessEngagementQualification ? activeTab : "dataUpload";
        if (activeTab !== effectiveTab) {
            setActiveTab(effectiveTab);
            return;
        }
        sessionStorage.setItem("partnerUploadActiveTab", effectiveTab);
        const url = new URL(window.location.href);
        if (url.searchParams.get("tab") !== effectiveTab) {
            url.searchParams.set("tab", effectiveTab);
            window.history.replaceState({}, '', url.pathname + url.search);
        }
    }, [activeTab, canAccessEngagementQualification]);

    useEffect(() => {
        uploadCountsRef.current = uploadCounts;
    }, [uploadCounts]);

    useEffect(() => {
        fileDataRef.current = fileData;
    }, [fileData]);

    useEffect(() => {
        uploadPercentageRef.current = uploadPercentage;
    }, [uploadPercentage]);

    useEffect(() => {
        failedUploadsRef.current = failedUploads;
    }, [failedUploads]);

    useEffect(() => {
        failedUploadStatusRef.current = failedUploadStatus;
    }, [failedUploadStatus]);

    useEffect(() => {
        arcDownloadStatusRef.current = partnersDownloadArcArchivesData?.data || {};
        if (gridApi?.refreshCells) {
            gridApi.refreshCells({ columns: ["pendingFiles", "actions"], force: true });
        }
    }, [partnersDownloadArcArchivesData?.data, gridApi]);

    // After a header "Download" / Actions download-icon request settles, the saga updates the
    // upload status/counts but does NOT re-read the per-engagement failed files. Detect each
    // engagement whose ARC download just finished (the saga clears its in-progress marker on
    // success, or marks it ERROR on failure) and re-fetch its errors so the "Failed" badge
    // reflects the files that failed to download. Works for single and bulk downloads.
    useEffect(() => {
        const data = partnersDownloadArcArchivesData?.data || {};
        const nextActive = {};
        Object.keys(data).forEach((guid) => {
            const status = data[guid]?.status;
            if (status === ApiStatus.LOADING || status === ApiStatus.SUCCESS) {
                nextActive[guid] = true;
            }
        });
        Object.keys(arcDownloadActiveRef.current || {}).forEach((guid) => {
            if (!nextActive[guid]) {
                GetErrorsByEngagement(guid, { force: true });
            }
        });
        arcDownloadActiveRef.current = nextActive;
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [partnersDownloadArcArchivesData?.data]);

    const normalizeGuid = (value) => String(value || "").replace(/[^a-zA-Z0-9]/g, "").toLowerCase();
    const getStatusGuid = (item) => item?.engagementGuid || item?.engagementId_GUID || item?.engagementIdGuid || item?.engagementID_GUID;

    const addTag = () => {
        const newTag = additionalTags.trim();

        if (newTag === '') {
            setShowErrorMsg(false);
            return;
        }

        if (tagsList.some(tag => tag.toLowerCase() === newTag.toLowerCase())) {
            setShowErrorMsg(true);
            setToastMessage('Tag already exists.');
            return;
        }

        if (tagsList.length >= 15) {
            setShowErrorMsg(true);
            setToastMessage('The limit has been reached.');
            return;
        }

        // Calculate the total length of all tags
        const totalLength = tagsList.join('').length + newTag.length;

        if (totalLength > 500) {
            setShowErrorMsg(true);
            setToastMessage('Total character limit of all tags should not exceed 500.');
            return;
        }

        setTagsList([...tagsList, newTag]);
        setIsFormDirty(true);
        setAdditionalTags('');
        setShowErrorMsg(false);
    };

    const removeTag = (index) => {
        const updatedTags = tagsList.filter((_, i) => i !== index);
        setTagsList(updatedTags);
        setIsFormDirty(true);
    };

    // useEffect to handle error messages based on tagsList and additionalTags
    useEffect(() => {
        if (tagsList.length >= 15) {
            setShowErrorMsg(true);
            setToastMessage('The limit has been reached.');
        } else {
            setShowErrorMsg(false);
        }
    }, [tagsList]);

    useEffect(() => {
        if (tagsList.some(tag => tag.toLowerCase() === additionalTags.trim().toLowerCase())) {
            setShowErrorMsg(true);
            setToastMessage('Tag already exists.');
        } else {
            setShowErrorMsg(false);
        }
    }, [additionalTags, tagsList]);

    // Find engagementIds with failed uploads using useEffect
    useEffect(() => {
        const ids = (utilityData?.data ?? [])
            .filter(item => {
                const engagementId = item.engagementId_GUID;
                const status = failedUploadStatus[engagementId];
                const failedCountValue = status?.data?.length ?? 0;
                return failedCountValue > 0;
            })
            .map(item => item.engagementId);
        setFailedIds(ids);
    }, [utilityData?.data, failedUploadStatus]);
    // Find engagementIds that require partner password using
    useEffect(() => {
        const EngGuids = Object.keys(uploadCounts).filter(
            key => uploadCounts[key]?.totalPendingFile > 0
        );
        const ids = (utilityData?.data ?? []).filter(item =>
            EngGuids.includes(item.engagementId_GUID)
        ).map(item => item.engagementId);
        setPpIds(ids);

    }, [uploadCounts, utilityData?.data]);

    useEffect(() => {
        const EngGuids = Object.keys(uploadCounts).filter(
            key => uploadCounts[key]?.totalPendingFile < 1 && uploadCounts[key]?.uploaD_STATUS === "Files Uploaded"
        );
        const ids = (utilityData?.data ?? []).filter(item =>
            EngGuids.includes(item.engagementId_GUID)
        ).map(item => item.engagementId);
        setFilesUploadedIds(ids);
    }, [uploadCounts, utilityData?.data]);

    useEffect(() => {
        const EngGuids = Object.keys(uploadCounts).filter(
            key => uploadCounts[key]?.uploaD_STATUS === "No files"
        );
        const ids = (utilityData?.data ?? []).filter(item =>
            EngGuids.includes(item.engagementId_GUID)
        ).map(item => item.engagementId);
        setNoFilesIds(ids);

    }, [uploadCounts, utilityData?.data]);

    useEffect(() => {
        const EngGuids = Object.keys(uploadCounts).filter(
            key => ["Submitted", "Submitted by ARC", "Submitted via Edge"].includes(uploadCounts[key]?.uploaD_STATUS)
        );
        const ids = (utilityData?.data ?? []).filter(item =>
            EngGuids.includes(item.engagementId_GUID)
        ).map(item => item.engagementId);
        setSubmittedIds(ids);

    }, [uploadCounts, utilityData?.data]);


    useEffect(() => {
        if (!isDataUploadTabActive) return;
        if (!fileData || !Array.isArray(fileData) || fileData.length === 0) return;

        const fetchAllEngagementErrors = async () => {
            const errorResults = {};

            // set before fetching
            if (isAddFilesOpen === true) {
                setFailedUploadLoadData(true);
                try {
                    const errors = await GetErrorsByEngagement(rowData.engagementId_GUID);
                    errorResults[rowData.engagementId_GUID] = errors;
                } catch (e) {
                    errorResults[rowData.engagementId_GUID] = null;
                }
            } else if (isAddFilesOpen === false) {
                setFailedUploadLoadData(true);
                try {
                    const errors = await GetErrorsByEngagement(rowData.engagementId_GUID);
                    errorResults[rowData.engagementId_GUID] = errors;
                } catch (e) {
                    errorResults[rowData.engagementId_GUID] = null;
                }
            }
            else if (isAddFilesOpen === null) {
                setFailedUploadLoadData(false);
                if (userProfileDetails?.isEngagementAdmin === true) {
                    if (!window.__engAdminErrorsFetched) {
                        window.__engAdminErrorsFetched = true;
                        GetAllErrorsAsEngAdmin();
                    }
                } else {
                    // setFailedUploadLoadData(false);
                    await Promise.all(
                        fileData.map(async (item) => {
                            try {
                                const errors = await GetErrorsByEngagement(item.engagementId_GUID);
                                errorResults[item.engagementId_GUID] = errors;
                            } catch (e) {
                                errorResults[item.engagementId_GUID] = null;
                            }
                        })
                    );
                }
            }



            setEngagementErrors(errorResults);
        };

        fetchAllEngagementErrors();

    }, [fileData, hasInteracted, isAddFilesOpen, isDataUploadTabActive])

    const onSelectionChanged = (event) => {
        const selectedNodes = event.api.getSelectedNodes();
        const selectedIds = selectedNodes.map(node => node.data.engagementId);
        setCheckedEngIds(selectedIds);

    }

    // Check for GUID parameter in URL and highlight matching row
    const [highlightedGUID, setHighlightedGUID] = useState(null);
    const [hasNavigatedToHighlightedRow, setHasNavigatedToHighlightedRow] = useState(false);

    useEffect(() => {
        const urlParams = new URLSearchParams(location.search);
        const guidParam = urlParams.get('eng_guid');
        if (guidParam) {
            setHighlightedGUID(guidParam);
            setHasNavigatedToHighlightedRow(false); // Reset navigation flag when GUID changes
        } else {
            setHighlightedGUID(null); // Clear highlight if no eng_guid in URL
        }
    }, [location.search]);

    // Function to get row class for highlighting
    const getRowClass = (params) => {
        return highlightedGUID && params.data?.engagementId_GUID === highlightedGUID
            ? 'highlighted-row'
            : '';
    };

    const handleCheckboxChange = (e) => {
        const { value, checked } = e.target;
        setCheckedEngIds(prev =>
            checked ? [...prev, value] : prev.filter(id => id !== value)
        );
    };

    const triggerEngagementUpdate = useCallback((engagementId, { force = false } = {}) => {
        if (!isDataUploadTabActive) return;
        const row = fileDataRef.current.find(r => r.engagementId === engagementId);
        if (row) {
            dispatch(partnersUploadCountSingleRequest({ engagementId_GUID: row.engagementId_GUID, area: row.area, force }));
        }
    }, [dispatch, isDataUploadTabActive]);
    // Before (re)starting an ARC download, clear that engagement's previous download-failure
    // records so the stale "Failed upload" entries are removed. Runs in the background
    // (fire-and-forget), keyed by the logged-in user and the engagement GUIDs (isArcDownload).
    // Accepts one or more GUIDs so the header bulk download can clear every selected engagement
    // in a single call.
    const deleteArcErrorLogs = (engagementGuids) => {
        // Only engagements that actually have failed-upload records need their error logs
        // cleared, so skip any without failed files. The failed-file data comes from
        // GetAllErrorsAsEngAdmin's api//errors/all response (stored in failedUploadStatus). For a
        // single (Actions icon) download this can mean no delete call at all; for a bulk (header)
        // download it drops the no-failure engagements from the payload.
        const guids = (engagementGuids || [])
            .filter(Boolean)
            .filter((guid) => (failedUploadStatusRef.current?.[guid]?.data?.length ?? 0) > 0);
        if (guids.length === 0) return;
        apiQueryWithToken
            .delete("api/errors/delete", {
                headers: { "Content-Type": "application/json" },
                data: {
                    ErrorIds: [],
                    EngagementIdGUID: "",
                    TransactionID:"",
                    emailAddress: getAccount()?.username,
                    isArcDownload: true,
                    arcDownloadEngagementGuids: guids,
                },
            })
            .catch((error) => {
                logger.error("Failed to delete ARC error logs on download:", error);
            });
    };

    const onDownloadArcFilesClick = (row_Data) => {
        if (!row_Data?.engagementId_GUID) return;
        dispatch(partnersDownloadArcArchivesRequest({
            engagementId_GUID: row_Data.engagementId_GUID,
            engagementId: row_Data.engagementId,
            email: getAccount()?.username,
            area: row_Data.area,
        }));
    };

    // Eligibility for both ARC download entry points: the header "Download" button (bulk) and the
    // per-row Actions download icon. An engagement is downloadable when it is an ARC source whose
    // Upload Status is one the download flow can act on: "Download Error", "No files", or "Failed
    // upload". Eligibility is derived with the SAME precedence the Upload Status column uses, so the
    // button/icon always agree with the status shown in the grid.
    const ARC_HEADER_DOWNLOAD_STATUSES = new Set(["no files", "download error (arc)", "failed upload"]);
    const isArcHeaderDownloadEligible = (row_Data) => {
        if (!row_Data) return false;
        if (String(row_Data.dataSource || "").toUpperCase() !== "ARC") return false;
        // Higher-precedence statuses that are NOT downloadable (mirrors the Upload Status column):
        // pending passwords render as "Provide password", incomplete metadata as "Metadata Missing".
        if (Number(row_Data.totalPendingFile || 0) > 0) return false;
        if (isArcMetadataMissing(row_Data)) return false;
        // "Download Error": an ARC engagement with unresolved download-failure records. This is the
        // same source the Upload Status column uses to render "Download Error", so rows shown as
        // "Download Error" are now correctly treated as downloadable here too.
        if ((failedUploadStatusRef.current?.[row_Data.engagementId_GUID]?.data?.length ?? 0) > 0) {
            return true;
        }
        // "No files" (nothing downloaded yet) or a tracking status the download flow can act on
        // ("Download Error (ARC)" / "Failed upload").
        const statusText = (Number(row_Data.noOfUploadedFiles) === 0
            ? "No files"
            : String(row_Data.engagementTrackingStatus || "")).trim().toLowerCase();
        return ARC_HEADER_DOWNLOAD_STATUSES.has(statusText);
    };

    // An ARC download is "in progress" (not yet settled) while its engagement GUID is held in the
    // download-status map as LOADING (downloading) or SUCCESS (downloaded, backend still syncing);
    // the saga removes the entry once the operation settles and marks it ERROR on failure. While in
    // progress, every download entry point for that engagement is disabled: the header Download
    // button, the Actions download icon, and the Failed panel's Retry Download button.
    const isArcGuidDownloading = (statusMap, guid) => {
        const status = statusMap?.[guid]?.status;
        return status === ApiStatus.LOADING || status === ApiStatus.SUCCESS;
    };

    // Rows backing the current grid checkbox selection (normalized fileData, so dataSource /
    // engagementTrackingStatus / noOfUploadedFiles match what the Upload Status column shows).
    const selectedEngagementRows = (fileData ?? []).filter(item => checkedEngIds.includes(item.engagementId));
    // The header Download button is enabled only for engagement admins when there is a selection
    // and every selected engagement is eligible for ARC download. A single bulk download accepts
    // at most MAX_ARC_DOWNLOAD_SELECTION engagements; selecting more disables the button until the
    // user deselects back down to the limit.
    const canBulkDownloadArc = userProfileDetails?.isEngagementAdmin === true &&
        checkedEngIds.length > 0 &&
        checkedEngIds.length <= MAX_ARC_DOWNLOAD_SELECTION &&
        selectedEngagementRows.length === checkedEngIds.length &&
        selectedEngagementRows.every(isArcHeaderDownloadEligible) &&
        // Disable the header Download while any selected engagement's download is still in flight
        // (e.g. started from its Actions icon or Retry Download) until that download settles.
        !selectedEngagementRows.some(row => isArcGuidDownloading(partnersDownloadArcArchivesData?.data, row.engagementId_GUID));

    const startBulkArcDownload = () => {
        const rowsToDownload = selectedEngagementRows.filter(isArcHeaderDownloadEligible);
        if (rowsToDownload.length === 0) return;
        // Clear every selected engagement's prior ARC download-failure records in a single call
        // (the delete endpoint is non-regional, so all areas are covered together).
        deleteArcErrorLogs(rowsToDownload.map(row => row.engagementId_GUID));
        // ARC archive download is regional (Americas / EMEIA / APAC each resolve to a
        // different base URL), so engagements from different areas must be downloaded in
        // separate API calls. Group by area (case-insensitively) and send each area's
        // engagements in a single comma-separated payload (one call per area).
        const rowsByArea = rowsToDownload.reduce((groups, row) => {
            const areaKey = String(row.area || "").trim().toLowerCase();
            (groups[areaKey] = groups[areaKey] || []).push(row);
            return groups;
        }, {});
        Object.values(rowsByArea).forEach(rows => {
            dispatch(partnersDownloadArcArchivesRequest({
                engagementId_GUID: rows.map(row => row.engagementId_GUID).join(","),
                engagementId: rows.map(row => row.engagementId).join(","),
                email: getAccount()?.username,
                area: rows[0]?.area,
            }));
        });
    };
    const getData = useCallback((showLoader = false) => {
        if (!isDataUploadTabActive) return;
        if (fileDataRef.current.length === 0 || showLoader) {
            setIsLoading(true);
        }
        const payload = {
            "EmailAddress": getAccount()?.username,
            "isEngagementAdmin": userProfileDetails?.isEngagementAdmin === null ? '' : userProfileDetails?.isEngagementAdmin,
            "CallFrom": "utility",
            "EngagementId_GUID": ""
        };
        if (getAccount()?.username) {
            dispatch(getUtilityData(payload)); // Dispatch the action to fetch application data
        }

    }, [dispatch, isDataUploadTabActive, userProfileDetails?.isEngagementAdmin]);

    // Merge redux uploadCounts into local fileData whenever counts change
    // Uses in-place mutation + gridApi row update to avoid full re-render and pagination reset
    useEffect(() => {
        if (!fileData || fileData.length === 0) return;
        const hasAny = Object.keys(uploadCounts || {}).length > 0;
        if (!hasAny) return;
        const rowsToUpdate = [];
        fileData.forEach(row => {
            const rec = uploadCounts[row.engagementId_GUID];
            if (!rec) return;
            const newPending = rec.totalPendingFile ?? row.totalPendingFile;
            const newUploaded = rec.noOfUploadedFiles ?? row.noOfUploadedFiles;
            const newStatus = rec.uploaD_STATUS ?? row.engagementTrackingStatus;
            if (
                newPending !== row.totalPendingFile ||
                newUploaded !== row.noOfUploadedFiles ||
                newStatus !== row.engagementTrackingStatus
            ) {
                row.totalPendingFile = newPending;
                row.noOfUploadedFiles = newUploaded;
                row.engagementTrackingStatus = newStatus;
                rowsToUpdate.push(row);
            }
        });
        if (rowsToUpdate.length > 0) {
            if (gridApi?.applyTransaction) {
                gridApi.applyTransaction({ update: rowsToUpdate });
            }
            gridApi?.refreshCells?.({ columns: ["pendingFiles", "actions", "noOfUploadedFiles"], force: true });
        }
    }, [uploadCounts]);

    // Record ARC engagements that have (had) password-protected pending files so the Submit
    // button can later be enabled once those files are unlocked. Persisted across reloads.
    useEffect(() => {
        if (!fileData || fileData.length === 0) return;
        let changed = false;
        fileData.forEach(row => {
            const guid = row?.engagementId_GUID;
            if (!guid) return;
            if (String(row?.dataSource || "").toUpperCase() !== "ARC") return;
            const pending = uploadCounts[guid]?.totalPendingFile ?? row.totalPendingFile ?? 0;
            if (pending > 0 && !arcHadPendingRef.current.has(guid)) {
                arcHadPendingRef.current.add(guid);
                changed = true;
            }
        });
        if (changed) {
            persistArcHadPendingSet(arcHadPendingRef.current);
            gridApi?.refreshCells?.({ columns: ["actions"], force: true });
        }
    }, [uploadCounts, fileData, gridApi]);
    const wordLimit = 500;

    const onAdditionalTagsClick = (event) => {
        const value = event.target.value.trimStart().replace(/\s+/g, ' ');
        const trimmedValue = value.replace(/[^a-zA-Z ]/g, '');
        setAdditionalTags(trimmedValue);

        // setIsFormDirty(true);
    };

    const openTagsDialog = (rowData) => {
        const tags = (rowData.freeTextTags || '').split(',').map(tag => tag.trim()).filter(tag => tag.length > 0);
        setTagsDialogRow(rowData);
        setTagsDialogList(tags);
        setTagsDialogInput('');
        setTagsDialogError('');
        setIsTagsDialogOpen(true);
    };

    const addTagInDialog = () => {
        const newTag = tagsDialogInput.trim();
        if (newTag === '') return;
        if (tagsDialogList.some(tag => tag.toLowerCase() === newTag.toLowerCase())) {
            setTagsDialogError('Tag already exists.');
            return;
        }
        if (tagsDialogList.length >= 15) {
            setTagsDialogError('Maximum 15 tags allowed.');
            return;
        }
        const totalLength = tagsDialogList.join('').length + newTag.length;
        if (totalLength > 500) {
            setTagsDialogError('Total character limit of all tags should not exceed 500.');
            return;
        }
        setTagsDialogList([...tagsDialogList, newTag]);
        setTagsDialogInput('');
        setTagsDialogError('');
    };

    const removeTagInDialog = (index) => {
        setTagsDialogList(tagsDialogList.filter((_, i) => i !== index));
    };

    const clearAllTagsInDialog = () => {
        setTagsDialogList([]);
    };

    const saveTagsDialog = () => {
        if (!tagsDialogRow) return;
        const newValue = tagsDialogList.join(', ');
        onInlineCellSave(tagsDialogRow, 'freeTextTags', newValue);
        const row = fileDataRef.current.find(item => item.engagementId === tagsDialogRow.engagementId);
        if (row) {
            row.freeTextTags = newValue;
            if (gridApi?.applyTransaction) {
                gridApi.applyTransaction({ update: [row] });
            }
            gridApi?.refreshCells?.({ columns: ["freeTextTags"], force: true });
        }
        setIsTagsDialogOpen(false);
    };

    const handlePageChange = (newPage) => {
        const parsedPage = Number(newPage);
        if (Number.isFinite(parsedPage) && parsedPage >= 1) {
            setCurrentPage(parsedPage);
        }
    };

    const onOpenMenu = (items) => {
        setMenuItems(items); // Set the items for the menu
        setMenuOpen(true); // Open the menu
    };

    const onAddFilesOpen = (items) => {
        setAddFilesOpen(true); // Open the menu


    };

    const onFaileUploadOpen = (items) => {
        setFailedUploadOpen(true);
        setOpenFailedUploadBadge(true);
        setAddFilesOpen(true);

    }

    const handleDialogOpen = () => setIsDialogOpen(true);
    const handleDialogClose = () => setIsDialogOpen(false);

    const handleDialogSave = () => {
        // Perform save logic
        logger.info("Saved data");
        setIsDialogOpen(false);
    };

    const onCloseMenu = () => {
        setMenuOpen(false); // Close the menu
    };
    const onAdddFilesClose = () => {
        setAddFilesOpen(false); // Close the menu
        triggerEngagementUpdate(rowData.engagementId, { force: true });
        // if (hasInteracted) {
        //     hasInteracted && getData();
        // }
    };
    const failedUploadClose = () => {
        setFailedUploadOpen(false);
    }
    const onPendingFilesClose = () => {
        setPendingFileOpen(false); // Close the menu
        triggerEngagementUpdate(rowData.engagementId, { force: true });
    };

    const setBaseURLByArea = (area) => {
        if ((area || "").toLowerCase() === "americas") {
            setBaseURL(process.env.REACT_APP_API_URL_US)
        } else if ((area || "").toLowerCase() === "emeia") {
            setBaseURL(process.env.REACT_APP_API_URL_EU)
        } else if ((area || "").toLowerCase() === "apac") {
            setBaseURL(process.env.REACT_APP_API_URL_AU)
        }
    };

    const resolveBaseURLByArea = (areaName = "") => {
        if ((areaName || "").toLowerCase() === "americas") {
            return process.env.REACT_APP_API_URL_US;
        }
        if ((areaName || "").toLowerCase() === "emeia") {
            return process.env.REACT_APP_API_URL_EU;
        }
        if ((areaName || "").toLowerCase() === "apac") {
            return process.env.REACT_APP_API_URL_AU;
        }
        return "";
    };

    const onEditModalClose = (event, reason) => {
        if (reason !== 'backdropClick' && reason !== 'escapeKeyDown') {
            setIsEditModalOpen(false);
            if (dialogMode === "submit") {
                setDialogMode(null);
                dispatch(resetPartnersEditEngagementStatus());
            }
        }
    };
    const applyGicsSelectionFromRow = (row_Data) => {
        const selection = resolveGicsSelection(userDataRef.current?.gicsSectorMappings, row_Data);
        setSectorId(selection.gicsSectorId ?? "");
        setIndustryGroupId(selection.industryGroupId ?? "");
        setIndustryId(selection.industryId ?? "");
        setSubIndustryId(selection.subIndustryId ?? "");
        setSectorName(selection.gicsSector);
        setIndustryGroupName(selection.industryGroup);
        setIndustryName(selection.industry);
        setSubIndustryName(selection.subindustry);
    };

    const onEditClick = (row_Data, updatemode = "") => {
        setArea(row_Data?.area);
        setRegion(row_Data?.region);
        setCountry(row_Data?.country);
        setIsSaveEnabled(false);
        setTargetArea(row_Data?.targetArea);
        setTargetRegion(row_Data?.targetRegion);
        setTargetCountry(row_Data?.targetCountry);
        setServiceName(row_Data?.serviceName || "");
        setCompetency(row_Data?.competency || "");
        setPractice(row_Data?.practice || "");
        setBaseURLByArea(row_Data?.area);
        setSelectedRow(row_Data);
        setEngagementId(row_Data.engagementId);
        setEngagementId_GUID(row_Data.engagementId_GUID);
        applyGicsSelectionFromRow(row_Data);
        setMarketSize(row_Data.revenueRange);
        setTransactionType(row_Data.transactionType)
        setSslCompetancy(row_Data.ssl);
        setDialogMode("edit");
        setButtonClicked(updatemode)
        const tags = (row_Data.freeTextTags || '').split(',').map(tag => tag.trim()).filter(tag => tag.length > 0); // Split and trim the tags
        setTagsList(tags); // Set the tags list
        setAdditionalTags('');
        setShowTagsDropdown(false);
        setIsEditModalOpen(true);

    };
    const onSaveClick = () => {
        setIsFormDirty(true);
        setIsLoading(true);
        lastEditedEngagementRef.current = { engagementId, engagementId_GUID, area };
        const derivedTargetArea = targetRegion
            ? (userData?.areaRegionCountryMappings?.find(
                (item) => item.regionName === targetRegion
            )?.areaName || targetArea)
            : targetArea;
        const payload = {
            engagementID: engagementId,
            ...toGicsEditPayload({
                gicsSectorId: sectorId,
                gicsSector: sectorName,
                industryGroupId: industryGroupId,
                industryGroup: industryGroupName,
                industryId: industryId,
                industry: industryName,
                subIndustryId: subIndustryId,
                subindustry: subIndustryName,
            }),
            ccs: selectedRow?.ccs || "",
            revenueRange: marketSize,
            ssl: sslCompetancy,
            area: area,
            region: region,
            country: country,
            targetArea: derivedTargetArea,
            targetRegion: targetRegion,
            targetCountry: targetCountry,
            serviceName: serviceName,
            competency: competency,
            practice: practice,
            email: getAccount()?.username,
            FreeTextTags: tagsList.join(', '),
            isEngagementAdmin: userProfileDetails?.isEngagementAdmin,
            EngagementId_GUID: engagementId_GUID

        };
        try {
            if (baseURL === process.env.REACT_APP_API_URL_US) {
                dispatch(getPartnerEditEngagementDetailsUS(payload));
            } else if (baseURL === process.env.REACT_APP_API_URL_EU) {
                dispatch(getPartnerEditEngagementDetailsEU(payload));
            } else if (baseURL === process.env.REACT_APP_API_URL_AU) {
                dispatch(getPartnerEditEngagementDetailsAU(payload));
            }
            setIsEditModalOpen(false);
            // getData();
        } catch (error) {
            setIsLoading(false);
            if (error.response && error.response.status === 401) {
                navigation("/");
            } else {
                logger.error("An error occurred:", error);
            }
        }
    };

    // New function for handling inline cell edits
    const onInlineCellSave = (rowData, fieldName, newValue) => {
        setIsLoading(true);
        setBaseURLByArea(rowData.area);
        lastEditedEngagementRef.current = { engagementId: rowData.engagementId, engagementId_GUID: rowData.engagementId_GUID, area: rowData.area };

        const effectiveTargetRegion = fieldName === 'targetRegion' ? newValue : rowData.targetRegion;
        const derivedTargetArea = fieldName === 'targetRegion'
            ? (userData?.areaRegionCountryMappings?.find(
                (item) => item.regionName === effectiveTargetRegion
            )?.areaName || rowData.targetArea)
            : rowData.targetArea;

        const gicsSelection = resolveGicsSelection(userDataRef.current?.gicsSectorMappings, {
            gicsSectorId: rowData.gicsSectorId,
            gicsSector: fieldName === 'gicsSector' ? newValue : rowData.gicsSector,
            industryGroupId: rowData.industryGroupId,
            industryGroup: fieldName === 'industryGroup' ? newValue : rowData.industryGroup,
            industryId: rowData.industryId,
            industry: fieldName === 'industry' ? newValue : rowData.industry,
            subIndustryId: rowData.subIndustryId,
            subindustry: fieldName === 'subindustry' ? newValue : rowData.subindustry,
        });

        const payload = {
            engagementID: rowData.engagementId,
            ...toGicsEditPayload(gicsSelection),
            ccs: rowData.ccs,
            revenueRange: fieldName === 'revenueRange' ? newValue : rowData.revenueRange,
            ssl: fieldName === 'ssl' ? newValue : rowData.ssl,
            area: rowData.area,
            region: rowData.region,
            country: rowData.country,
            targetArea: derivedTargetArea,
            targetRegion: fieldName === 'targetRegion' ? newValue : rowData.targetRegion,
            targetCountry: fieldName === 'targetCountry' ? newValue : rowData.targetCountry,
            serviceName: fieldName === 'serviceName' ? newValue : rowData.serviceName,
            competency: fieldName === 'competency' ? newValue : rowData.competency,
            practice: fieldName === 'practice' ? newValue : rowData.practice,
            email: getAccount()?.username,
            FreeTextTags: fieldName === 'freeTextTags' ? newValue : rowData.freeTextTags,
            isEngagementAdmin: userProfileDetails?.isEngagementAdmin,
            EngagementId_GUID: rowData.engagementId_GUID
        };

        try {
            if (rowData.area.toLowerCase() === "americas") {
                dispatch(getPartnerEditEngagementDetailsUS(payload));
            } else if (rowData.area.toLowerCase() === "emeia") {
                dispatch(getPartnerEditEngagementDetailsEU(payload));
            } else if (rowData.area.toLowerCase() === "apac") {
                dispatch(getPartnerEditEngagementDetailsAU(payload));
            }
        } catch (error) {
            logger.error("An error occurred during inline save:", error);
        }
    };

    useEffect(() => {
        if (partnersEditEngagementDetailsData?.status === ApiStatus.SUCCESS) {
            setIsEditModalOpen(false);
            setIsLoading(false);
            const edited = lastEditedEngagementRef.current;
            if (edited?.engagementId_GUID) {
                const payload = {
                    "EmailAddress": getAccount()?.username,
                    "isEngagementAdmin": userProfileDetails?.isEngagementAdmin === null ? '' : userProfileDetails?.isEngagementAdmin,
                    "CallFrom": "utility",
                    "engagementId_GUID": edited.engagementId_GUID
                };
                dispatch(getUtilityData(payload));
                triggerEngagementUpdate(edited.engagementId);
            } else {
                getData(true);
            }
        }

    }, [partnersEditEngagementDetailsData?.status]);
    const initiateProcess = async (processingInfo) => {
        const formJSONData = {
            controlIds: processingInfo.uploadID,
            userEmailID: getAccount()?.username,
            Region: processingInfo.Region,
            BlobFileName: " ",
            TransactionID: " ",
            eng_password: processingInfo.pwdSkipped ? '' : processingInfo.engLevelPwd

        }
        let area = processingInfo.Region;
        let NewBASEURL = '';
        if ((area || "").toLowerCase() === "americas") {
            NewBASEURL = process.env.REACT_APP_API_URL_US;
        } else if ((area || "").toLowerCase() === "emeia") {
            NewBASEURL = process.env.REACT_APP_API_URL_EU
        } else if ((area || "").toLowerCase() === "apac") {
            NewBASEURL = process.env.REACT_APP_API_URL_AU
        }

        try {
            // Make the API call
            if (NewBASEURL === process.env.REACT_APP_API_URL_US) {
                dispatch(partnersUploadProcessingUS(formJSONData));
            } else if (NewBASEURL === process.env.REACT_APP_API_URL_EU) {
                dispatch(partnersUploadProcessingEU(formJSONData));
            } else if (NewBASEURL === process.env.REACT_APP_API_URL_AU) {
                dispatch(partnersUploadProcessingAU(formJSONData));
            }
            // const response = await apiQueryToUploadDataRegional.post(`${NewBASEURL}/api/partners/UploadProcessing`, formJSONData)
            //     .then((data) => {
            //         const process = initiateAutoProcess.current.find(
            //             (p) => p.engID === rowData.engagementId
            //         );

            //         return data;
            //     })
            //     .catch((error) => {

            //     });

        } catch (error) {
            logger.error("Error during UploadProcessing:", error);
        }

    };
    useEffect(() => {
        if (partnersUploadProcessingData?.status === ApiStatus.SUCCESS) {
            const process = initiateAutoProcess.current.find(
                (p) => p.engID === rowData.engagementId
            );

            // return partnersUploadProcessingData?.data;
        }
    }, [partnersUploadProcessingData?.status])
    useEffect(() => {
        if (!isDataUploadTabActive) return;
        const interval = setInterval(() => {
            initiateAutoProcess.current.forEach((proc) => {
                if (
                    proc.uploadID?.length > 0 &&
                    proc.shouldInitiate &&
                    !proc.hasInitiated

                    //  && totalPercent === 100n
                ) {


                    if (isAddFilesOpen === false || isAddFilesOpen === null) {

                        initiateProcess(proc);
                        proc.hasInitiated = true; // mark so it won’t repeat
                    }


                }
            });
        }, 2000); // check every 2s (adjust as needed)

        return () => clearInterval(interval); // cleanup on unmount
    }, [initiateAutoProcess, isDataUploadTabActive]);

    useEffect(() => {
        if (!isDataUploadTabActive) return;
        // Find engagements that reached 100% upload
        const completedEngagements = Object.entries(uploadPercentage)
            .filter(([engagementId, item]) => item.percent === 100)
            .map(([engagementId]) => engagementId);

        if (completedEngagements.length > 0) {
            completedEngagements.forEach(engagementId => {
                triggerEngagementUpdate(engagementId);
            });
        }
    }, [uploadPercentage, isDataUploadTabActive]);

    useEffect(() => {
        if (utilityData?.status === ApiStatus.SUCCESS) {
            if (buttonClicked === "add") {
                const latestData = utilityData?.data;
                // Raw utilitydata rows carry `subIndustry`; the upload payload builders read `subindustry`.
                const matchedItem = normalizeGicsRow(latestData?.find(item => item.engagementId === engagementId));
                onAddFilesClick(matchedItem);
                setButtonClicked("");
            } else if (buttonClicked === "arcDownload") {
                const latestData = utilityData?.data;
                const matchedItem = normalizeGicsRow(latestData?.find(item => item.engagementId === engagementId));
                if (matchedItem) {
                    // Resuming the Actions download icon after capturing metadata: clear this
                    // engagement's prior ARC download-failure records, then start the download.
                    deleteArcErrorLogs([matchedItem.engagementId_GUID]);
                    onDownloadArcFilesClick(matchedItem);
                }
                setButtonClicked("");
            }
        }
    }, [utilityData?.status]);



    // After the page reloads, check for the stored data

    useEffect(() => {
        if (!isDataUploadTabActive) return;
        const cachedData = sessionStorage.getItem("userDataCache"); // Check session storage for cached data
        if (cachedData) {
            // If data exists in session storage, use it
            if (cachedData) {
                setUserData(JSON.parse(cachedData)); // Assuming the data is stored as a JSON string
                userDataRef.current = JSON.parse(cachedData);
            }
        } else {
            dispatch(getApplicationData());
        }
    }, [dispatch, isDataUploadTabActive]);

    useEffect(() => {
        if (getApplicationDetail?.status === ApiStatus.SUCCESS) {
            setUserData(getApplicationDetail?.data);
            userDataRef.current = getApplicationDetail?.data;
            // Store fetched data in session storage for future use
            sessionStorage.setItem(
                "userDataCache", // Key for user data in session storage
                JSON.stringify(getApplicationDetail?.data)
            );
        } else if (getApplicationDetail?.status === ApiStatus.FAILURE) {
            // Handle failure case
            navigation("/");
        }

    }, [getApplicationDetail?.status])

    React.useEffect(() => {
        if ((rowData?.area || "").toLowerCase() === "americas") {
            setBaseURL(process.env.REACT_APP_API_URL_US)
        } else if ((rowData?.area || "").toLowerCase() === "emeia") {
            setBaseURL(process.env.REACT_APP_API_URL_EU)
        } else if ((rowData?.area || "").toLowerCase() === "apac") {
            setBaseURL(process.env.REACT_APP_API_URL_AU)
        }

    }, [rowData?.area])

    const filteredData = Object.values(
        fileData?.filter((item) => {
            // Convert searchValue to lowercase once for efficiency
            const lowerCaseSearchValue = searchValue.toLowerCase();

            // Check if engagementId is not null and not blank
            const engagementIdValid = item?.engagementId && item.engagementId.trim() !== '';

            // Convert searchValue to a number if it's a valid numeric string
            const numericSearchValue = !isNaN(searchValue) ? Number(searchValue) : null;

            // Check if any of the specified fields contain the searchValue
            const searchMatch = (
                (item?.engagementId && item.engagementId.toLowerCase().includes(lowerCaseSearchValue)) ||
                (item?.engagementName && item.engagementName.toLowerCase().includes(lowerCaseSearchValue)) ||
                (item?.clientName && item.clientName.toLowerCase().includes(lowerCaseSearchValue)) ||
                (item?.area && item.area.toLowerCase().includes(lowerCaseSearchValue)) ||
                (item?.region && item.region.toLowerCase().includes(lowerCaseSearchValue)) ||
                (item?.country && item.country.toLowerCase().includes(lowerCaseSearchValue)) ||
                (item?.gicsSector && item.gicsSector.toLowerCase().includes(lowerCaseSearchValue)) ||
                (item?.industryGroup && item.industryGroup.toLowerCase().includes(lowerCaseSearchValue)) ||
                (item?.industry && item.industry.toLowerCase().includes(lowerCaseSearchValue)) ||
                (item?.subindustry && item.subindustry.toLowerCase().includes(lowerCaseSearchValue)) ||
                (item?.revenueRange && item.revenueRange.toLowerCase().includes(lowerCaseSearchValue)) ||
                (item?.transactionType && item.transactionType.toLowerCase().includes(lowerCaseSearchValue)) ||
                (numericSearchValue !== null && item?.noOfUploadedFiles === numericSearchValue) || // Check noOfFiles
                (numericSearchValue !== null && item?.pendingFiles === numericSearchValue) || // Check pendingFiles
                (item?.partnerName && item.partnerName.toLowerCase().includes(lowerCaseSearchValue)) ||
                (item?.targetRegion && item.targetRegion.toLowerCase().includes(lowerCaseSearchValue)) ||
                (item?.targetCountry && item.targetCountry.toLowerCase().includes(lowerCaseSearchValue)) ||
                (item?.serviceName && item.serviceName.toLowerCase().includes(lowerCaseSearchValue)) ||
                (item?.competency && item.competency.toLowerCase().includes(lowerCaseSearchValue)) ||
                (item?.practice && item.practice.toLowerCase().includes(lowerCaseSearchValue)) ||
                (item?.freeTextTags && item.freeTextTags.toLowerCase().includes(lowerCaseSearchValue))
            );

            // Include the item if engagementId is valid and any of the fields match the searchValue
            return engagementIdValid && searchMatch;
        })
    );


    useEffect(() => {
        filteredDataRef.current = filteredData;
    }, [filteredData]);

    // Navigate to the page containing the highlighted row when GUID param matches
    useEffect(() => {
        if (!gridApi || !highlightedGUID || hasNavigatedToHighlightedRow) return;

        // Wait for data to be fully loaded in the grid
        const rowCount = gridApi.getDisplayedRowCount();
        if (rowCount === 0) return;

        // Use setTimeout to ensure AG Grid has fully rendered pagination
        const timeoutId = setTimeout(() => {
            // Find the row index of the highlighted GUID
            let targetRowIndex = -1;
            gridApi.forEachNode((node, index) => {
                if (node.data?.engagementId_GUID === highlightedGUID && targetRowIndex === -1) {
                    targetRowIndex = index;
                }
            });

            if (targetRowIndex === -1) return; // GUID not found in current data

            // Get pagination info from AG Grid Enterprise API
            const pageSize = gridApi.paginationGetPageSize();
            const targetPage = Math.floor(targetRowIndex / pageSize);
            const currentPage = gridApi.paginationGetCurrentPage();

            // Navigate to the target page if different from current page
            if (targetPage !== currentPage) {
                gridApi.paginationGoToPage(targetPage);
            }

            // Ensure the row is visible by scrolling to it after page change
            setTimeout(() => {
                const rowNode = gridApi.getRowNode(String(targetRowIndex));
                if (rowNode) {
                    gridApi.ensureNodeVisible(rowNode, 'middle');
                }
            }, 100);

            setHasNavigatedToHighlightedRow(true);
        }, 200);

        return () => clearTimeout(timeoutId);

    }, [gridApi, highlightedGUID, hasNavigatedToHighlightedRow, fileData]);

    useEffect(() => {
        if (utilityData?.data && utilityData?.status === ApiStatus.SUCCESS) {
            setIsLoading(false);

            // Check if this was triggered by a single-engagement edit refresh
            const isSingleRecordUpdate = lastEditedEngagementRef.current !== null
                || (Array.isArray(utilityData?.data) && utilityData?.data.length === 1 && fileData.length > 1);

            if (isSingleRecordUpdate && fileData.length > 0) {
                // Merge only the returned records in-place to avoid full grid re-render
                const returnedData = Array.isArray(utilityData.data) ? utilityData.data : [];
                returnedData.forEach(updatedRecord => {
                    const existingRow = fileData.find(item => item.engagementId === updatedRecord.engagementId);
                    if (existingRow) {
                        // Keep the current upload-status fields when the refreshed record does not include them
                        const preservedFields = {
                            totalPendingFile: updatedRecord.totalPendingFile ?? existingRow.totalPendingFile,
                            noOfUploadedFiles: updatedRecord.noOfUploadedFiles ?? existingRow.noOfUploadedFiles,
                            engagementTrackingStatus: updatedRecord.engagementTrackingStatus ?? existingRow.engagementTrackingStatus,
                        };
                        Object.assign(existingRow, normalizeGicsRow(updatedRecord), preservedFields);
                        if (gridApi?.applyTransaction) {
                            gridApi.applyTransaction({ update: [existingRow] });
                        }
                    }
                });
                gridApi?.refreshCells?.({ force: true });
                lastEditedEngagementRef.current = null;
            } else {
                // Full data replacement (initial load or full refresh)
                setFileData((utilityData?.data ?? []).map(item => ({ ...normalizeGicsRow(item) })));
                const engagementIdList = utilityData?.data?.filter(item => item.engagementId).map(item => item.engagementId);
                setEngagementIdList(engagementIdList);
                setTimeout(() => gridApi?.refreshCells?.({ force: true }), 0);
            }
        } else if (utilityData?.error) {
            navigation("/");
            setIsLoading(false);
        }
    }, [utilityData, navigation, utilityData?.status]);
    useEffect(() => {
        if (!isDataUploadTabActive) return;
        getData();

    }, [getData, isDataUploadTabActive]);


    // Sync planned outage redux state into local toast state. The prior-outage
    // banner is only relevant BEFORE the outage begins; once the announced
    // start time is reached, hide it (the active-outage flow takes over and
    // redirects the user to the maintenance page).
    useEffect(() => {
        if (outageBannerHideTimeoutRef.current) {
            clearTimeout(outageBannerHideTimeoutRef.current);
            outageBannerHideTimeoutRef.current = null;
        }

        if (plannedOutagePriorData?.status === ApiStatus.SUCCESS) {
            const data = plannedOutagePriorData?.data;
            if (data) {
                setOutageInfo(data);
                const startMs = parseUtcToEpochMs(data?.outageStartsUtc);
                const msUntilStart = Number.isFinite(startMs) ? startMs - Date.now() : NaN;

                if (Number.isFinite(msUntilStart) && msUntilStart <= 0) {
                    setShowOutageToast(false);
                } else if (!outageDismissedRef.current) {
                    setShowOutageToast(true);
                    if (Number.isFinite(msUntilStart)) {
                        outageBannerHideTimeoutRef.current = setTimeout(() => {
                            setShowOutageToast(false);
                        }, msUntilStart);
                    }
                }
            } else {
                setOutageInfo(null);
                setShowOutageToast(false);
            }
        } else if (plannedOutagePriorData?.status === ApiStatus.ERROR) {
            setOutageInfo(null);
            setShowOutageToast(false);
        }

        return () => {
            if (outageBannerHideTimeoutRef.current) {
                clearTimeout(outageBannerHideTimeoutRef.current);
                outageBannerHideTimeoutRef.current = null;
            }
        };
    }, [plannedOutagePriorData]);

    // Handle specific engagement updates when user interacts
    useEffect(() => {
        if (!isDataUploadTabActive) return;
        if (hasInteracted && interactedEngagementId && getAccount()?.username) {
            const payload = {
                "EmailAddress": getAccount()?.username,
                "isEngagementAdmin": userProfileDetails?.isEngagementAdmin === null ? '' : userProfileDetails?.isEngagementAdmin,
                "CallFrom": "utility",
                "engagementId_GUID": interactedEngagementId
            };
            dispatch(getUtilityData(payload));

            // Reset the interaction state after API call
            setInteraction(false);
            setInteractedEngagementId(null);
        }
    }, [interactedEngagementId, isDataUploadTabActive, hasInteracted, userProfileDetails?.isEngagementAdmin, dispatch]);

    const onFilterTextBoxChanged = (value) => {
        setSearchValue(value);
    };

    const onUserFilterTextBoxChanged = (value) => {
        setSearchUser(value);
    };

    const handleEditableEngagementExport = async () => {
        if (isEditableExportLoading) return;
        const allEngagements = fileDataRef.current || fileData || [];
        if (!Array.isArray(allEngagements) || allEngagements.length === 0) {
            setToastMessage("No engagements available to export.");
            setShowToast(true);
            return;
        }
        const selectedEngagements = allEngagements.filter((item) =>
            checkedEngIds.includes(item.engagementId)
        );
        if (selectedEngagements.length === 0) {
            setToastMessage("Select at least one engagement to export.");
            setShowToast(true);
            return;
        }
        setIsEditableExportLoading(true);
        try {
            const exportFile = await createEditableEngagementExportFile({
                engagements: selectedEngagements,
                userData: userDataRef.current || userData || {},
                includeSource: userProfileDetails?.isEngagementAdmin === true,
            });
            downloadBlobFile({
                blob: exportFile.blob,
                fileName: exportFile.fileName,
            });
            setToastMessage(
                exportFile.format === "xlsx"
                    ? `Exported ${exportFile.recordsCount} engagements.`
                    : `Exported ${exportFile.recordsCount} engagements as CSV fallback.`
            );
            setShowToast(true);
        } catch {
            setToastMessage("Unable to export engagements. Please try again.");
            setShowToast(true);
        } finally {
            setIsEditableExportLoading(false);
        }
    };

    const resetImportState = () => {
        setImportValidationResult(null);
        setImportProcessResult(null);
        setImportModalError("");
    };

    const isImportCompleted = Boolean(importProcessResult?.summary);
    const expectedImportColumnLabels = EDITABLE_ENGAGEMENT_EXPORT_COLUMNS.map((column) => column.label);

    const openImportModal = () => {
        resetImportState();
        setImportFile(null);
        setIsImportModalOpen(true);
    };

    const closeImportModal = () => {
        if (isImportValidationLoading || isImportApplying) return;
        setIsImportModalOpen(false);
    };

    const onImportFileChange = (event) => {
        const selectedFile = event?.target?.files?.[0] || null;
        setImportFile(selectedFile);
        resetImportState();
    };

    const IMPORT_VALIDATION_LOG_CHUNK_SIZE = 200;

    const buildImportUpdatePayload = (existingRow, importRow, userEmail) => ({
        engagementID: existingRow.engagementId,
        engagementId_GUID: existingRow.engagementId_GUID,
        email: userEmail,
        revenueRange: importRow.revenueRange,
        freeTextTags: importRow.freeTextTags || "",
        isEngagementAdmin: userProfileDetails?.isEngagementAdmin,
        ccs: existingRow.ccs || "",
        ...toGicsEditPayload(
            resolveGicsSelection(userDataRef.current?.gicsSectorMappings, {
                gicsSector: importRow.gicsSector,
                industryGroup: importRow.industryGroup,
                industry: importRow.industry,
                subindustry: importRow.subindustry,
            })
        ),
        ssl: existingRow.ssl || "",
        targetArea: existingRow.targetArea || existingRow.area || "",
        targetRegion: importRow.targetRegion,
        targetCountry: importRow.targetCountry,
        serviceName: existingRow.serviceName || "",
        competency: existingRow.competency || "",
        practice: existingRow.practice || "",
    });

    const formatImportEndpoint = (endpointTemplate, importBatchId) =>
        String(endpointTemplate || "").replace("{importBatchId}", String(importBatchId));

    const getImportApiErrorMessage = (error, fallbackMessage) =>
        error?.response?.data?.message ||
        (typeof error?.response?.data === "string" ? error?.response?.data : "") ||
        error?.message ||
        fallbackMessage;

    const resolveImportBatchCompletionStatus = ({
        importedRows = 0,
        failedRows = 0,
    }) => {
        if (importedRows > 0 && failedRows > 0) return "PARTIAL_SUCCESS";
        if (importedRows > 0 && failedRows === 0) return "COMPLETED";
        if (importedRows === 0 && failedRows > 0) return "FAILED";
        return "COMPLETED";
    };

    const normalizeEngagementIdToken = (value) =>
        String(value || "").trim().toLowerCase();

    const mapValidationFieldName = (errorMessage = "") => {
        const message = String(errorMessage || "").toLowerCase();
        if (message.includes("engagement id")) return "EngagementId";
        if (message.includes("target country")) return "TargetCountry";
        if (message.includes("target region")) return "TargetRegion";
        if (message.includes("competency")) return "Competency";
        if (message.includes("practice")) return "Practice";
        // Prefix checks: mapping messages mention the parent level too (e.g. "Industry does not match Industry Group mapping").
        if (message.startsWith("sub industry")) return "SubIndustry";
        if (message.startsWith("industry group")) return "IndustryGroup";
        if (message.startsWith("industry")) return "Industry";
        if (message.startsWith("sector")) return "Sector";
        if (message.includes("revenue")) return "RevenueRange";
        if (message.includes("additional tags") || message.includes("tags")) return "FreeTextTags";
        return null;
    };

    const mapValidationErrorCode = (errorMessage = "") => {
        const message = String(errorMessage || "").toLowerCase();
        if (message.includes("engagement id is required")) return "ENGAGEMENT_ID_REQUIRED";
        if (message.includes("was not found")) return "ENGAGEMENT_ID_NOT_FOUND";
        if (message.includes("is required")) return "REQUIRED_FIELD_MISSING";
        if (message.includes("not valid")) return "INVALID_LOOKUP_VALUE";
        if (message.includes("target country does not match")) return "TARGET_COUNTRY_REGION_MISMATCH";
        if (message.includes("practice does not match")) return "PRACTICE_COMPETENCY_MISMATCH";
        if (message.includes("sub industry does not match")) return "SUBINDUSTRY_INDUSTRY_MISMATCH";
        if (message.includes("industry group does not match")) return "INDUSTRYGROUP_SECTOR_MISMATCH";
        if (message.includes("industry does not match")) return "INDUSTRY_INDUSTRYGROUP_MISMATCH";
        if (message.includes("at most 15 tags")) return "TAGS_MAX_15";
        if (message.includes("duplicate")) return "TAGS_DUPLICATE";
        return "VALIDATION_ERROR";
    };

    const buildValidationLogsFromFailedRows = (
        failedRows = [],
        importBatchId,
        engagementGuidByIdMap = new Map()
    ) =>
        (failedRows || []).flatMap((item) =>
            (item?.errors || []).map((errorMessage) => {
                const engagementIdKey = normalizeEngagementIdToken(item?.engagementId);
                const matchedGuid =
                    (engagementIdKey && engagementGuidByIdMap.get(engagementIdKey)) || null;
                return {
                    importBatchId,
                    rowNumber: item?.rowNumber || null,
                    engagementId_GUID: matchedGuid,
                    fieldName: mapValidationFieldName(errorMessage),
                    errorCode: mapValidationErrorCode(errorMessage),
                    errorMessage,
                };
            })
        );

    const saveImportValidationLogs = async (importBatchId, validations, requestedByEmail) => {
        if (!importBatchId || !Array.isArray(validations) || validations.length === 0) return;
        const endpoint = formatImportEndpoint(ENDPOINT.PARTNERS_IMPORT_BATCH_LOGS, importBatchId);
        const inflightRequests = [];
        for (let index = 0; index < validations.length; index += IMPORT_VALIDATION_LOG_CHUNK_SIZE) {
            const chunk = validations.slice(index, index + IMPORT_VALIDATION_LOG_CHUNK_SIZE);
            inflightRequests.push(apiQueryWithToken.post(endpoint, {
                requestedByEmail,
                validations: chunk,
            }));
            if (inflightRequests.length >= 3) {
                await Promise.all(inflightRequests);
                inflightRequests.length = 0;
            }
        }
        if (inflightRequests.length > 0) {
            await Promise.all(inflightRequests);
        }
    };

    const handleValidateImportFile = async () => {
        if (!importFile) {
            setImportModalError("Please select an export file to import.");
            return null;
        }
        setIsImportValidationLoading(true);
        setImportModalError("");
        setImportProcessResult(null);

        try {
            const parsedImport = await parseEditableEngagementImportFile(importFile);
            const validationResult = validateEditableEngagementImportRows({
                rows: parsedImport.rows,
                headers: parsedImport.headers,
                fileData: fileDataRef.current || fileData || [],
                userData: userDataRef.current || userData || {},
            });
            setImportValidationResult(validationResult);
            if (validationResult.missingColumns?.length > 0) {
                setImportModalError(
                    `Invalid import file format. Expected columns: ${expectedImportColumnLabels.join(", ")}.`
                );
            } else if (validationResult.summary.errorRecords > 0) {
                setImportModalError(
                    `Validation completed with ${validationResult.summary.errorRecords} error row(s).`
                );
            } else {
                setImportModalError("");
            }
            return validationResult;
        } catch (error) {
            setImportValidationResult(null);
            setImportModalError(error?.message || "Unable to read import file.");
            return null;
        } finally {
            setIsImportValidationLoading(false);
        }
    };

    const handleImportSummaryDownload = () => {
        const result = importProcessResult;
        if (!result || !Array.isArray(result.logs) || result.logs.length === 0) return;
        const csvRows = [
            ["Status", "Row Number", "Engagement ID", "Details"].join(","),
            ...result.logs.map((item) =>
                [
                    item.status,
                    item.rowNumber,
                    `"${String(item.engagementId || "").replace(/"/g, '""')}"`,
                    `"${String(item.message || "").replace(/"/g, '""')}"`,
                ].join(",")
            ),
        ];
        const summaryBlob = new Blob([csvRows.join("\r\n")], {
            type: "text/csv;charset=utf-8;",
        });
        const timestamp = new Date().toISOString().replace(/[:.]/g, "-");
        downloadBlobFile({
            blob: summaryBlob,
            fileName: `engagement_import_summary_${timestamp}.csv`,
        });
    };

    const handleApplyImportFile = async () => {
        let validationResult = importValidationResult;
        if (!validationResult) {
            validationResult = await handleValidateImportFile();
        }
        if (!validationResult) return;
        if (validationResult.missingColumns?.length > 0) return;

        const validRows = validationResult.validRows || [];
        const loggedInUserEmail = String(getAccount()?.username || "").trim();

        const validationFailedRows = (validationResult.failedRows || []).map((item) => ({
            status: "Validation Error",
            rowNumber: item.rowNumber,
            engagementId: item.engagementId,
            message: (item.errors || []).join(" | "),
        }));

        setImportProcessResult({
            summary: {
                totalRows: Number(validationResult?.summary?.totalRecords || 0),
                importedRows: 0,
                failedRows: validationFailedRows.length,
            },
            logs: [...validationFailedRows],
        });

        setIsImportApplying(true);
        let importBatchId = null;
        let importedRows = 0;
        let failedRows = validationFailedRows.length;
        const totalRows = Number(validationResult?.summary?.totalRecords || 0);
        const validRowsCount = Number(validationResult?.summary?.validRecords || validRows.length || 0);
        const importLogs = [...validationFailedRows];
        let importErrorMessage = "";
        let batchFinalStatus = "VALIDATING";
        try {
            const startBatchResponse = await apiQueryWithToken.post(ENDPOINT.PARTNERS_IMPORT_BATCH_START, {
                sourceFileName: importFile?.name || "engagement_import.xlsx",
                importedByEmail: loggedInUserEmail,
                totalRows,
            });
            importBatchId = startBatchResponse?.data?.importBatchId || null;

            if (importBatchId) {
                const engagementGuidByIdMap = new Map(
                    (fileDataRef.current || fileData || [])
                        .map((row) => [normalizeEngagementIdToken(row?.engagementId), row?.engagementId_GUID])
                        .filter((entry) => entry[0])
                );
                const validationLogs = buildValidationLogsFromFailedRows(
                    validationResult?.failedRows || [],
                    importBatchId,
                    engagementGuidByIdMap
                );
                await saveImportValidationLogs(importBatchId, validationLogs, loggedInUserEmail);
            }

            const preBulkFailures = [];
            const bulkUpdateGroupsByArea = {};

            validRows.forEach((item) => {
                const payload = buildImportUpdatePayload(item?.existingRow || {}, item?.row || {}, loggedInUserEmail);
                if (!String(payload?.engagementId_GUID || "").trim()) {
                    preBulkFailures.push({
                        status: "Validation Error",
                        rowNumber: item?.rowNumber,
                        engagementId: item?.engagementId,
                        engagementId_GUID: item?.existingRow?.engagementId_GUID || null,
                        message: "engagementId_GUID is required.",
                    });
                    return;
                }
                const areaName = item?.existingRow?.area || "";
                const areaBaseUrl = resolveBaseURLByArea(areaName);
                if (!areaBaseUrl) {
                    preBulkFailures.push({
                        status: "Validation Error",
                        rowNumber: item?.rowNumber,
                        engagementId: item?.engagementId,
                        engagementId_GUID: item?.existingRow?.engagementId_GUID || null,
                        message: `Unable to resolve regional API for area "${areaName || "Unknown"}".`,
                    });
                    return;
                }
                const groupKey = `${String(areaName || "").toLowerCase()}|${areaBaseUrl}`;
                if (!bulkUpdateGroupsByArea[groupKey]) {
                    bulkUpdateGroupsByArea[groupKey] = {
                        areaName,
                        areaBaseUrl,
                        payloads: [],
                        metaRows: [],
                    };
                }
                bulkUpdateGroupsByArea[groupKey].payloads.push(payload);
                bulkUpdateGroupsByArea[groupKey].metaRows.push(item);
            });

            if (preBulkFailures.length > 0) {
                importLogs.push(...preBulkFailures);
                failedRows += preBulkFailures.length;
            }

            if (importBatchId && preBulkFailures.length > 0) {
                await saveImportValidationLogs(
                    importBatchId,
                    preBulkFailures.map((item) => ({
                        importBatchId,
                        rowNumber: item?.rowNumber || null,
                        engagementId_GUID: item?.engagementId_GUID || null,
                        fieldName: "EngagementId_GUID",
                        errorCode: "ENGAGEMENT_GUID_REQUIRED",
                        errorMessage: item?.message,
                    })),
                    loggedInUserEmail
                );
            }

            const bulkUpdateGroups = Object.values(bulkUpdateGroupsByArea);
            if (bulkUpdateGroups.length > 0) {
                const bulkGroupResults = await Promise.all(
                    bulkUpdateGroups.map(async (group) => {
                        let groupImportedRows = 0;
                        let groupFailedRows = 0;
                        const groupLogs = [];
                        try {
                            const bulkEndpoint = ENDPOINT.PARTNERS_EDIT_ENGAGEMENT_DETAILS_BULK_REGIONAL.replace(
                                "baseUrl",
                                group.areaBaseUrl
                            );
                            const bulkUpdateResponse = await apiQueryToUploadDataRegional.post(
                                bulkEndpoint,
                                group.payloads
                            );
                            const bulkResults = Array.isArray(bulkUpdateResponse?.data?.results)
                                ? bulkUpdateResponse.data.results
                                : [];
                            const handledIndexes = new Set();
                            const fallbackStatus = String(bulkUpdateResponse?.data?.status || "").toUpperCase();
                            const fallbackFailedRows = Number(bulkUpdateResponse?.data?.failedRows || 0);

                            bulkResults.forEach((resultItem) => {
                                const resultGuid = normalizeGuid(resultItem?.engagementId_GUID);
                                let matchedIndex = group.metaRows.findIndex(
                                    (row) => normalizeGuid(row?.existingRow?.engagementId_GUID) === resultGuid
                                );
                                if (matchedIndex < 0) {
                                    const resultRowNumber = Number(resultItem?.rowNumber);
                                    matchedIndex =
                                        Number.isFinite(resultRowNumber) && resultRowNumber > 0
                                            ? resultRowNumber - 1
                                            : -1;
                                }
                                if (matchedIndex < 0 || !group.metaRows[matchedIndex]) return;
                                if (handledIndexes.has(matchedIndex)) return;

                                handledIndexes.add(matchedIndex);
                                const sourceRow = group.metaRows[matchedIndex];
                                const rowMessage = resultItem?.message || "Bulk update completed.";
                                if (resultItem?.isSuccess) {
                                    groupImportedRows += 1;
                                    groupLogs.push({
                                        status: "Imported",
                                        rowNumber: sourceRow?.rowNumber,
                                        engagementId: sourceRow?.engagementId,
                                        message: rowMessage,
                                    });
                                } else {
                                    groupFailedRows += 1;
                                    groupLogs.push({
                                        status: "Import Error",
                                        rowNumber: sourceRow?.rowNumber,
                                        engagementId: sourceRow?.engagementId,
                                        message: rowMessage,
                                    });
                                }
                            });

                            group.metaRows.forEach((row, index) => {
                                if (handledIndexes.has(index)) return;
                                const shouldTreatAsSuccess =
                                    fallbackStatus === "COMPLETED" && fallbackFailedRows === 0;
                                if (shouldTreatAsSuccess) {
                                    groupImportedRows += 1;
                                    groupLogs.push({
                                        status: "Imported",
                                        rowNumber: row?.rowNumber,
                                        engagementId: row?.engagementId,
                                        message: "Imported successfully.",
                                    });
                                } else {
                                    groupFailedRows += 1;
                                    groupLogs.push({
                                        status: "Import Error",
                                        rowNumber: row?.rowNumber,
                                        engagementId: row?.engagementId,
                                        message: "No row result returned by bulk update API.",
                                    });
                                }
                            });
                        } catch (bulkError) {
                            const bulkErrorMessage = getImportApiErrorMessage(
                                bulkError,
                                `Failed to update engagements using bulk API for area "${group.areaName || "Unknown"}".`
                            );
                            group.metaRows.forEach((row) => {
                                groupFailedRows += 1;
                                groupLogs.push({
                                    status: "Import Error",
                                    rowNumber: row?.rowNumber,
                                    engagementId: row?.engagementId,
                                    message: bulkErrorMessage,
                                });
                            });
                        }
                        return {
                            importedRows: groupImportedRows,
                            failedRows: groupFailedRows,
                            logs: groupLogs,
                        };
                    })
                );

                bulkGroupResults.forEach((groupResult) => {
                    importedRows += Number(groupResult?.importedRows || 0);
                    failedRows += Number(groupResult?.failedRows || 0);
                    if (Array.isArray(groupResult?.logs) && groupResult.logs.length > 0) {
                        importLogs.push(...groupResult.logs);
                    }
                });
            }

            batchFinalStatus = resolveImportBatchCompletionStatus({
                importedRows,
                failedRows,
            });

            try {
                sessionStorage.setItem(
                    "engagementImportAuditTrail",
                    JSON.stringify({
                        importBatchId,
                        status: batchFinalStatus,
                        importedAt: new Date().toISOString(),
                        importedBy: loggedInUserEmail,
                        fileName: importFile?.name || "",
                        summary: {
                            totalRows,
                            importedRows,
                            failedRows,
                        },
                        logs: importLogs,
                    })
                );
            } catch { }
        } catch (error) {
            importErrorMessage = getImportApiErrorMessage(error, "Unable to complete import.");
            batchFinalStatus = "FAILED";
            if (failedRows === 0 && importedRows === 0) {
                importLogs.push({
                    status: "Import Error",
                    rowNumber: "",
                    engagementId: "",
                    message: importErrorMessage,
                });
                failedRows = 1;
            }
        } finally {
            if (importBatchId) {
                try {
                    await apiQueryWithToken.post(
                        formatImportEndpoint(ENDPOINT.PARTNERS_IMPORT_BATCH_COMPLETE, importBatchId),
                        {
                            requestedByEmail: loggedInUserEmail,
                            status: batchFinalStatus,
                            totalRows,
                            validRows: validRowsCount,
                            importedRows,
                            failedRows,
                            missingColumnsJson: JSON.stringify(validationResult?.missingColumns || []),
                        }
                    );
                } catch (completeError) {
                    logger.error("Failed to complete import batch:", completeError);
                }
            }

            const processResult = {
                summary: {
                    totalRows,
                    importedRows,
                    failedRows,
                },
                logs: importLogs,
            };
            setImportProcessResult(processResult);

            if (importedRows > 0) {
                setToastMessage(
                    failedRows > 0
                        ? `Imported ${importedRows} row(s). ${failedRows} row(s) failed.`
                        : `Imported ${importedRows} row(s) successfully.`
                );
                setShowToast(true);
                getData(true);
            }

            if (importErrorMessage) {
                setImportModalError(importErrorMessage);
            } else if (failedRows > 0) {
                setImportModalError(`${failedRows} row(s) failed. Download summary for details.`);
            } else {
                setImportModalError("");
            }

            setIsImportApplying(false);
        }
    };

    const getEngagementData = useCallback((engagementId_GUID, region, showLoader, engagementId) => {
        setIsLoading(showLoader);
        try {
            const payload = { engagementId_GUID, engagementId, region, email: getAccount()?.username, isEngagementAdmin: userProfileDetails?.isEngagementAdmin };
            if (getAccount()?.username) {
                dispatch(getFilesEngagementData(payload));
            }
        } catch (error) {
            if (error.response && error.response.status === 401) {
                navigation("/");
            } else {
                logger.error("An error occurred:", error);
                setIsLoading(false);
            }
        }
    }, [dispatch, navigation]);

    useEffect(() => {
        if (filesEngagementData?.status === ApiStatus.SUCCESS) {
            setEngagementData(filesEngagementData?.data);
            onOpenMenu(filesEngagementData?.data);
            setIsLoading(false);
        }
    }, [filesEngagementData?.data, filesEngagementData?.status]);

    useEffect(() => {
        setMenuOpen(false);
    }, []);

    const getPendingFilesData = (engagementId, region, openPendingFiles, showLoader) => {
        setIsLoading(showLoader);
        apiQueryWithToken
            .post(`api/partners/pendingfiles`, {
                engagementId, email: getAccount()?.username
            })
            .then((data) => {

                setPendingFilesData(data.data);
                setIsLoading(false);
                // Pass the response data to the view file component
                if (openPendingFiles) {
                    setPendingFileOpen(true);
                }
            })
            .catch((error) => {
                if (error.response && error.response.status === 401) {
                    navigation("/");
                } else {
                    logger.error("An error occurred:", error);
                    setIsLoading(false);
                }
            });
    };

    // Function to handle the click event for the "View Files" button
    const onViewFilesClick = (rowData) => {
        // Call onOpenMenu with the list of items you want to display
        if (rowData.country === UNITED_KINGDOM) {

            getEngagementData(rowData.engagementId_GUID, 'EMEIA', true, rowData.engagementId);

        } else
            getEngagementData(rowData.engagementId_GUID, rowData.area, true, rowData.engagementId);

        setRowData(rowData);
        //onOpenMenu([1, 2, 3, 4]);
    };
    const onPendingFilesClick = (rowData) => {
        setRowData(rowData);
        // Reset interaction state
        setInteraction(false);
        setInteractedEngagementId(null);
        getPendingFilesData(rowData.engagementId, rowData.area, true, true);


        //onOpenMenu([1, 2, 3, 4]);
    };

    const onAddFilesClick = (rowData) => {
        // Call onOpenMenu with the list of items you want to display
        // getEngagementData(rowData.engagementId);
        setFailedUploads(prev =>
            prev.map(item => ({
                ...item,
                currentFlow: false
            }))
        );
        setOpenFailedUploadBadge(false);
        setRowData(rowData);
        // Reset interaction state
        setInteraction(false);
        setInteractedEngagementId(null);
        onAddFilesOpen();

        //onOpenMenu([1, 2, 3, 4]);
    };


    const onFailedUploadClick = (rowData) => {
        setFailedUploads(prev =>
            prev.map(item => ({
                ...item,
                currentFlow: false
            }))
        );
        setRowData(rowData);
        setInteraction(false);
        // ARC failures use only the dedicated read-only "Failed Downloads" panel
        // (FailedFilesUpload). Do not also open the Add Files / FailedUploadsList
        // (previous) UX, which onFaileUploadOpen() would trigger via setAddFilesOpen(true).
        if (String(rowData?.dataSource || "").toUpperCase() === "ARC") {
            setFailedUploadOpen(true);
            setOpenFailedUploadBadge(true);
        } else {
            onFaileUploadOpen();
        }

    }

    const navigate = useNavigate();
    // Function to handle the click event for the "Add More Files" button
    const onAddMoreFilesClick = (rowData) => {
        navigate('/uploadFileData', { state: { ...rowData } });
    };

    const handleRemoveFile = ({ controlId, area, engagementId, isPending }) => {
        // setIsViewLoading(true);
        // setIsPendingFilesLoading(true);
        setBaseURLByArea(area);
        setIsDeletePendingFiles(isPending);

        const anonymizedFileCount = Array.isArray(engagementData) ? engagementData.reduce((cnt, it) => cnt + (it.isAnonymized ? 1 : 0), 0) : 0;
        const engagement_Data = fileData.find(file => file.engagementId === engagementId);
        const TotalUploadedFiles = engagement_Data ? engagement_Data.noOfUploadedFiles : 0;
        const engagementId_Guid = engagement_Data?.engagementId_GUID  || "";
        const ids = String(controlId || '')
            .split(',')
            .map(s => s.trim())
            .filter(Boolean); // remove empty parts
        const totalIds = ids.length; // total count (including duplicates)
        const uniqueIdsCount = new Set(ids).size; // unique id count of files to be deleted

        let uploadStatus = "";
        let isUploadStatusUpdated = false;

        if (anonymizedFileCount === 0 && (uniqueIdsCount === TotalUploadedFiles)) {
            uploadStatus = "No files";
            isUploadStatusUpdated = true;
        }
        else if ((TotalUploadedFiles - uniqueIdsCount === anonymizedFileCount) && anonymizedFileCount > 0) {
            uploadStatus = "Submitted";
            isUploadStatusUpdated = true;
        }


        try {
            const payload = {
                "controlId": controlId,
                "isPending": isPending,
                "region": area,
                "email": getAccount()?.username,
                "uploadStatus": uploadStatus,
                "isUploadStatusUpdated": isUploadStatusUpdated,
                "engagementId": engagementId,
                "engagementId_Guid": engagementId_Guid
            }
            if (baseURL === process.env.REACT_APP_API_URL_US) {
                dispatch(getPartnersFilesDeleteUS(payload))
            } else if (baseURL === process.env.REACT_APP_API_URL_EU) {
                dispatch(getPartnersFilesDeleteEU(payload))
            } else if (baseURL === process.env.REACT_APP_API_URL_AU) {
                dispatch(getPartnersFilesDeleteAU(payload))
            }
        } catch (error) {
            // setIsViewLoading(false);
            // setIsPendingFilesLoading(false);
            // setToastMessage('Something went wrong. Please try again');
            setShowToast(true);
            onCloseMenu();
        }
    };



    useEffect(() => {
        if (partnersFilesDeleteData?.status === ApiStatus.SUCCESS) {
            // 
            if (!isDeletePendingFiles) {
                getEngagementData(rowData.engagementId_GUID, rowData.area, false, rowData.engagementId);
            } else {
                getPendingFilesData(rowData.engagementId, rowData.area, false, false);
            }
            triggerEngagementUpdate(rowData.engagementId, { force: true });
            setIsViewLoading(false);
            setIsPendingFilesLoading(false);
        }
        if (partnersFilesDeleteData?.status === ApiStatus.ERROR) {
            setIsViewLoading(false);
            setIsPendingFilesLoading(false);
            setAlertMessage("Something went wrong, Please try again.");
            setOpenAlertDialog(true);
            triggerEngagementUpdate(rowData.engagementId);
            // onCloseMenu();
        }
    }, [partnersFilesDeleteData?.status]);

    const handleViewFilecontent = ({ controlId, fileName }) => {
        setBaseURLByArea(rowData.area);
        setFileViewerOpen(true);
        setFileName(fileName);
        setIsViewLoading(true);
        const payload = { controlId: String(controlId) };
        try {
            if (baseURL === process.env.REACT_APP_API_URL_US) {
                dispatch(getPartnersViewFilesContentUS(payload));
            } else if (baseURL === process.env.REACT_APP_API_URL_EU) {
                dispatch(getPartnersViewFilesContentEU(payload));
            } else if (baseURL === process.env.REACT_APP_API_URL_AU) {
                dispatch(getPartnersViewFilesContentAU(payload));
            }
        } catch (error) {
            logger.error("API error:", error);
        }
    };

    const handleAlertDialogClose = () => {
        setOpenAlertDialog(false);
        setAlertMessage("");
    }
    const handleConvertClientDialogClose = () => {
        setOpenConvertClientDialog(false);
        setToggleChecked(!toggleChecked);
    }
    const handleConvertClientDialogConfirm = async () => {
        setIsLoading(true);
        setOpenConvertClientDialog(false);
        setToggleChecked(!toggleChecked);

        // Filter engagementId_GUIDs from utilityData using checkedEngIds array
        const selectedEngagementGuids = (utilityData?.data ?? [])
            .filter(item => checkedEngIds.includes(item.engagementId))
            .map(item => item.engagementId_GUID);

        if (selectedEngagementGuids.length > 0) {
            const selectedRows = (utilityData?.data ?? []).filter(item =>
                selectedEngagementGuids.includes(item.engagementId_GUID)
            );

            // Group engagements by area
            const areaGroups = selectedRows.reduce((acc, row) => {
                const area = (row.area || "").toLowerCase();
                if (!acc[area]) {
                    acc[area] = [];
                }
                acc[area].push(row.engagementId_GUID);
                return acc;
            }, {});

            try {
                // Make API calls for each area
                const responses = await Promise.all(
                    Object.entries(areaGroups).map(async ([area, guids]) => {
                        let NewBASEURL = '';
                        if (area === "americas") {
                            NewBASEURL = process.env.REACT_APP_API_URL_US;
                        } else if (area === "emeia") {
                            NewBASEURL = process.env.REACT_APP_API_URL_EU;
                        } else if (area === "apac") {
                            NewBASEURL = process.env.REACT_APP_API_URL_AU;
                        }

                        return await apiQueryToUploadDataRegional.post(
                            `${NewBASEURL}/api/partners/EnableDisableClientData`,
                            {
                                engagementId_GUIDs: String(guids.join(',')),
                                isClientDataEnabled: toggleChecked
                            }
                        );
                    })
                );

                // Check if all responses are successful (response.data === true)
                const allSuccessful = responses.every(response => response.data.isSuccess === true);

                // Check if at least one response is successful
                const partialSuccessful = responses.some(response => response.data.isSuccess === true) && !allSuccessful;

                // Collect all missingEngagementId_GUIDs from responses
                const allMissingIds = responses
                    .filter(response => response.data && response.data.missingEngagementId_GUIDs)
                    .map(response => {
                        const missingGuids = response.data.missingEngagementId_GUIDs.split(',').map(guid => guid.trim());
                        return missingGuids
                            .map(guid => {
                                const matchingItem = (utilityData?.data ?? []).find(item => item.engagementId_GUID === guid);
                                return matchingItem ? matchingItem.engagementId : null;
                            })
                            .filter(Boolean);
                    })
                    .flat()
                    .join(', ');

                setIsLoading(false);
                setIsConvertToastVisible(true);
                setIsConvertClientSuccessful(allSuccessful);
                setIsConvertClientPartialSuccessful(partialSuccessful);
                setClientConversionMissingIds(allMissingIds);

                if (allSuccessful || partialSuccessful) {
                    setCheckedEngIds([]);
                    getData(true);
                }

                setTimeout(() => {
                    setIsConvertToastVisible(false);
                    setIsConvertClientSuccessful(false);
                    setIsConvertClientPartialSuccessful(false);
                    setClientConversionMissingIds('');
                }, 5000);

            } catch (error) {
                logger.error("Error occurred while converting to client engagement:", error);
                setIsLoading(false);
                setIsConvertToastVisible(true);
                setIsConvertClientSuccessful(false);
                setIsConvertClientPartialSuccessful(false);
                setClientConversionMissingIds('');
                setTimeout(() => {
                    setIsConvertToastVisible(false);
                }, 5000);
            }
        }
    };

    const handleDownloadFileContent = ({ controlId, fileName }) => {
        setBaseURLByArea(rowData.area);
        setFileName(fileName);
        setIsViewLoading(true);
        const payload = { controlId: String(controlId), fileName: String(fileName), isDownload: true };
        try {
            if (baseURL === process.env.REACT_APP_API_URL_US) {
                dispatch(getPartnersFilesDownloadUS(payload));
            } else if (baseURL === process.env.REACT_APP_API_URL_EU) {
                dispatch(getPartnersFilesDownloadEU(payload));
            } else if (baseURL === process.env.REACT_APP_API_URL_AU) {
                dispatch(getPartnersFilesDownloadAU(payload));
            }
        } catch (error) {
            logger.error("API error:", error);
            setIsViewLoading(false);
            setAlertMessage("Something went wrong while downloading the file.");
            setOpenAlertDialog(true);
        }
    };

    const resetPartnersFilesDownloadResponse = () => {
        dispatch(resetPartnersFilesDownload());
    };

    useEffect(() => {
        return () => {
            resetPartnersFilesDownloadResponse();
        };
    }, []);

    useEffect(() => {
        if (partnersDownloadFilesContentData?.status === ApiStatus.SUCCESS) {
            const encryptedSasUri = partnersDownloadFilesContentData?.data?.encryptedSasUri;

            if (encryptedSasUri) {
                const decryptedSasUri = decryptSasUri(encryptedSasUri);
                if (!decryptedSasUri) {
                    setIsViewLoading(false);
                    setAlertMessage("Unable to decrypt the file URL.");
                    setOpenAlertDialog(true);
                    return;
                }
                fetch(decryptedSasUri)
                    .then(res => res.blob())
                    .then(blob => {
                        const url = window.URL.createObjectURL(blob);
                        const link = document.createElement('a');
                        link.href = url;
                        link.download = fileName;
                        document.body.appendChild(link);
                        link.click();
                        document.body.removeChild(link);
                        window.URL.revokeObjectURL(url);
                        setIsViewLoading(false);
                    })
                    .catch((err) => {
                        setIsViewLoading(false);
                        setAlertMessage("Something went wrong while downloading the file.");
                        setOpenAlertDialog(true);
                    });
            }
            else {
                setIsViewLoading(false);
                setAlertMessage("The file you are trying to download does not exist.");
                setOpenAlertDialog(true);
            }
        }
        else if (partnersDownloadFilesContentData?.status === ApiStatus.ERROR) {
            setIsViewLoading(false);
            setAlertMessage("Something went wrong while downloading the file.");
            setOpenAlertDialog(true);
        }
    }, [partnersDownloadFilesContentData?.status]);

    useEffect(() => {
        if (partnersViewFilesContentData?.status === ApiStatus.SUCCESS) {
            const cipherText = partnersViewFilesContentData?.data?.encryptedSasUri;
            setTempFileName(partnersViewFilesContentData?.data?.fileName);

            const decryptedText = decryptSasUri(cipherText);
            if (!decryptedText) {
                setIsViewLoading(false);
                setAlertMessage("Unable to decrypt the file URL.");
                setOpenAlertDialog(true);
                return;
            }
            setDecryptedFileUrl(decryptedText);
            setIsViewLoading(false);
        }
        if (partnersViewFilesContentData?.status === ApiStatus.ERROR) {
            setIsViewLoading(false);
            setFileViewerOpen(false);
            setIsPendingFilesLoading(false);
            setAlertMessage("Something went wrong, Please try again.");
            setOpenAlertDialog(true);
        }
    }, [partnersViewFilesContentData?.status]);

    // const uploadFailedFolders = () =>{

    // }

    const deleteTempFiles = () => {
        setBaseURLByArea(rowData.area);
        if (baseURL === process.env.REACT_APP_API_URL_US) {
            dispatch(
                PartnersDeleteTempFilesOnPopupCloseUS({ fileName: TempFileName })
            );
        } else if (baseURL === process.env.REACT_APP_API_URL_EU) {
            dispatch(
                PartnersDeleteTempFilesOnPopupCloseEU({ fileName: TempFileName })
            );
        } else if (baseURL === process.env.REACT_APP_API_URL_AU) {
            dispatch(
                PartnersDeleteTempFilesOnPopupCloseAU({ fileName: TempFileName })
            );
        }
    };
    useEffect(() => {
        if (
            partnersDeleteTempFilesOnPopupCloseData?.status === ApiStatus.SUCCESS
        ) {
            logger.info("success");
        } else if (partnersDeleteTempFilesOnPopupCloseData?.status === ApiStatus.ERROR) {
            logger.error(
                "API error:",
                partnersDeleteTempFilesOnPopupCloseData?.error
            );
        }
    }, [partnersDeleteTempFilesOnPopupCloseData?.status]);




    const handleCloseToast = () => {
        setShowToast(false);
    };
    const setOpenDialog = () => {
        setDeleteDialogOpen(true);
    };

    const CustomCellRenderer = ({ value }) => {
        const cellStyle = {
            fontWeight: 'bold',
            // whiteSpace: 'nowrap',
            overflow: 'hidden',
            textOverflow: 'ellipsis',
            // maxWidth: '100%', // Ensure the content does not exceed the cell width
        };
        return (
            <div title={value} style={cellStyle}>
                {value}
            </div>
        );
    };
    const CustomCellRendererTooltip = (params) => {
        const { value, data, colDef, node } = params;
        // Create a unique identifier for this cell (e.g., by combining column and row)
        const uniqueId = `${colDef.field}-${data?.engagementId || data?.id || ''}`;

        const isDropdownEditable = (() => {
            if (!data || node?.group) return false;
            const editor = colDef?.cellEditor;
            if (editor !== 'agSelectCellEditor') return false;
            const editableProp = colDef?.editable;
            if (typeof editableProp === 'function') return !!editableProp(params);
            return !!editableProp;
        })();

        const handleCopy = () => {
            if (navigator && navigator.clipboard) {
                navigator.clipboard.writeText(value);
                setCopied(true);
                setCopiedValue(uniqueId);
                setTimeout(() => setCopied(false), 1000); // Reset after 1s
            }
        };
        const cellStyle = {
            overflow: "hidden",
            textOverflow: "ellipsis",
            whiteSpace: "nowrap",
            maxWidth: isDropdownEditable ? 'calc(100% - 18px)' : '100%',
            display: "inline-block",
            backgroundColor: copied && copiedValue === uniqueId ? "#1976d2" : "transparent",
            color: copied && copiedValue === uniqueId ? "#fff" : undefined,
            transition: "background 0.2s",
            cursor: "pointer"
        };

        return (
            <div
                onClick={handleCopy}
                className={isDropdownEditable ? 'ag-cell-with-dropdown' : ''}
                title={value ?? ''}
                style={{ width: '100%', overflow: 'hidden' }}
            >
                <span
                    style={cellStyle}
                >
                    {value}
                </span>
                {isDropdownEditable && (
                    <span className="ag-cell-dropdown-arrow">&#9662;</span>
                )}
            </div>
        );
    };

    const ServiceNameCellRenderer = (params) => {
        const { value, data, colDef, node } = params;
        const uniqueId = `serviceName-${data?.engagementId || data?.id || ''}`;

        const handleCopy = () => {
            if (navigator && navigator.clipboard) {
                navigator.clipboard.writeText(value);
                setCopied(true);
                setCopiedValue(uniqueId);
                setTimeout(() => setCopied(false), 1000);
            }
        };

        const cellStyle = {
            overflow: "hidden",
            textOverflow: "ellipsis",
            whiteSpace: "nowrap",
            maxWidth: "100%",
            backgroundColor: copied && copiedValue === uniqueId ? "#1976d2" : "transparent",
            color: copied && copiedValue === uniqueId ? "#fff" : undefined,
            transition: "background 0.2s",
            cursor: "pointer"
        };

        return (
            <div onClick={handleCopy} style={cellStyle} title={value}>
                <span>{value}</span>
            </div>
        );
    };

    const freeTextTagsHeader = () => {
        return (
            <div
                className="header-free-text-tags"
            >
                <span>Additional Tags</span>
                <MotifTooltip
                    allowClick
                    allowHover
                    closeButtonProps={{}}
                    flip
                    id="tooltip"
                    placement="auto"
                    trigger={
                        <MotifIcon
                            style={{ marginTop: '6px' }}
                            src={infoIcon}
                        />
                    }
                    variant="default"
                >
                    Additional tags may include sector, industry,<br /> business model, etc. Please ensure no PII or<br /> client identifiers are included.
                </MotifTooltip>
            </div>
        );
    };

    const CustomCellRendererTransactionWithTooltip = ({ value, data, api }) => {
        const isBuySide = value?.toLowerCase() === "buy-side";

        const getFreshRowData = () => {
            const rowId = data?.engagementId_GUID || data?.engagementId;
            const freshData = rowId ? api?.getRowNode(rowId)?.data : null;
            return freshData || data;
        };

        const additionalInfo = isBuySide
            ? <a href="#" onClick={(e) => {
                e.preventDefault();
                onAddTargetCompanyClick(getFreshRowData(), "");

            }} style={{ color: '#2773c4', textDecoration: 'none', fontSize: "11px", fontWeight: '400' }}>Add Target Company Info</a>
            : value?.toLowerCase() === "sell-side"
                ? <a href="#" onClick={(e) => { e.preventDefault(); onAddClientCompanyClick(getFreshRowData(), ""); }} style={{ color: 'rgb(35 180 180)', textDecoration: 'none', fontSize: "11px", fontWeight: '400' }}>Add Client Company Info</a>
                : <a href="#" onClick={(e) => { e.preventDefault(); onAddClientCompanyClick(getFreshRowData(), ""); }} style={{ color: 'rgb(35 180 180)', textDecoration: 'none', fontSize: "11px", fontWeight: '400' }}>Add Client Company Info</a>;

        const cellStyle = {
            whiteSpace: "nowrap",
            overflow: "hidden",
            textOverflow: "ellipsis",
            maxWidth: "100%",
        };

        // Debugging log to check the value of 'value'

        return (
            <div title={value ?? ''}>
                <div>{value}</div>
                <div >{additionalInfo}</div>
            </div>
        );
    };


    const CustomCellRendererAdditionalTagsWithTooltip = ({ value, data }) => {
        const additionalInfo = (
            <a
                href="#"
                onClick={(e) => {
                    e.preventDefault();
                    onEditClick(data, "");
                }}
                style={{ color: '#2773c4', textDecoration: 'none', fontSize: "11px", fontWeight: '400' }}
            >
                Add Tags
            </a>
        );

        const cellStyle = {
            whiteSpace: "nowrap",
            overflow: "hidden",
            textOverflow: "ellipsis",
            maxWidth: "150px", // Set a specific width for ellipsis to work
            display: "block", // Ensure it behaves as a block element
        };

        return (
            <div style={{ display: 'flex', flexDirection: 'column', maxWidth: '200px' }}> {/* Set a max width for the parent */}
                <div style={cellStyle} title={value} >{value}</div> {/* Apply cellStyle here */}
                <div>{additionalInfo}</div>
            </div>
        );
    };

    const onAddTargetCompanyClick = (row_Data, updatemode = "") => {
        setDialogMode("addTargetCompany"); // Set mode for adding target company
        setIsSaveEnabled(false);
        setBaseURLByArea(row_Data?.area);
        setArea(row_Data?.area);
        setRegion(row_Data?.region);
        setCountry(row_Data?.country);
        setTargetArea(row_Data?.targetArea);
        setTargetRegion(row_Data?.targetRegion);
        setTargetCountry(row_Data?.targetCountry);
        setServiceName(row_Data?.serviceName || "");
        setCompetency(row_Data?.competency || "");
        setPractice(row_Data?.practice || "");
        setSelectedRow(row_Data);
        setEngagementId(row_Data.engagementId);
        setEngagementId_GUID(row_Data.engagementId_GUID);
        applyGicsSelectionFromRow(row_Data);
        setMarketSize(row_Data.revenueRange);
        const tags = (row_Data?.freeTextTags || '').split(',').map(tag => tag.trim()).filter(tag => tag.length > 0); // Split and trim the tags
        setTagsList(tags); // Set the tags list
        setAdditionalTags('');
        setSslCompetancy(row_Data.ssl);
        setButtonClicked(updatemode);
        setShowTagsDropdown(false);
        setIsEditModalOpen(true);

        // Populate any necessary data from row_Data if needed
    };

    const onAddClientCompanyClick = (row_Data, updatemode = "") => {
        setDialogMode("addClientCompany"); // Set mode for adding client company
        setIsSaveEnabled(false);
        setBaseURLByArea(row_Data?.area);
        setTargetArea(row_Data?.targetArea);
        setTargetRegion(row_Data?.targetRegion);
        setTargetCountry(row_Data?.targetCountry);
        setServiceName(row_Data?.serviceName || "");
        setCompetency(row_Data?.competency || "");
        setPractice(row_Data?.practice || "");
        setArea(row_Data?.area);
        setRegion(row_Data?.region);
        setCountry(row_Data?.country);
        setSelectedRow(row_Data);
        setEngagementId(row_Data.engagementId);
        // BUGFIX: was corrupting engagementData (expected array) with GUID string
        setEngagementId_GUID(row_Data.engagementId_GUID);
        applyGicsSelectionFromRow(row_Data);
        setMarketSize(row_Data.revenueRange);
        const tags = (row_Data?.freeTextTags || '').split(',').map(tag => tag.trim()).filter(tag => tag.length > 0); // Split and trim the tags
        setTagsList(tags); // Set the tags list
        setAdditionalTags('');
        setSslCompetancy(row_Data.ssl);
        setButtonClicked(updatemode);
        setShowTagsDropdown(false);
        setIsEditModalOpen(true);
    };
    const gicsLabelPrefix = (dialogMode === "addTargetCompany" || (dialogMode === "edit" && transactionType?.toLowerCase() === "buy-side")) ? "Target " : "";

    const isConfirmButtonDisabled = () => {
        if (dialogMode === "addClientCompany") {
            return (
                !isFormDirty ||
                !sectorId ||
                !industryGroupId ||
                !industryId ||
                !subIndustryId ||
                !marketSize ||
                (
                    marketSize === selectedRow?.revenueRange &&
                    subIndustryName === selectedRow?.subindustry &&
                    targetCountry === selectedRow?.targetCountry &&
                    targetRegion === selectedRow?.targetRegion &&
                    targetArea === selectedRow?.targetArea &&
                    sectorName === selectedRow?.gicsSector &&
                    industryGroupName === selectedRow?.industryGroup &&
                    industryName === selectedRow?.industry &&
                    tagsList.join(",") === selectedRow?.freeTextTags.split(',').map(tag => tag.trim()).filter(tag => tag.length > 0).join(",")
                )
            );
        } else if (dialogMode === "addTargetCompany") {
            return (
                !isFormDirty ||
                !sectorId ||
                !industryGroupId ||
                !industryId ||
                !subIndustryId ||
                !marketSize ||
                !targetRegion ||
                !targetCountry ||
                (
                    marketSize === selectedRow?.revenueRange &&
                    subIndustryName === selectedRow?.subindustry &&
                    targetCountry === selectedRow?.targetCountry &&
                    targetRegion === selectedRow?.targetRegion &&
                    targetArea === selectedRow?.targetArea &&
                    sectorName === selectedRow?.gicsSector &&
                    industryGroupName === selectedRow?.industryGroup &&
                    industryName === selectedRow?.industry &&
                    tagsList.join(",") === selectedRow?.freeTextTags.split(',').map(tag => tag.trim()).filter(tag => tag.length > 0).join(",")
                )
            );
        } else if (dialogMode === "edit") {
            // Must match the condition that shows the Target Super Region / Target Country fields.
            const isBuySideEdit = transactionType?.toLowerCase() === "buy-side";
            return (
                !isFormDirty ||
                !sectorId ||
                !industryGroupId ||
                !industryId ||
                !subIndustryId ||
                !marketSize ||
                (isBuySideEdit && (isMetadataValueMissing(targetRegion) || isMetadataValueMissing(targetCountry))) ||
                (
                    marketSize === selectedRow?.revenueRange &&
                    subIndustryName === selectedRow?.subindustry &&
                    targetCountry === selectedRow?.targetCountry &&
                    targetRegion === selectedRow?.targetRegion &&
                    targetArea === selectedRow?.targetArea &&
                    sectorName === selectedRow?.gicsSector &&
                    industryGroupName === selectedRow?.industryGroup &&
                    industryName === selectedRow?.industry &&
                    tagsList.join(",") === selectedRow?.freeTextTags.split(',').map(tag => tag.trim()).filter(tag => tag.length > 0).join(",")
                )
            );
        } else if (dialogMode === "manageaccess") {
            return (selectedValue.length == 0);
        } else if (dialogMode === "passwordReminder") {
            return enableDisableEmailReminder === null;
        }
        return false; // Default case, button is enabled
    };


    const CustomHeaderCheckbox = ({ checkedEngIds, setCheckedEngIds, fullEngagementList, column }) => {
        const [checked, setChecked] = useState(false);
        const [indeterminate, setIndeterminate] = useState(false);



        useEffect(() => {

            const selectedCount = fullEngagementList.filter((item) =>
                checkedEngIds.includes(item.engagementId)
            ).length;

            setChecked(fullEngagementList.length > 0 && selectedCount === fullEngagementList.length);
            setIndeterminate(selectedCount > 0 && selectedCount < fullEngagementList.length);
        }, [fullEngagementList, checkedEngIds]);

        const handleClick = (e) => {
            e.stopPropagation();
            const newChecked = !checked;

            const newIds = newChecked ? fullEngagementList.map((item) => item.engagementId) : [];

            setCheckedEngIds(newIds);
            setChecked(newChecked);
            setIndeterminate(false);
        };

        return (
            <div className="select-checkbox-container" onClick={handleClick}>
                <MotifCheckbox checked={checked} indeterminate={indeterminate} />
                <span>{column?.colDef?.headerName ?? 'Engagement Id'}</span>
            </div>
        );
    };

    const getCachedAvatarUrl = (id) => {
        try {
            const stored = sessionStorage.getItem("asyncAvatarCache_v1");
            if (!stored) return "";
            const obj = JSON.parse(stored);
            const entry = obj?.[id];
            // entry may be string (legacy) or object { url, ts }
            if (!entry) return "";
            if (typeof entry === "string") return entry || "";
            return entry.url || "";
        } catch (e) {
            return "";
        }
    };
    const regionToCountriesMap = React.useMemo(() => {
        const map = {};

        userData?.areaRegionCountryMappings?.forEach(item => {
            if (!map[item.regionName]) {
                map[item.regionName] = new Set();
            }
            map[item.regionName].add(item.countryName);
        });

        Object.keys(map).forEach(region => {
            map[region] = Array.from(map[region]).sort((a, b) => a.localeCompare(b));
        });

        return map;
    }, [userData]);

    const gicsSectorMappings = userData?.gicsSectorMappings;

    // Name-keyed hierarchy for the grid cell editors and set filters.
    const gicsHierarchy = React.useMemo(
        () => buildGicsNameHierarchy(gicsSectorMappings),
        [gicsSectorMappings]
    );

    // Id-based option lists for the Update Engagement dialog.
    const gicsSectorOptions = React.useMemo(
        () => getGicsSectorOptions(gicsSectorMappings),
        [gicsSectorMappings]
    );
    const gicsIndustryGroupOptions = React.useMemo(
        () => getGicsIndustryGroupOptions(gicsSectorMappings, sectorId),
        [gicsSectorMappings, sectorId]
    );
    const gicsIndustryOptions = React.useMemo(
        () => getGicsIndustryOptions(gicsSectorMappings, industryGroupId),
        [gicsSectorMappings, industryGroupId]
    );
    const gicsSubIndustryOptions = React.useMemo(
        () => getGicsSubIndustryOptions(gicsSectorMappings, industryId),
        [gicsSectorMappings, industryId]
    );

    const revenueRangeOptionsMap = React.useMemo(() => {
        return userData?.revenueRanges
            ?.filter(item => item.range !== "Others")
            .map(item => item.range) || [];
    }, [userData]);

    const sslOptionsMap = React.useMemo(() => {
        return userData?.ssl
            ?.map(item => item.sslName)
            .filter(sslName => sslName) || [];
    }, [userData]);

    const competenciesMap = React.useMemo(() => {
        return userData?.competencyList?.map(item => ({
            id: item.competencyID,
            name: item.competencyName
        })).sort((a, b) => a.name.localeCompare(b.name)) || [];
    }, [userData]);

    const competencyToPracticesMap = React.useMemo(() => {
        const map = {};
        userData?.practiceList?.forEach(item => {
            const compId = item.competencyID;
            if (!map[compId]) map[compId] = [];
            map[compId].push({ id: item.practiceID, name: item.practiceName });
        });
        Object.keys(map).forEach(compId => {
            map[compId].sort((a, b) => a.name.localeCompare(b.name));
        });
        return map;
    }, [userData]);

    const competencyOptionsMap = React.useMemo(() => {
        return competenciesMap.map(c => c.name);
    }, [competenciesMap]);

    const serviceNameOptionsMap = React.useMemo(() => {
        const names = new Set();
        utilityData?.data?.forEach(item => {
            if (item.serviceName) names.add(item.serviceName);
        });
        return Array.from(names).sort();
    }, [utilityData?.data]);

    const additionalTagsOptionsMap = React.useMemo(() => {
        // Extract unique tags from existing utilityData freeTextTags
        const allTags = new Set();
        utilityData?.data?.forEach(item => {
            if (item.freeTextTags) {
                const tags = item.freeTextTags.split(',').map(tag => tag.trim()).filter(tag => tag.length > 0);
                tags.forEach(tag => allTags.add(tag));
            }
        });
        return Array.from(allTags).sort();
    }, [utilityData?.data]);

    const revenueComparator = (valueA, valueB) => {
        const isBlank = (v) => v == null || String(v).trim() === '';

        const aBlank = isBlank(valueA);
        const bBlank = isBlank(valueB);
        if (aBlank && bBlank) return 0;
        if (aBlank) return -1;
        if (bBlank) return 1;

        const parseDollarValue = (value) => {
            if (typeof value !== 'string') return Number.POSITIVE_INFINITY;

            const raw = value.trim();
            const lower = raw.split('-')[0].trim();

            const inequalityRegex = /^(?<op><=|>=|<|>)\s*(?<rest>.*)$/i;
            const wordOpRegex = /^(?<word>(under|less than|below|at most|≤|no more than|over|more than|above|at least|≥))\s*(?<rest>.*)$/i;

            let op = null;
            let rest = lower;

            const sym = lower.match(inequalityRegex);
            if (sym && sym.groups) {
                op = sym.groups.op;
                rest = sym.groups.rest.trim();
            } else {
                const w = lower.match(wordOpRegex);
                if (w && w.groups) {
                    const word = w.groups.word.toLowerCase();
                    rest = w.groups.rest.trim();
                    if (['under', 'less than', 'below', 'at most', '≤', 'no more than'].includes(word)) op = '<=';
                    if (['over', 'more than', 'above', 'at least', '≥'].includes(word)) op = '>=';
                }
            }

            rest = rest.replace(/US\s?\$|\$/i, '').trim();

            const m = rest.match(/^([\d,.]+)\s*([BMK])?$/i);
            if (!m) return Number.POSITIVE_INFINITY;

            const number = parseFloat(m[1].replace(/,/g, ''));
            if (isNaN(number)) return Number.POSITIVE_INFINITY;

            const unit = (m[2] || '').toUpperCase();

            let millions = number;
            if (unit === 'B') millions = number * 1000;
            else if (unit === 'K') millions = number / 1000;

            const EPS = 1e-6;
            if (op === '<') return millions - EPS;
            if (op === '<=') return millions;
            if (op === '>') return millions + EPS;
            if (op === '>=') return millions;

            return millions;
        };

        const aNum = parseDollarValue(valueA);
        const bNum = parseDollarValue(valueB);

        if (aNum < bNum) return -1;
        if (aNum > bNum) return 1;
        return 0;
    };

    const caseInsensitiveComparator = (valueA, valueB) => {
        const isBlank = (v) => v == null || String(v).trim() === '';
        const aBlank = isBlank(valueA);
        const bBlank = isBlank(valueB);
        if (aBlank && bBlank) return 0;
        if (aBlank) return -1;
        if (bBlank) return 1;
        return String(valueA).localeCompare(String(valueB), undefined, { sensitivity: 'base' });
    };

    const columnDefs = React.useMemo(() => [
        {
            field: "engagementName",
            headerClass: "selected-border-right",
            pinned: "left",
            // Without lockPinned, AG Grid auto-unpins this column when pinned widths approach the viewport width.
            lockPinned: true,
            lockVisible: true,
            headerName: "Engagement Name",
            width: 200,
            resizable: true,
            checkboxSelection: true,
            filter:true,
            lockVisible: true,
            headerCheckboxSelection: true,
            headerCheckboxSelectionFilteredOnly: true,
            comparator: caseInsensitiveComparator,
            cellRenderer: CustomCellRendererTooltip, // Apply custom renderer with tooltip
            //  headerComponent: CustomHeaderCheckbox, // Add custom header component
            // headerComponentParams: {
            //     enableSorting: true,
            //     showFilter: true,
            //     checkedEngIds,
            //     setCheckedEngIds,
            //     fullEngagementList: filteredDataRef.current,
            // },
            cellRenderer: (params) => {
                // Handle group rows (no data on group row)
                if (params?.node?.group) {
                    return (
                        <span title={String(params.value ?? '')}>{String(params.value ?? '')}</span>
                    );
                }

                const engagementId = params?.data?.engagementId ?? params.value;
                const engagementName = params?.data?.engagementName ?? String(params.value ?? '');
                const uniqueId = `engagementName-${engagementId ?? ''}`;
                const cellStyle = {
                    backgroundColor: copied && copiedValue === uniqueId ? "#1976d2" : "transparent",
                    color: copied && copiedValue === uniqueId ? "#fff" : undefined,
                    transition: "background 0.2s",
                    cursor: "pointer"
                };

                const handleCopy = () => {
                    if (navigator && navigator.clipboard) {
                        navigator.clipboard.writeText(engagementName);
                        setCopied(true);
                        setCopiedValue(uniqueId);
                        setTimeout(() => setCopied(false), 1000); // Reset after 1s
                    }
                };

                return (
                    <div className="ey-data-container engagement-name-cell">
                        {/* <MotifCheckbox
                                id={`checkbox-${engagementId ?? ''}`}
                                value={engagementId ?? ''}
                                checked={checkedEngIds.includes(engagementId)}
                                onChange={(e) => handleCheckboxChange(e)}

                            /> */}
                        <div className="engagement-name-inner" style={{ minWidth: 0, flex: 1, overflow: "hidden" }}>
                            <div className="engagement-name-text" title={engagementName} onClick={handleCopy} style={cellStyle}>
                                {engagementName}
                            </div>
                            {!(params?.data && params.data.clientData) && (
                                <span className='lbl-NonQualified' title='Only upload EY data; do not include client data.'>
                                    EY Data Only
                                </span>
                            )}
                        </div>


                    </div>
                );
            }
        },
        {
            field: "engagementId",
            headerName: "Engagement Id",
            width: 145,
            cellRenderer: CustomCellRendererTooltip,
            sortable: true,
            filter: true,
            enableRowGroup: true,
            enablePivot: false,

            // cellRendererFramework

        }

        ,
        {
            field: "clientName",
            headerName: "Client Name",
            width: 125,
            resizable: true,
            editable: false,
            sortable: true,
            filter: true,
            cellRenderer: ServiceNameCellRenderer, // Apply custom renderer with tooltip
            // this for editable columns
            onCellValueChanged: (params) => {
                if (!params.newValue) {
                    params.node.setDataValue('hasError', true);
                }
                { logger.info("Client Name changed to:", params.newValue) }
            },
        },
        {
            field: "partnerName",
            headerName: "Partner Name",
            width: 135,
            resizable: true,
            sortable: true,
            filter: AG_SET_FILTER_AVAILABLE ? 'agSetColumnFilter' : 'agTextColumnFilter',
            cellClass: "actions-header-right-partner-name-cells",

            cellRenderer: (params) => {
                // Handle group rows (no data on group row)
                if (params?.node?.group) {
                    return String(params.value ?? '');
                }
                // Add copy-to-clipboard functionality with unique identification
                const uniqueId = `partnerName-${params?.data?.engagementId ?? params.value ?? ''}`;
                const name = params?.data?.partnerName || '';
                const avatarId = params?.data?.engagementPartners || params?.data?.partnerName || '';
                const containerStyle = {
                    display: 'flex',
                    alignItems: 'left',
                    gap: '8px',
                    overflow: 'hidden',
                    marginLeft: '-8px'
                };
                const nameStyle = {
                    whiteSpace: 'nowrap',
                    overflow: 'hidden',
                    textOverflow: 'ellipsis',
                    maxWidth: '120px',
                    marginLeft: "10px",
                    backgroundColor: copied && copiedValue === uniqueId ? "#1976d2" : "transparent",
                    color: copied && copiedValue === uniqueId ? "#fff" : undefined,
                    transition: "background 0.2s",
                    cursor: "pointer"
                };
                const cachedAvatar = avatarId ? getCachedAvatarUrl(avatarId) : "";
                const handleCopy = () => {
                    if (navigator && navigator.clipboard) {
                        navigator.clipboard.writeText(name);
                        setCopied(true);
                        setCopiedValue(uniqueId);
                        setTimeout(() => setCopied(false), 1000); // Reset after 1s
                    }
                };
                return (
                    <div style={containerStyle} title={name}>
                        {cachedAvatar ? (
                            <img
                                src={cachedAvatar}
                                alt={name}
                                style={{ width: 24, height: 24, borderRadius: '50%', objectFit: 'cover', marginLeft: '9px' }}
                            />
                        ) : (
                            <div style={{ marginRight: '9.5px' }}>
                                <AsyncAvatar id={avatarId} name={name} size="small" />
                            </div>
                        )}<div style={nameStyle} onClick={handleCopy}>{name}</div>
                    </div>
                );
            }
        },
        {
            field: "transactionType",
            headerName: "Transaction Type",
            width: 155,
            resizable: true,
            sortable: true,
            filter: AG_SET_FILTER_AVAILABLE ? 'agSetColumnFilter' : 'agTextColumnFilter',
            cellRenderer: CustomCellRendererTransactionWithTooltip, // Apply custom renderer with tooltip
        },
        ...(userProfileDetails?.isEngagementAdmin === true ? [{
            field: "dataSource",
            headerName: "Source",
            width: 120,
            resizable: true,
            sortable: true,
            enableRowGroup: true,
            enablePivot: false,
            filter: AG_SET_FILTER_AVAILABLE ? 'agSetColumnFilter' : 'agTextColumnFilter',
            cellRenderer: CustomCellRendererTooltip
        }] : []),
        {
            field: "targetRegion",
            headerName: "Super Region",
            width: 135,
            resizable: true,
            sortable: true,
            enableRowGroup: true,
            enablePivot: false,
            filter: AG_SET_FILTER_AVAILABLE ? 'agSetColumnFilter' : 'agTextColumnFilter',
            filterParams: AG_SET_FILTER_AVAILABLE ? narrowedSetFilterParams("targetRegion") : undefined,
            editable: (params) => !!params?.data && String(params.data?.transactionType).toLowerCase() === 'buy-side',
            cellEditor: 'agSelectCellEditor',
            cellEditorParams: (params) => ({
                values: params.context.regionList
            }),
            onCellValueChanged: (params) => {
                if (params.newValue !== params.oldValue) {
                    params.node.setDataValue('targetCountry', null);
                    setTargetRegion(params.newValue);
                    // Refresh the targetCountry cell to update its dropdown options
                    params.api.refreshCells({
                        rowNodes: [params.node],
                        columns: ['targetCountry'],
                        force: true
                    });
                }
            },
            cellRenderer: CustomCellRendererTooltip
        },
        {
            field: "targetCountry",
            headerName: "Country",
            width: 105,
            resizable: true,
            sortable: true,
            filter: AG_SET_FILTER_AVAILABLE ? 'agSetColumnFilter' : 'agTextColumnFilter',
            filterParams: AG_SET_FILTER_AVAILABLE ? narrowedSetFilterParams("targetCountry") : undefined,
            editable: (params) => !!params?.data && String(params.data?.transactionType).toLowerCase() === 'buy-side',
            cellEditor: 'agSelectCellEditor',
            cellEditorParams: (params) => ({
                values:
                    params.context.regionToCountriesMap[
                    params.data.targetRegion
                    ] || []
            }),
            onCellValueChanged: (params) => {
                if (params.newValue !== params.oldValue) {
                    setTargetCountry(params.newValue);
                    // Additional logic can be added here if needed when targetCountry changes
                    // Only call inline save if the new value is not null (to avoid calling it when targetRegion changes)
                    if (params.newValue !== null) {
                        onInlineCellSave(params.data, 'targetCountry', params.newValue);
                    }
                }
            },
            cellRenderer: CustomCellRendererTooltip
        },
        {
            field: "serviceName",
            headerName: "Service Name",
            width: 160,
            resizable: true,
            sortable: true,
            filter: AG_SET_FILTER_AVAILABLE ? 'agSetColumnFilter' : 'agTextColumnFilter',
            filterParams: AG_SET_FILTER_AVAILABLE ? narrowedSetFilterParams("serviceName") : undefined,
            cellRenderer: ServiceNameCellRenderer
        },
        {
            field: "competency",
            headerName: "Competency",
            width: 150,
            resizable: true,
            sortable: true,
            filter: AG_SET_FILTER_AVAILABLE ? 'agSetColumnFilter' : 'agTextColumnFilter',
            filterParams: AG_SET_FILTER_AVAILABLE ? narrowedSetFilterParams("competency") : undefined,
            editable: false,
            cellRenderer: CustomCellRendererTooltip
        },
        {
            field: "practice",
            headerName: "Practice",
            width: 160,
            resizable: true,
            sortable: true,
            filter: AG_SET_FILTER_AVAILABLE ? 'agSetColumnFilter' : 'agTextColumnFilter',
            filterParams: AG_SET_FILTER_AVAILABLE ? narrowedSetFilterParams("practice") : undefined,
            editable: false,
            cellRenderer: CustomCellRendererTooltip
        },
        // Domain/Competency (ssl) column hidden from UI - data preserved in database
        // {
        //     field: "targetArea",
        //     filter: true,
        //     headerName: "Area",
        //     width: 140,
        //     cellRenderer: CustomCellRendererTooltip
        // },
        // {
        //     field: "targetRegion",
        //     headerComponentParams: {
        //         enableSorting: true,
        //         showFilter: true
        //     },
        //     headerName: "Super Region",
        //     width: 190,
        //     resizable: true,
        //     cellRenderer: CustomCellRendererTooltip
        // },
        // {
        //     field: "targetCountry",
        //     headerComponentParams: {
        //         enableSorting: true,
        //         showFilter: true
        //     },
        //     headerName: "Country",
        //     width: 160,
        //     resizable: true,
        //     cellRenderer: CustomCellRendererTooltip
        // },
        {
            field: "gicsSector",
            headerName: "Sector",
            width: 120,
            resizable: true,
            sortable: true,
            filter: AG_SET_FILTER_AVAILABLE ? 'agSetColumnFilter' : 'agTextColumnFilter',
            filterParams: AG_SET_FILTER_AVAILABLE ? narrowedSetFilterParams("gicsSector") : undefined,
            editable: true,
            cellEditor: 'agSelectCellEditor',
            cellEditorParams: (params) => ({
                values: params.context?.gicsHierarchy?.sectors || []
            }),
            onCellValueChanged: (params) => {
                if (params.newValue !== params.oldValue) {
                    params.data.gicsSectorId = null;
                    params.data.industryGroupId = null;
                    params.data.industryId = null;
                    params.data.subIndustryId = null;
                    params.node.setDataValue('industryGroup', null);
                    params.node.setDataValue('industry', null);
                    params.node.setDataValue('subindustry', null);
                    // Refresh dependent cells so their dropdown options follow the new sector
                    params.api.refreshCells({
                        rowNodes: [params.node],
                        columns: ['industryGroup', 'industry', 'subindustry'],
                        force: true
                    });
                }
            },
            cellRenderer: CustomCellRendererTooltip
        },
        {
            field: "industryGroup",
            headerName: "Industry Group",
            width: 150,
            resizable: true,
            sortable: true,
            filter: AG_SET_FILTER_AVAILABLE ? 'agSetColumnFilter' : 'agTextColumnFilter',
            filterParams: AG_SET_FILTER_AVAILABLE ? narrowedSetFilterParams("industryGroup") : undefined,
            editable: true,
            cellEditor: 'agSelectCellEditor',
            cellEditorParams: (params) => ({
                values: params.context?.gicsHierarchy?.industryGroupsBySector?.[params.data?.gicsSector] || []
            }),
            onCellValueChanged: (params) => {
                if (params.newValue !== params.oldValue) {
                    params.data.industryGroupId = null;
                    params.data.industryId = null;
                    params.data.subIndustryId = null;
                    params.node.setDataValue('industry', null);
                    params.node.setDataValue('subindustry', null);
                    params.api.refreshCells({
                        rowNodes: [params.node],
                        columns: ['industry', 'subindustry'],
                        force: true
                    });
                }
            },
            cellRenderer: CustomCellRendererTooltip
        },
        {
            field: "industry",
            headerName: "Industry",
            width: 150,
            resizable: true,
            sortable: true,
            filter: AG_SET_FILTER_AVAILABLE ? 'agSetColumnFilter' : 'agTextColumnFilter',
            filterParams: AG_SET_FILTER_AVAILABLE ? narrowedSetFilterParams("industry") : undefined,
            editable: true,
            cellEditor: 'agSelectCellEditor',
            cellEditorParams: (params) => ({
                values: params.context?.gicsHierarchy?.industriesByIndustryGroup?.[params.data?.industryGroup] || []
            }),
            onCellValueChanged: (params) => {
                if (params.newValue !== params.oldValue) {
                    params.data.industryId = null;
                    params.data.subIndustryId = null;
                    params.node.setDataValue('subindustry', null);
                    params.api.refreshCells({
                        rowNodes: [params.node],
                        columns: ['subindustry'],
                        force: true
                    });
                }
            },
            cellRenderer: CustomCellRendererTooltip
        },
        {
            field: "subindustry",
            headerName: "Sub Industry",
            width: 160,
            resizable: true,
            sortable: true,
            filter: AG_SET_FILTER_AVAILABLE ? 'agSetColumnFilter' : 'agTextColumnFilter',
            filterParams: AG_SET_FILTER_AVAILABLE ? narrowedSetFilterParams("subindustry") : undefined,
            editable: true,
            cellEditor: 'agSelectCellEditor',
            cellEditorParams: (params) => ({
                values: params.context?.gicsHierarchy?.subIndustriesByIndustry?.[params.data?.industry] || []
            }),
            onCellValueChanged: (params) => {
                if (params.newValue !== params.oldValue) {
                    params.data.subIndustryId = null;
                    // Saving on the last level keeps the full hierarchy consistent in one call
                    if (params.newValue !== null) {
                        onInlineCellSave(params.data, 'subindustry', params.newValue);
                    }
                }
            },
            cellRenderer: CustomCellRendererTooltip
        },

        {
            field: "revenueRange",
            headerName: "Reported Revenue Range",
            width: 205,
            resizable: true,
            sortable: true,
            filter: AG_SET_FILTER_AVAILABLE ? 'agSetColumnFilter' : 'agTextColumnFilter',
            filterParams: AG_SET_FILTER_AVAILABLE ? narrowedSetFilterParams("revenueRange") : undefined,
            editable: true,
            cellEditor: 'agSelectCellEditor',
            cellEditorParams: (params) => ({
                values: params.context.revenueRangeOptionsMap || []
            }),
            onCellValueChanged: (params) => {
                if (params.newValue !== params.oldValue) {
                    setMarketSize(params.newValue);
                    if (params.newValue !== null) {
                        onInlineCellSave(params.data, 'revenueRange', params.newValue);
                    }
                }
            },
            // uncomment this part for sorting fix. need to use a hidden field for sorting
            //  valueGetter: (params) =>  params.data.engagementId,
            //  valueFormatter: (params) => params.data.revenueRange,
            comparator: revenueComparator,
            cellRenderer: CustomCellRendererTooltip
        },
        {
            field: "freeTextTags",
            headerName: "Additional Tags",
            width: 200,
            resizable: true,
            sortable: true,
            filter: true,
            editable: false,
            cellRenderer: (params) => {
                if (params?.node?.group || !params?.data) return '';
                const raw = params.value || '';
                const tags = raw.split(',').map(t => t.trim()).filter(t => t.length > 0);
                const MAX_VISIBLE = 2;
                const visibleTags = tags.slice(0, MAX_VISIBLE);
                const remaining = tags.length - MAX_VISIBLE;

                return (
                    <div className="tags-cell-container" onClick={() => openTagsDialog(params.data)}>
                        <div className="tags-cell-chips">
                            {tags.length === 0 && <span className="tags-cell-empty">-</span>}
                            {visibleTags.map((tag, i) => (
                                <span key={i} className="tags-cell-chip" title={tag}>{tag}</span>
                            ))}
                            {remaining > 0 && (
                                <span className="tags-cell-chip tags-cell-more">+{remaining}</span>
                            )}
                        </div>
                        <img
                            loading="lazy"
                            src={require("../../common/images/edit_enable_icon.png")}
                            alt="edit-tags"
                            className="tags-cell-edit-icon"
                            title="Edit Tags"
                        />
                    </div>
                );
            },
        },

        {
            field: "noOfUploadedFiles",
            headerComponentParams: {
                enableSorting: true,
                showFilter: false,
                width: 210,
                resizable: true,
            },
            filter: false,
            // firstColumnBorderRight: true,
            headerName: "Uploaded Files",
            width: 140,
            cellRenderer: CustomCellRendererTooltip,
            cellRenderer: (params) => {
                const row_Data = params.data;
                const countsRecord = uploadCountsRef.current[row_Data.engagementId_GUID];
                // Use latest values if present in redux counts
                const noOfUploadedFiles = countsRecord?.noOfUploadedFiles ?? row_Data.noOfUploadedFiles ?? 0;
                const totalPendingFile = countsRecord?.totalPendingFile ?? row_Data.totalPendingFile ?? 0;
                const totalUploadedFile = Math.max(0, (noOfUploadedFiles || 0) - (totalPendingFile || 0));
                return <div title={String(totalUploadedFile)}>{totalUploadedFile}</div>;
            },
        },
        ...(userProfileDetails?.isEngagementAdmin ? [{
            field: "isEmailReminderEnabled",
            // pinned: "right",
            headerName: "Password Reminder Status",
            //  resizable: true,
            width: 155,
            wrapHeaderText: true,
            headerComponentParams: {
                enableSorting: false,
                showFilter: false
            },
            filter: false,
            cellRenderer: (params) => {
                const row_Data = params.data;
                return (
                    <div className="reminder-status-cell" title={row_Data.isEmailReminderEnabled ? "Enabled" : "Disabled"}>
                        {row_Data.isEmailReminderEnabled ? (
                            <span className="reminder-enabled">Enabled</span>
                        ) : (
                            <span className="reminder-disabled">Disabled</span>
                        )}
                    </div>
                );
            }
        }] : []),
        {
            field: "pendingFiles",
            pinned: "right",
            lockPinned: true,
            lockVisible: true,
            headerName: "Upload Status",
            resizable: true,
            lockVisible: true,
            headerClass: "actions-header-right",
            cellClass: "actions-header-right",
            headerComponentParams: {
                enableSorting: false,
            },
            sortable: false,
            filter: 'agSetColumnFilter',
            filterValueGetter: (params) => {
                if (!params?.data) return '';
                if (params.data.totalPendingFile > 0) return 'Provide password';
                // Mirrors the cell renderer, which only shows Metadata Missing when no files are pending.
                if (params.data.totalPendingFile === 0 && isArcMetadataMissing(params.data)) return 'Metadata Missing';
                // ARC engagements with unresolved download failures surface as "Download Error"
                // (Provide password / Metadata Missing above take precedence).
                if (String(params.data.dataSource || "").toUpperCase() === "ARC"
                    && (failedUploadStatusRef.current?.[params.data.engagementId_GUID]?.data?.length ?? 0) > 0) {
                    return 'Download Error';
                }
                if (params.data.noOfUploadedFiles == 0) return 'No files';
                return params.data.engagementTrackingStatus || '';
            },
            cellRenderer: (params) => {
                // Guard: group rows have no data
                if (params?.node?.group || !params?.data) {
                    return '';
                }
                const row_Data = params.data;

                const failedCount = (failedUploadsRef.current || []).filter(
                    (item) => item.engagementID === row_Data.engagementId
                );
                const pendingFileCount = params.data.totalPendingFile;
                const uploadStatus =
                    params.data.noOfUploadedFiles == 0
                        ? "No files"
                        : params.data.engagementTrackingStatus;

                const engagementProgressList = Object.values(uploadPercentageRef.current || {}).filter(
                    (p) => p.engagementId === row_Data.engagementId
                );
                const totalPercent = engagementProgressList.reduce(
                    (sum, p) => sum + (p.percentSize || 0),
                    0
                );
                const isInProgress =
                    engagementProgressList.length > 0 &&
                    engagementProgressList.some((p) => (p.percent || 0) < 100);

                const statusList = Array.isArray(fileStatusRef.current) ? fileStatusRef.current : [];
                const rowGuid = normalizeGuid(row_Data.engagementId_GUID);
                const status = statusList.find(
                    (item) => normalizeGuid(getStatusGuid(item)) === rowGuid
                );
                const processed = Number(status?.totalFileProcessed || 0);
                const uploaded = Number(status?.totalFileUploaded || 0);
                const isProcessing = uploaded > 0 && processed !== uploaded;
                const showProgressCount = status?.isSharepointUpload;

                const engagementPauseState = engagementPauseStatus.current[row_Data.engagementId] || {};
                const uploadSessionKeys = Object.keys(engagementPauseState).filter(key => key.startsWith(`${row_Data.engagementId}_`));
                const isPaused = Boolean(engagementPauseState.isUploadPaused) || uploadSessionKeys.some(key => Boolean(engagementPauseState[key]?.isUploadPaused));
                const isAutoPaused = Boolean(engagementPauseState.isUploadAutoPaused) || uploadSessionKeys.some(key => Boolean(engagementPauseState[key]?.isUploadAutoPaused));

                const handlePauseResume = (engagementId) => {
                    const prev = engagementPauseStatus.current[engagementId] || {};

                    // Get all upload sessions for this engagement
                    const uploadSessions = Object.keys(prev).filter(key => key.startsWith(`${engagementId}_`));

                    const isEnagementPaused = Boolean(engagementPauseStatus.current[engagementId]?.isUploadPaused) || uploadSessions.some(key => Boolean(prev[key]?.isUploadPaused));
                    const isEnagementAutoPaused = Boolean(engagementPauseStatus.current[engagementId]?.isUploadAutoPaused) || uploadSessions.some(key => Boolean(prev[key]?.isUploadAutoPaused));
                    const anySessionPaused = isEnagementPaused || isEnagementAutoPaused;

                    const willPause = !anySessionPaused;

                    if (willPause && uploadSessions.length > 0) {
                        // Pause all active sessions
                        uploadSessions.forEach(sessionKey => {
                            const sessionData = prev[sessionKey] || {};
                            const autoPaused = Boolean(sessionData.isUploadAutoPaused);

                            if (!autoPaused) {
                                let ac = sessionData.abortController;
                                if (!ac) ac = new AbortController();
                                try { ac.abort(); } catch { }

                                prev[sessionKey] = {
                                    ...sessionData,
                                    isUploadPaused: true,
                                    isUploadAutoPaused: false,
                                    abortController: ac,
                                };
                            }
                        });

                        engagementPauseStatus.current[engagementId] = prev;
                        engagementPauseStatus.current[engagementId].isUploadPaused = true;
                        setAlertMessage?.(
                            `The upload has been paused for Engagement ${engagementId} and can be resumed in the same session.`
                        );
                        setOpenAlertDialog?.(true);
                    } else if (navigator.onLine) {
                        // Resume all paused sessions
                        uploadSessions.forEach(sessionKey => {
                            const sessionData = prev[sessionKey] || {};
                            const freshAC = new AbortController();

                            prev[sessionKey] = {
                                ...sessionData,
                                isUploadPaused: false,
                                isUploadAutoPaused: false,
                                offlineAlertShown: false, // Reset offline alert flag
                                abortController: freshAC,
                            };

                            const resolver = sessionData.resumeResolve;
                            if (typeof resolver === "function") {
                                try { resolver(); } catch { }
                                prev[sessionKey].resumeResolve = null;
                            } else {
                                prev[sessionKey].pendingManualResume = true;
                            }
                        });

                        engagementPauseStatus.current[engagementId] = prev;
                        engagementPauseStatus.current[engagementId].isUploadPaused = false;
                        engagementPauseStatus.current[engagementId].isUploadAutoPaused = false;
                    }

                    params.api?.refreshCells?.({ columns: ["pendingFiles", "actions"], force: true });
                };

                const arcDownloadRecord = arcDownloadStatusRef.current?.[row_Data.engagementId_GUID];
                const isArcDownloading = arcDownloadRecord?.status === ApiStatus.LOADING;
                if (isArcDownloading) {
                    return (
                        <div className="progress-bar-container" style={{ marginLeft: "-5px" }}>
                            <span className="progress-label" style={{ fontSize: "10px", marginTop: "5px" }}>
                                Downloading files...
                            </span>
                            <MotifProgressBar
                                hideLabel="true"
                                labelPosition="default"
                                isIndeterminate={true}
                                variant="alt"
                                className="motif-score"
                            />
                        </div>
                    );
                }

                // After a successful ARC download the backend keeps processing; show the
                // existing "Syncing..." indicator until the upload status reaches a terminal value.
                const isArcSyncing =
                    arcDownloadRecord?.status === ApiStatus.SUCCESS &&
                    !ARC_TERMINAL_UPLOAD_STATUSES.has(
                        String(row_Data.engagementTrackingStatus || "").trim().toLowerCase()
                    );
                if (isArcSyncing) {
                    return (
                        <div
                            className="sync-loading-status"
                            style={{ display: "flex", alignItems: "center", height: "100%" }}
                        >
                            <MotifIcon src={syncIcon} className="sync-rotating-icon small" />
                            <span style={{ fontSize: "10px", marginLeft: 4 }}>
                                Syncing...
                            </span>
                        </div>
                    );
                }

                if (isInProgress) {
                    return (
                        <div className="progress-bar-container" style={{ marginLeft: "-15px" }}>
                            <span className="progress-label" style={{ fontSize: "10px", marginTop: "5px" }}>
                                {isPaused || isAutoPaused ? "Paused" : "Uploading"} - {" "}
                                {totalPercent} % completed
                            </span>
                            <img
                                loading="lazy"
                                src={isPaused || isAutoPaused ? PlayIcon : PauseIcon}
                                onClick={() => handlePauseResume(row_Data.engagementId)}
                                alt={isPaused || isAutoPaused ? "Resume" : "Pause"}
                                style={{
                                    height: 15,
                                    width: 15,
                                    cursor: "pointer",
                                    marginRight: "2px 5px 8px 5px",
                                    marginBottom: "-3px",
                                }}
                            />
                            <MotifProgressBar
                                hideLabel="true"
                                labelPosition="default"
                                value={totalPercent}
                                resultStateLabel="Completed"
                                isIndeterminate={totalPercent === 100 && !isPaused && !isAutoPaused}
                                variant="alt"
                                className="motif-score"
                            />
                        </div>
                    );
                }

                if (isProcessing) {
                    return (
                        <div className="progress-bar-container" style={{ marginLeft: "-5px" }}>
                            {showProgressCount ? (
                                <div style={{ marginTop: "9px" }}>
                                    <div className="progress-label" style={{ marginLeft: "-5px" }}>
                                        {processed === uploaded ? "Processed" : "Processing"}{" "}
                                        <span style={{ marginRight: "60px" }}>
                                            {processed}/{uploaded}
                                        </span>
                                    </div>
                                    <MotifProgressBar
                                        style={{ marginLeft: "-5px" }}
                                        hideLabel="true"
                                        labelPosition="default"
                                        value={uploaded > 0 ? Math.floor((processed / uploaded) * 100) : 0}
                                        processStateLabel={`Processing ${processed}/${uploaded}`}
                                        resultStateLabel={`Processed ${processed}/${uploaded}`}
                                        variant="alt"
                                        className="motif-score"
                                    />
                                </div>
                            ) : (
                                <MotifProgressBar
                                    style={{ marginLeft: "-5px" }}
                                    labelPosition="default"
                                    value={uploaded > 0 ? Math.floor((processed / uploaded) * 100) : 0}
                                    processStateLabel="Processed"
                                    resultStateLabel="Processed"
                                    variant="alt"
                                    className="motif-score"
                                />
                            )}
                        </div>
                    );
                }

                if (pendingFileCount === 0) {
                    const normalizedUploadStatus = uploadStatus.toLowerCase();
                    const isMetadataMissing = isArcMetadataMissing(row_Data);
                    // ARC engagements with unresolved download failures also render as "Download
                    // Error". isMetadataMissing below still takes precedence, and reaching this block
                    // means pendingFileCount === 0 so "Provide password" already took precedence.
                    const isArcSource = String(row_Data?.dataSource || "").toUpperCase() === "ARC";
                    const arcFailedLen = failedUploadStatusRef.current?.[row_Data.engagementId_GUID]?.data?.length ?? 0;
                    const isDownloadError = normalizedUploadStatus.startsWith("download error") || (isArcSource && arcFailedLen > 0);
                    const isSubmittedByArc =
                        normalizedUploadStatus === "submitted by arc" ||
                        normalizedUploadStatus === "submitted via arc";
                    // Count shown after "Submitted by ARC" mirrors the "Uploaded Files" column
                    // (latest redux counts: uploaded minus still-pending).
                    const countsRecord = uploadCountsRef.current[row_Data.engagementId_GUID];
                    const submittedArcCount = Math.max(
                        0,
                        (countsRecord?.noOfUploadedFiles ?? row_Data.noOfUploadedFiles ?? 0)
                            - (countsRecord?.totalPendingFile ?? row_Data.totalPendingFile ?? 0)
                    );
                    const displayUploadStatus = isMetadataMissing
                        ? "Metadata Missing"
                        : isDownloadError
                            ? "Download Error"
                            : normalizedUploadStatus === "in progress"
                                ? "In progress"
                                : normalizedUploadStatus === "files uploaded"
                                    ? "Files uploaded"
                                    : normalizedUploadStatus === "failed upload"
                                        ? "Failed upload"
                                        : isSubmittedByArc
                                            ? (
                                                <span className="submitted-arc-status">
                                                    Submitted by ARC
                                                    <span className="submitted-arc-count">{submittedArcCount}</span>
                                                </span>
                                            )
                                            : uploadStatus;
                    const className = isMetadataMissing
                        ? "metadata-missing-container"
                        : isDownloadError
                            ? "download-error-status-container"
                            : normalizedUploadStatus === "no files"
                                ? "no-files-container"
                                : normalizedUploadStatus === "files uploaded"
                                    ? "pending-files-container"
                                    : normalizedUploadStatus === "in progress"
                                        ? "in-progress-status-container"
                                    : "completed-status-container";

                    return (
                        <div style={{ marginTop: "auto", marginBottom: "8%" }}>
                            <div
                                style={{ marginLeft: "-10px", marginTop: "-19px", ...(isMetadataMissing ? { cursor: "pointer" } : {}) }}
                                className={`upload-status-container ${className}`}
                                onClick={isMetadataMissing ? () => onEditClick(row_Data) : undefined}
                                title={isMetadataMissing ? "Add the missing engagement metadata" : undefined}
                            >
                                {displayUploadStatus}
                            </div>

                            <div>
                                {(() => {
                                    const engagementId = row_Data.engagementId_GUID;
                                    const st = failedUploadStatusRef.current[engagementId];
                                    const failedCountValue = st?.data?.length ?? failedCount?.length ?? 0;
                                    if (failedCountValue > 0) {
                                        return (
                                            <div
                                                className="Failed-Upload-container"
                                                style={{
                                                    display: "flex",
                                                    alignItems: "center",
                                                    border: "1px solid #F6B26B",
                                                    backgroundColor: "#FFF3E0",
                                                    color: "#B85C00",
                                                    borderRadius: "10px",
                                                    padding: "1px 2px",
                                                    fontSize: "10px",
                                                    width: "fit-content",
                                                    lineHeight: 1,
                                                    cursor: "pointer",
                                                    marginLeft: "-5px",
                                                    marginBottom: "-6px"
                                                }}
                                                onClick={() => {
                                                    // ARC failures open the dedicated read-only "Retry Download"
                                                    // panel; other sources keep the Add Files re-upload flow.
                                                    if (String(row_Data.dataSource || "").toUpperCase() === "ARC") {
                                                        setFailedUploadData?.(st?.data || []);
                                                        onFailedUploadClick?.(row_Data);
                                                    } else {
                                                        setOpenFailedUploadBadge?.(true);
                                                        setAddFilesOpen?.(true);
                                                        setRowData?.(row_Data);
                                                        setFailedUploadData?.(st?.data || []);
                                                    }
                                                }}
                                            >
                                                <MotifIcon
                                                    src={waringIcon}
                                                    style={{ width: "10px", height: "10px", marginRight: "4px", color: "#d28431ff" }}
                                                />
                                                <span style={{ marginRight: "4px", fontWeight: 500 }}>Failed</span>
                                                <span
                                                    style={{
                                                        backgroundColor: "#F6B26B",
                                                        color: "#9c5100ff",
                                                        borderRadius: "8px",
                                                        padding: "2px 8px",
                                                        fontSize: "8px",
                                                        width: "25px",
                                                        height: "16px",
                                                        display: "flex",
                                                        alignItems: "center",
                                                        justifyContent: "center",
                                                        fontWeight: 500,
                                                    }}
                                                >
                                                    {st?.data ? st.data.length : failedCount?.length}
                                                </span>
                                            </div>
                                        );
                                    }
                                    return null;
                                })()}
                            </div>
                        </div>
                    );
                }

                return (
                    <div className="pending-files-container">
                        <div
                            style={{
                                display: "flex",
                                alignItems: "center",
                                border: "1px solid #F59E9E",
                                backgroundColor: "#FFECEC",
                                color: "#D64545",
                                borderRadius: "10px",
                                padding: "1px 2px",
                                fontSize: "10px",
                                fontWeight: 500,
                                width: "fit-content",
                                lineHeight: 1,
                                cursor: "pointer",
                                marginLeft: "-5px",
                                marginTop: "-7px"
                            }}
                            onClick={() => onPendingFilesClick?.(row_Data)}
                        >
                            <MotifIcon
                                src={lockIcon}
                                style={{ width: "10px", height: "10px", marginRight: "4px", color: "#8a0000ff" }}
                            />
                            <span style={{ marginRight: "4px" }}>Provide password</span>
                            <span
                                style={{
                                    backgroundColor: "#F59E9E",
                                    color: "#8a0000ff",
                                    borderRadius: "8px",
                                    padding: "2px 8px",
                                    fontSize: "8px",
                                    width: "25px",
                                    height: "16px",
                                    display: "flex",
                                    alignItems: "center",
                                    justifyContent: "center",
                                    fontWeight: "bolder",
                                }}
                            >
                                {pendingFileCount}
                            </span>
                        </div>

                        {(() => {
                            const engagementId = row_Data.engagementId_GUID;
                            const st = failedUploadStatusRef.current[engagementId];
                            const failedCountValue = st?.data?.length ?? failedCount?.length ?? 0;
                            if (failedCountValue > 0) {
                                return (
                                    <div
                                        className="Failed-Upload-container"
                                        style={{
                                            display: "flex",
                                            alignItems: "center",
                                            border: "1px solid #F6B26B",
                                            backgroundColor: "#FFF3E0",
                                            color: "#B85C00",
                                            borderRadius: "10px",
                                            padding: "1px 2px",
                                            fontSize: "10px",
                                            width: "fit-content",
                                            lineHeight: 1,
                                            cursor: "pointer",
                                            marginLeft: "-5px",
                                            marginBottom: "-7px",
                                        }}
                                        onClick={() => {
                                            // ARC failures open the dedicated read-only "Retry Download"
                                            // panel; other sources keep the Add Files re-upload flow.
                                            if (String(row_Data.dataSource || "").toUpperCase() === "ARC") {
                                                setFailedUploadData?.(st?.data || []);
                                                onFailedUploadClick?.(row_Data);
                                            } else {
                                                setOpenFailedUploadBadge?.(true);
                                                setAddFilesOpen?.(true);
                                                setRowData?.(row_Data);
                                                setFailedUploadData?.(st?.data || []);
                                            }
                                        }}
                                    >
                                        <MotifIcon
                                            src={waringIcon}
                                            style={{ width: "10px", height: "10px", marginRight: "4px", color: "#d28431ff" }}
                                        />
                                        <span style={{ marginRight: "4px", fontWeight: 500 }}>Failed</span>
                                        <span
                                            style={{
                                                backgroundColor: "#F6B26B",
                                                color: "#9c5100ff",
                                                borderRadius: "8px",
                                                padding: "2px 8px",
                                                fontSize: "8px",
                                                width: "25px",
                                                height: "16px",
                                                display: "flex",
                                                alignItems: "center",
                                                justifyContent: "center",
                                                fontWeight: 500,
                                            }}
                                        >
                                            {st?.data ? st.data.length : failedCount?.length}
                                        </span>
                                    </div>
                                );
                            }
                            return null;
                        })()}
                    </div>
                );
            },
            width: 190,
        },
        {
            headerName: "Actions",
            pinned: "right",
            lockPinned: true,
            lockVisible: true,
            field: "actions",
            lockVisible: true,
            headerComponentParams: {
                enableSorting: false,
                showFilter: false
            },
            sortable: false,
            filter: false,
            headerClass: "actions-header-right",
            cellRenderer: (params) => {
                // Guard: group rows have no data
                if (params?.node?.group || !params?.data) {
                    return '';
                }
                const row_Data = params.data;
                const rowGuid = normalizeGuid(row_Data.engagementId_GUID);
                const status = (Array.isArray(fileStatusRef.current) ? fileStatusRef.current : []).find(
                    item => normalizeGuid(getStatusGuid(item)) === rowGuid
                );
                const isProcessing = Number(status?.totalFileUploaded || 0) > 0 &&
                    Number(status?.totalFileProcessed || 0) !== Number(status?.totalFileUploaded || 0);

                const isDisabled = !((row_Data.datA_UPLOADERS_EMAIL || '').toLowerCase().includes((userName || '').toLowerCase())
                    ||
                    (params.data.engagementPartners || '').toLowerCase() === (userName || '').toLowerCase()) && !(userProfileDetails?.isEngagementAdmin);
                const failedUploadExist = (failedUploadsRef.current || []).some(
                    item => item.engagementID === row_Data.engagementId);
                const engagementProgressList = Object.values(uploadPercentageRef.current || {}).filter(
                    p => p.engagementId === row_Data.engagementId
                );
                const isUploadinProgress = engagementProgressList.length > 0 &&
                    engagementProgressList.some(p => (p.percent || 0) < 100);

                const statusText = (row_Data?.engagementTrackingStatus || "").toLowerCase();
                const normalizedDataSource = String(row_Data?.dataSource || "").toLowerCase();
                const isEdgeSource = normalizedDataSource === "edge" || normalizedDataSource === "oneedge" || normalizedDataSource === "one edge";
                const isArcSource = String(row_Data?.dataSource || "").toUpperCase() === "ARC";
                // ARC engagements are submittable only after they had password-protected pending
                // files that have since been unlocked (pending cleared via correct passwords).
                const arcSubmitBlocked = isArcSource && !arcHadPendingRef.current.has(row_Data.engagementId_GUID);
                const isSubmitDisabled = (statusText == "no files" || statusText.startsWith("submitted") || row_Data?.totalPendingFile > 0 || params.data.noOfUploadedFiles == 0 || arcSubmitBlocked);
                // ARC Submit is enabled only when the engagement shows "Files uploaded" (files
                // present and metadata complete) and has no failed files left for it (failed-file
                // list from api//errors/all, stored in failedUploadStatus, is empty). It stays
                // disabled while any files are still pending a password (status "Provide password",
                // i.e. totalPendingFile > 0).
                const arcFailedFilesCount = failedUploadStatusRef.current?.[row_Data.engagementId_GUID]?.data?.length ?? 0;
                const isArcSubmitAllowed =
                    statusText === "files uploaded" &&
                    Number(row_Data?.noOfUploadedFiles) > 0 &&
                    Number(row_Data?.totalPendingFile || 0) === 0 &&
                    !isArcMetadataMissing(row_Data) &&
                    arcFailedFilesCount === 0;
                const hasRequiredMetadata = hasRequiredUploadMetadata(row_Data);
                return (
                    <>
                        <div className="button-container">
                            <MotifButton
                                onClick={() => onViewFilesClick(row_Data)}
                                variant='secondary'
                                disabled={isDisabled || isEdgeSource}
                                className="action-icon-button"
                                >
                                <MotifIcon src={IconoirEye} className="action-icon" title="View Files" />
                            </MotifButton>
                            {isArcSource ? (
                                <MotifButton
                                    onClick={() => {
                                        if (!hasRequiredMetadata) {
                                            onEditClick(row_Data, "arcDownload"); // Open EditEngagement to capture missing metadata
                                        } else {
                                            // Clear this engagement's prior ARC download-failure records, then start the download.
                                            deleteArcErrorLogs([row_Data.engagementId_GUID]);
                                            onDownloadArcFilesClick(row_Data); // Otherwise, start the ARC download
                                        }
                                    }}
                                    disabled={userProfileDetails?.isEngagementAdmin !== true || !isArcHeaderDownloadEligible(row_Data) || isArcGuidDownloading(arcDownloadStatusRef.current, row_Data.engagementId_GUID)}
                                    variant='secondary'
                                    className="arc-download-button action-icon-button"
                                    >
                                    <MotifIcon src={IconoirDownload} className="action-icon" title="Download" />
                                </MotifButton>
                            ) : (
                                <MotifButton
                                    onClick={() => {
                                        if (!hasRequiredMetadata) {
                                            onEditClick(row_Data, "add"); // Call edit function if any condition is true
                                        } else {
                                            onAddFilesClick(row_Data); // Otherwise, call add files function
                                        }
                                    }}
                                    disabled={isProcessing || isUploadinProgress || isEdgeSource}
                                    variant='secondary'
                                    className="action-icon-button"
                                    >
                                    <MotifIcon src={IconoirCloudUpload} className="action-icon" title="Add Files" />
                                </MotifButton>
                            )}
                            <MotifButton
                                onClick={() => onEditClick(row_Data)}
                                variant='secondary'
                                disabled={isEdgeSource}
                                className="action-icon-button edit-icon-utilitytable"
                                >
                                <MotifIcon
                                    src={IconoirEditPencil}
                                    className="action-icon"
                                    title={isEdgeSource ? "Editing is not available for Edge engagements" : "Edit Engagement"}
                                />
                            </MotifButton>
                            <span className="separator"></span> {/* Separator added here */}
                            {/* For ARC, also keep Submit disabled while a download is still in flight
                                ("Downloading files..." = LOADING / "Syncing..." = SUCCESS, via
                                isArcGuidDownloading) and while the engagement is processing, so it can
                                only be submitted once the upload status has settled. */}
                            <MotifButton onClick={() => onSubmitClick(row_Data)} variant='primary' disabled={isArcSource ? (!isArcSubmitAllowed || isArcGuidDownloading(arcDownloadStatusRef.current, row_Data.engagementId_GUID) || isProcessing) : (isSubmitDisabled || isProcessing || failedUploadExist || isUploadinProgress || isEdgeSource)} >Submit</MotifButton>
                        </div>
                    </>
                );
            },
            width: 190,
        },
    ], [checkedEngIds, copied, copiedValue, userProfileDetails?.isEngagementAdmin]);

    const onSubmitClick = (row_Data) => {
        const isArcSource = (row_Data?.dataSource || "").toUpperCase() === "ARC";
        const engagementStatus = isArcSource ? "Submitted by ARC" : "Submitted";
        setIsLoading(true);
        lastSubmittedEngagementRef.current = {
            engagementId: row_Data?.engagementId,
            engagementId_GUID: row_Data?.engagementId_GUID,
            engagementStatus,
        };
        // setBaseURLByArea(row_Data?.area);
        let BASEURL = '';
        if ((row_Data?.area || "").toLowerCase() === "americas") {
            BASEURL = process.env.REACT_APP_API_URL_US;
        } else if ((row_Data?.area || "").toLowerCase() === "emeia") {
            BASEURL = process.env.REACT_APP_API_URL_EU
        } else if ((row_Data?.area || "").toLowerCase() === "apac") {
            BASEURL = process.env.REACT_APP_API_URL_AU
        }
        if (BASEURL === process.env.REACT_APP_API_URL_US) {
            dispatch(partnersEditEngagementStatusUS({
                "engagementID": row_Data?.engagementId,
                "engagementStatus": engagementStatus,
                "region": row_Data?.area,
                "email": getAccount()?.username,
                "EngagementId_GUID": row_Data?.engagementId_GUID
            }))
        }
        if (BASEURL === process.env.REACT_APP_API_URL_EU) {
            dispatch(partnersEditEngagementStatusEU({
                "engagementID": row_Data?.engagementId,
                "engagementStatus": engagementStatus,
                "region": row_Data?.area,
                "email": getAccount()?.username,
                "EngagementId_GUID": row_Data?.engagementId_GUID
            }))
        }
        if (BASEURL === process.env.REACT_APP_API_URL_AU) {
            dispatch(partnersEditEngagementStatusAU({
                "engagementID": row_Data?.engagementId,
                "engagementStatus": engagementStatus,
                "region": row_Data?.area,
                "email": getAccount()?.username,
                "EngagementId_GUID": row_Data?.engagementId_GUID
            }))
        }

    }

    useEffect(() => {
        if (partnersEditEngagementStatusData?.status === ApiStatus.SUCCESS) {
            const submitted = lastSubmittedEngagementRef.current;
            if (submitted?.engagementId) {
                const row = fileDataRef.current.find(item => item.engagementId === submitted.engagementId);
                if (row) {
                    row.engagementTrackingStatus = submitted?.engagementStatus || "Submitted";
                    if (gridApi?.applyTransaction) {
                        gridApi.applyTransaction({ update: [row] });
                    }
                    gridApi?.refreshCells?.({ columns: ["pendingFiles", "actions"], force: true });
                }
                triggerEngagementUpdate(submitted.engagementId);
            }
            setIsLoading(false);
            setDialogMode("submit");
            setIsEditModalOpen(true);
            const url = new URL(window.location.href);
            if (url.searchParams.has('eng_guid')) {
                url.searchParams.delete('eng_guid');
                window.history.replaceState({}, '', url.pathname + url.search);
                setHighlightedGUID(null);
                setHasNavigatedToHighlightedRow(false);
            }
            dispatch(resetPartnersEditEngagementStatus());
        } else if (partnersEditEngagementStatusData?.status === ApiStatus.ERROR) {
            logger.error("An error occurred:", partnersEditEngagementStatusData?.error);
            setIsLoading(false);
        }
    }, [partnersEditEngagementStatusData?.status])
    const GetAllErrorsAsEngAdmin = async () => {
        try {
            const response = await apiQueryWithToken.post("api//errors/all", {
                emailAddress: getAccount()?.username,
                isEngagementAdmin: userProfileDetails?.isEngagementAdmin || false,
            });
            const errorResults = {};
            // Group files by engagementIdGUID
            const grouped = {};
            (response.data || []).forEach((file) => {
                const engagementId_GUID = file.engagementIdGUID;
                if (!grouped[engagementId_GUID]) {
                    grouped[engagementId_GUID] = [];
                }
                grouped[engagementId_GUID].push(file);
            });

            Object.entries(grouped).forEach(([engagementId_GUID, files]) => {
                // Update failedUploadStatus
                setFailedUploadStatus(prev => ({
                    ...prev,
                    [engagementId_GUID]: { hasValues: files.length > 0, data: files },
                }));

                // Update failedUploadData
                setFailedUploadData(prev => {
                    const filtered = prev.filter(item => item.engagementID !== engagementId_GUID);
                    const uploads = files.map((f, i) => ({
                        file: f.uploadFileName,
                        fileName: f.uploadFileName,
                        reason: f.reasonPhrase,
                        message: f.customErrorMessage,
                        engagementID: f.engagementIdGUID,
                        region: f.region,
                        id: `${f.engagementIdGUID}-${i}`,
                        attempts: 3,
                        currentFlow: true,
                    }));
                    return [...filtered, ...uploads];
                });

                // Update failedUploads
                setFailedUploads(prev => {
                    const filtered = prev.filter(item => item.engagementID !== engagementId_GUID);
                    return [...filtered, ...files.map((f, i) => ({
                        file: f.uploadFileName,
                        fileName: f.uploadFileName,
                        reason: f.reasonPhrase,
                        message: f.customErrorMessage,
                        engagementID: f.engagementIdGUID,
                        region: f.region,
                        id: `${f.engagementIdGUID}-${i}`,
                        attempts: 3,
                        currentFlow: true,
                    }))];
                });

                // Set errorResults for this engagement
                errorResults[engagementId_GUID] = files;
            });

            // For engagements with no errors, set null
            fileData.forEach(item => {
                if (!errorResults[item.engagementId_GUID]) {
                    errorResults[item.engagementId_GUID] = null;
                }
            });

            setEngagementErrors(errorResults);
            setFailedUploadLoadData(false);
        } catch (e) {
            const errorResults = {};
            fileData.forEach(item => {
                errorResults[item.engagementId_GUID] = null;
            });
            setEngagementErrors(errorResults);
            setFailedUploadLoadData(false);
        }
    }
    const parseDollarValue = (value) => {
        if (!value) return 0;

        // Remove "US $" and split range
        const cleaned = value.replace(/US\s?\$/i, '');
        const lowerBound = cleaned.split('-')[0];

        const number = parseFloat(lowerBound);

        if (lowerBound.includes('B')) return number * 1_000;
        if (lowerBound.includes('M')) return number;

        return number;
    };

    const GetErrorsByEngagement = async (engagementId_GUID, { force = false } = {}) => {

        try {
            if (force || isFailedUploadLoadData) {
                const response = await apiQueryWithToken.post(
                    `api/errors/engagement?engagementIdGUID=${engagementId_GUID ||
                    failedUploadStatus[engagementId_GUID]?.data?.[0]?.engagementId_GUID
                    }`
                );
                const responseData = response.data;
                const updatedCount = responseData.length;
                setUpdatedCountFailedUpload(updatedCount);
                const hasValues = responseData.length > 0;

                // ✅ Update failedUploadStatus map
                setFailedUploadStatus((prev) => ({
                    ...prev,
                    [engagementId_GUID]: { hasValues, data: responseData },
                }));

                // ✅ Append/update inside failedUploadData
                setFailedUploadData((prev) => {
                    // remove old data for this engagement
                    const filtered = prev.filter(
                        (item) => item.engagementID !== engagementId_GUID
                    );

                    // map new uploads
                    const uploads = responseData.map((file, idx) => ({
                        file: file.uploadFileName,
                        fileName: file.uploadFileName,
                        reason: file.reasonPhrase,
                        message: file.customErrorMessage,
                        engagementID: file.engagementIdGUID,
                        region: file.region,
                        id: `${file.engagementIdGUID}-${idx}`, // unique ID
                        attempts: 3,
                        currentFlow: true,
                    }));

                    return [...filtered, ...uploads];
                });

                // ✅ Also maintain failedUploads (flattened list)
                setFailedUploads((prev) => {
                    const filtered = prev.filter(
                        (item) => item.engagementID !== engagementId_GUID
                    );
                    return [...filtered, ...responseData.map((file, idx) => ({
                        file: file.uploadFileName,
                        fileName: file.uploadFileName,
                        reason: file.reasonPhrase,
                        message: file.customErrorMessage,
                        engagementID: file.engagementIdGUID,
                        region: file.region,
                        id: `${file.engagementIdGUID}-${idx}`,
                        attempts: 3,
                        currentFlow: true,
                    }))];
                });

                return responseData;
            }
        } catch (error) {

            const errorUpload = {
                file: null,
                fileName: null,
                reason: error.name,
                message: error.message,
                engagementID: engagementId_GUID,
                region: null,
                id: `${engagementId_GUID}-error-${Date.now()}`,
                attempts: 0,
                currentFlow: true,
            };

            // push error into failedUploadData
            setFailedUploadData((prev) => [...prev, errorUpload]);
            setFailedUploads((prev) => [...prev, errorUpload]);
        }
    };




    // Enhance column definitions for header icons (sorting/filtering) except where a custom headerComponent already exists
    const columnDefsWithHeaders = React.useMemo(() => columnDefs, [columnDefs]);
    const defaultColDef = React.useMemo(() => ({
        sortable: true,
        filter: 'agTextColumnFilter',
        floatingFilter: false,
        resizable: true,
        enableRowGroup: true,
        enablePivot: false,
        suppressMenuHide: true,
        suppressMenu: false,
        enableFilterHandlers: true,
        menuTabs: ['generalMenuTab', 'filterMenuTab', 'columnsMenuTab'],
        cellClassRules: {
            'ag-inline-edit-cursor': (params) => {
                try {
                    if (params?.node?.group || !params?.data) return false;
                    const editableProp = params?.colDef?.editable;
                    const isEditable = typeof editableProp === 'function' ? !!editableProp(params) : !!editableProp;
                    return isEditable;
                } catch {
                    return false;
                }
            }
        },
        cellStyle: {
            display: 'flex',
            alignItems: 'center',
        }
    }), []);

    // const fixedColumns = columnDefsWithHeaders.slice(0, 1); // First column
    // const scrollableColumns = columnDefsWithHeaders; // Middle columns
    // const lastTwoColumns = columnDefsWithHeaders.slice(-2); // Last two columns
    // const paginatedData = filteredData.slice(startIndex, endIndex);
    const fetchLoggedInUserCountry = useCallback(async () => {
        try {
            const email = (getAccount()?.username || '').toLowerCase();
            if (!email) return;
            const results = await searchGraphUsers(email);
            const exactMatch =
                results?.find((item) => String(item?.status || '').toLowerCase() === email) ||
                results?.[0] ||
                null;
            const resolvedCountry = exactMatch?.country || userProfileDetails?.country || '';
            setContactCountry(resolvedCountry);
        } catch (error) {
            setContactCountry(userProfileDetails?.country || '');
        }
    }, [userProfileDetails?.country]);

    const openContactUs = () => {
        setIsContactUsOpen(true);
        setContactMethod('email');
        setContactNotes('');
        setContactToastMessage('');
        void fetchLoggedInUserCountry();
    };

    const closeContactUs = () => {
        if (isContactSubmitting) return;
        setIsContactUsOpen(false);
    };

    const handleContactSubmit = async () => {
        const trimmedNotes = contactNotes.trim();
        if (!contactMethod || !trimmedNotes || isContactSubmitting) return;

        const account = getAccount();
        const firstName = String(account?.name || "").trim().split(/\s+/).filter(Boolean)[0] || "";
        const payload = {
            email: account?.username || '',
            name: firstName,
            country: contactCountry || userProfileDetails?.country || '',
            contact_method: contactMethod,
            message: trimmedNotes,
        };

        try {
            setIsContactSubmitting(true);
            const response = await apiQueryWithToken.post('/api/SSP/contactUs', payload);
            const isSuccess = response?.data === true || String(response?.data).toLowerCase() === 'true';

            if (!isSuccess) {
                throw new Error('Failed to submit contact request. Please try again.');
            }

            setIsContactUsOpen(false);
            setContactNotes('');
            setIsContactToastSuccess(true);
            setContactToastMessage('The DBS team will contact you soon.');
            setIsContactToastVisible(true);
        } catch (error) {
            const errorMsg =
                typeof error?.response?.data === 'string'
                    ? error.response.data
                    : error?.message || 'Failed to submit contact request. Please try again.';
            setIsContactToastSuccess(false);
            setContactToastMessage(errorMsg);
            setIsContactToastVisible(true);
        } finally {
            setIsContactSubmitting(false);
        }
    };

    useEffect(() => {
        if (!isContactToastVisible) return;

        const timeoutId = setTimeout(() => {
            setIsContactToastVisible(false);
        }, 5000);

        return () => clearTimeout(timeoutId);
    }, [isContactToastVisible]);

    const getRowHeight = () => 48;
    useEffect(() => {
        if (filteredData.length === 0) return;
        const totalPages = Math.max(1, Math.ceil(filteredData.length / rowsPerPage));
        setCurrentPage((prev) => {
            if (prev > totalPages) return totalPages;
            if (prev < 1) return 1;
            return prev;
        });
    }, [filteredData.length, rowsPerPage]);
    const groupedUsers = [];

    const convertClientEngagement = async () => {
        setToggleChecked(!toggleChecked);
        setOpenConvertClientDialog(true);
    }
    const passwordReminder = async () => {
        setEnableDisableEmailReminder(null);
        setDialogMode("passwordReminder");
        setIsEditModalOpen(true);
    }


    const manageAccess = async () => {

        setValue([]);
        setDialogMode("manageaccess");
        setIsEditModalOpen(true);
        await GetAccess(checkedEngIds);


    };

    const GetAccess = async (selectedEngagementIDs) => {
        const SELECTEDROWData = fileData.filter(row => selectedEngagementIDs?.includes(row.engagementId));
        // Group by area with list of engagement IDs
        const groupedSelectedRowData = SELECTEDROWData.reduce((acc, row) => {
            const area = row.area;
            if (!acc[area]) {
                acc[area] = [];
            }
            acc[area].push(row.engagementId);
            return acc;
        }, {});

        SetshowManageAccessLoader(true);

        try {

            await Promise.all(
                Object.entries(groupedSelectedRowData).map(async ([area, engagementId]) => {
                    setBaseURLByArea(area);
                    let BASEURL = '';
                    if ((area || "").toLowerCase() === "americas") {
                        BASEURL = process.env.REACT_APP_API_URL_US;
                    } else if ((area || "").toLowerCase() === "emeia") {
                        BASEURL = process.env.REACT_APP_API_URL_EU
                    } else if ((area || "").toLowerCase() === "apac") {
                        BASEURL = process.env.REACT_APP_API_URL_AU
                    }
                    for (const engID of engagementId) {
                        const response = await apiQueryToUploadDataRegional.post(`${BASEURL}/api/partners/files/GetAccess?Id=${engID}`
                        );
                        const emailString = response?.data?.[0]?.email;
                        if (emailString) {
                            const emails = emailString.split(',').map(email => email.trim()).filter(Boolean);
                            for (const email of emails) {
                                const lowerEmail = email.toLowerCase();
                                if (!groupedUsers[lowerEmail]) {
                                    groupedUsers[lowerEmail] = {
                                        email,
                                        userName: null,
                                        engagements: [],
                                    };
                                }
                                if (!groupedUsers[lowerEmail].engagements.includes(engID)) {
                                    groupedUsers[lowerEmail].engagements.push(engID);
                                }
                            }
                        }

                    }

                })

            );

            const transformed = await Promise.all(
                Object.entries(groupedUsers).map(async ([email, details]) => {
                    const result = await searchGraphUsers(email); // Fetch user info
                    return {
                        email,
                        engagements: details.engagements,
                        userName: result[0]?.displayName || null,
                        profilePhoto: result[0]?.image || null,
                    };
                })
            );

            SetDataUploaderList(transformed);


        } catch (error) {
            SetshowManageAccessLoader(false);
            if (error.response && error.response.status === 401) {
                navigate("/");
            } else {
                logger.error("An error occurred:", error);
            }
        } finally {
            SetshowManageAccessLoader(false);
        }
    };
    const userName = getAccount()?.username;

    const formatSuccessMessage = () => {

        const formatArrayItemsAsString = () => {
            if (selectedValue.length > 2) {
                return `${selectedValue[0].label}, ${selectedValue[1].label} +${selectedValue.length - 2
                    } has been successfully added to engagement ${checkedEngIds.join(',')}.`;
            } else {
                return `${selectedValue
                    .map((item) => item.label)
                    .join(', ')} has been successfully added to engagement ${checkedEngIds.join(',')}.`;
            }
        };
        return formatArrayItemsAsString();


    }
    const formatRevokeMessage = () => {

        const formatArrayItemsAsString = () => {


            if (deleteOption === 'All')
                return ` All the data uploaders access has been revoked from the selected engagement.`
            else if (deleteOption === 'User') {
                return `${dataUploaderList.find(item => item.email === uploaderToDelete)?.userName || 'this user'} access has been revoked from the selected engagement.`
            }
            else {
                return `${dataUploaderList.find(item => item.email === uploaderToDelete)?.userName || 'this user'} access has been revoked from the ${selectedEngagementToRevoke.join(',')}.`


            }

        };
        return formatArrayItemsAsString();


    }
    const grantAccess = async () => {
        setIsFormDirty(true);

        SetshowManageAccessLoader(true);
        SetDelegateAction("Grant");

        const outputArr = [];
        selectedValue.forEach(user => {
            checkedEngIds.forEach(engID => {
                const email = user.value;

                // Check if this (email, engID) pair already exists in existingRecords
                const exists = dataUploaderList.some(record =>
                    record.email.toLowerCase() === email.toLowerCase() && record.engagements.includes(engID)
                );

                if (!exists) {
                    const match = fileData.find(f => f.engagementId === engID);
                    outputArr.push({
                        email: email.toLowerCase(),
                        userName: user.label,
                        engagementID: engID,
                        EngagementId_GUID: match?.engagementId_GUID,
                        actionBy: userName
                    });
                }
            });
        });

        // group engagement by area
        const areaEngagementMap = {};

        fileData.forEach(({ engagementId, area }) => {
            if (!areaEngagementMap[area]) {
                areaEngagementMap[area] = new Set();
            }
            areaEngagementMap[area].add(engagementId);
        });

        for (const [area, engagementIDsSet] of Object.entries(areaEngagementMap)) {
            const filteredRequests = outputArr.filter(item =>
                engagementIDsSet.has(item.engagementID)
            );

            if (filteredRequests.length > 0) {

                let NewBASEURL = '';
                if ((area || "").toLowerCase() === "americas") {
                    NewBASEURL = process.env.REACT_APP_API_URL_US;
                } else if ((area || "").toLowerCase() === "emeia") {
                    NewBASEURL = process.env.REACT_APP_API_URL_EU
                } else if ((area || "").toLowerCase() === "apac") {
                    NewBASEURL = process.env.REACT_APP_API_URL_AU
                }

                if (NewBASEURL === process.env.REACT_APP_API_URL_US) {
                    postGrantRequests.push(
                        dispatch(partnersAccessGrantUS({ "engagementManageRequests": filteredRequests }))
                    );
                } else if (NewBASEURL === process.env.REACT_APP_API_URL_EU) {
                    postGrantRequests.push(
                        dispatch(partnersAccessGrantEU({ "engagementManageRequests": filteredRequests }))
                    );
                } else if (NewBASEURL === process.env.REACT_APP_API_URL_AU) {
                    postGrantRequests.push(
                        dispatch(partnersAccessGrantAU({ "engagementManageRequests": filteredRequests }))
                    );
                }
            }

        }

    }
    const enableDisableEmailReminderAction = async () => {
        setIsLoading(true);
        setIsEditModalOpen(false);

        const selectedEngagementGuids = (utilityData?.data ?? [])
            .filter(item => checkedEngIds.includes(item.engagementId))
            .map(item => item.engagementId_GUID);

        if (selectedEngagementGuids.length > 0) {
            const selectedRows = (utilityData?.data ?? []).filter(item =>
                selectedEngagementGuids.includes(item.engagementId_GUID)
            );

            // Group engagements by area
            const areaGroups = selectedRows.reduce((acc, row) => {
                const area = (row.area || "").toLowerCase();
                if (!acc[area]) {
                    acc[area] = [];
                }
                acc[area].push(row.engagementId_GUID);
                return acc;
            }, {});

            try {
                // Make API calls for each area
                const responses = await Promise.all(
                    Object.entries(areaGroups).map(async ([area, guids]) => {
                        let NewBASEURL = '';
                        if (area === "americas") {
                            NewBASEURL = process.env.REACT_APP_API_URL_US;
                        } else if (area === "emeia") {
                            NewBASEURL = process.env.REACT_APP_API_URL_EU;
                        } else if (area === "apac") {
                            NewBASEURL = process.env.REACT_APP_API_URL_AU;
                        }

                        return await apiQueryToUploadDataRegional.post(
                            `${NewBASEURL}/api/partners/EnableDisableEmailReminder`,
                            {
                                engagementId_GUIDs: String(guids.join(',')),
                                isEmailReminderEnabled: enableDisableEmailReminder
                            }
                        );
                    })
                );

                // Check if all responses are successful (response.data === true)
                const allSuccessful = responses.every(response => response.data === true);

                setIsLoading(false);
                setIsEmailReminderToastVisible(true);
                setIsEmailReminderSuccessful(allSuccessful);

                if (allSuccessful) {
                   // setCheckedEngIds([]); 
                    getData(true);
                }

                setTimeout(() => {
                    setIsEmailReminderToastVisible(false);
                    setIsEmailReminderSuccessful(false);
                }, 5000);

            } catch (error) {
                logger.error("Error occurred while enabling/disabling email reminder:", error);
                setIsLoading(false);
                setIsEmailReminderToastVisible(true);
                setIsEmailReminderSuccessful(false);
                setTimeout(() => {
                    setIsEmailReminderToastVisible(false);
                }, 5000);
            }
        }
    }
    useEffect(() => {
        if (partnersAccessGrantData?.status === ApiStatus.SUCCESS) {
            Promise.all(postGrantRequests);
            // Only show toast if this effect was triggered by an explicit grant action
            if (delegateAction === 'Grant' && postGrantRequests.length > 0) {
                SetManageDelegateMsg(formatSuccessMessage());
                setIsDelegateToastVisible(true);
                setTimeout(() => setIsDelegateToastVisible(false), 3000);
            }
            // Trigger update for all checked engagements
            checkedEngIds.forEach(engagementId => {
                const matchingData = fileData.find(item => item.engagementId === engagementId);
                if (matchingData) {
                    triggerEngagementUpdate(engagementId);
                }
            });
            GetAccess(checkedEngIds);
            SetshowManageAccessLoader(false);
            setValue([]);
            // SetDelegateAction('');
        } else if (partnersAccessGrantData?.status === ApiStatus.ERROR) {
            logger.error("An error occurred:", partnersAccessGrantData?.error);
            // SetDelegateAction('');
        }
    }, [partnersAccessGrantData?.status]);

    const revokeAccess = async () => {
        SetshowManageAccessLoader(true);
        SetDelegateAction("Revoke");
        const outputArr = [];

        if (deleteOption == 'All') {

            dataUploaderList.filter(item => item.email.includes(searchUser.toLowerCase())).map((uploader) => {
                const email = uploader.email;
                const displayName = uploader.userName;
                uploader.engagements.map((engID) => {
                    const match = fileData.find(f => f.engagementId === engID);
                    outputArr.push({
                        email: email.toLowerCase(),
                        userName: displayName,
                        engagementID: engID,
                        EngagementId_GUID: match?.engagementId_GUID,
                        actionBy: userName
                    });

                });
            });
        }
        else if (deleteOption == 'User') {

            const engagementsToRevoke = dataUploaderList.filter(item => item.email == uploaderToDelete);
            const displayName = engagementsToRevoke[0]?.userName || '';
            engagementsToRevoke[0].engagements.forEach(engID => {
                const email = uploaderToDelete;
                const match = fileData.find(f => f.engagementId === engID);
                outputArr.push({
                    email: email.toLowerCase(),
                    userName: displayName,
                    engagementID: engID,
                    EngagementId_GUID: match?.engagementId_GUID,
                    actionBy: userName
                });


            });

        }
        else {
            const displayName = dataUploaderList.filter(item => item.email == uploaderToDelete)[0].userName || '';
            selectedEngagementToRevoke.forEach(engID => {
                const email = uploaderToDelete;
                const match = fileData.find(f => f.engagementId === engID);
                outputArr.push({
                    email: email.toLowerCase(),
                    userName: displayName,
                    engagementID: engID,
                    EngagementId_GUID: match?.engagementId_GUID,
                    actionBy: userName
                });


            });

        }



        // group engagement by area
        const areaEngagementMap = {};

        fileData.forEach(({ engagementId, area }) => {
            if (!areaEngagementMap[area]) {
                areaEngagementMap[area] = new Set();
            }
            areaEngagementMap[area].add(engagementId);
        });

        for (const [area, engagementIDsSet] of Object.entries(areaEngagementMap)) {
            const filteredRequests = outputArr.filter(item =>
                engagementIDsSet.has(item.engagementID)
            );
            if (filteredRequests.length === 0) continue;
            let NewBASEURL = '';
            if ((area || "").toLowerCase() === "americas") {
                NewBASEURL = process.env.REACT_APP_API_URL_US;
            } else if ((area || "").toLowerCase() === "emeia") {
                NewBASEURL = process.env.REACT_APP_API_URL_EU
            } else if ((area || "").toLowerCase() === "apac") {
                NewBASEURL = process.env.REACT_APP_API_URL_AU
            }

            if (NewBASEURL === process.env.REACT_APP_API_URL_US) {
                postRevokeRequests.push(
                    dispatch(partnersAccessRevokeUS({ "engagementManageRequests": filteredRequests }))
                );
            } else if (NewBASEURL === process.env.REACT_APP_API_URL_EU) {
                postRevokeRequests.push(
                    dispatch(partnersAccessRevokeEU({ "engagementManageRequests": filteredRequests }))
                );
            } else if (NewBASEURL === process.env.REACT_APP_API_URL_AU) {
                postRevokeRequests.push(
                    dispatch(partnersAccessRevokeAU({ "engagementManageRequests": filteredRequests }))
                );
            }


        }
    }

    useEffect(() => {
        if (partnersAccessRevokeData?.status === ApiStatus.SUCCESS) {
            Promise.all(postRevokeRequests);
            GetAccess(checkedEngIds);
            handleMDDialogClose();
            if (delegateAction === 'Revoke' && postRevokeRequests.length > 0) {
                SetManageDelegateMsg(formatRevokeMessage());
                setIsDelegateToastVisible(true);
                setTimeout(() => setIsDelegateToastVisible(false), 3000);
            }
            SetshowManageAccessLoader(false);
            SetDelegateAction('');
        } else if (partnersAccessRevokeData?.status === ApiStatus.ERROR) {
            handleMDDialogClose();
            SetshowManageAccessLoader(false);
            logger.error("One or more access revoke requests failed.", partnersAccessRevokeData?.error);
            SetDelegateAction('');
        }
    }, [partnersAccessRevokeData?.status]);

    const handleRegionChange = (value) => {
        setTargetRegion(value);
        setTargetCountry("");

        // Filter the areaRegionCountryMappings based on the selected region
        const selectedArea = userData?.areaRegionCountryMappings.find(item => item.regionName === value);

        if (selectedArea) {
            setTargetArea(selectedArea.areaName); // Assuming you have a state for areaName
        } else {
            // Handle case where no area is found (optional)
            setTargetArea("");
        }

        setIsSaveEnabled(true);
    };

    const [selectedValue, setValue] = useState([]);
    const [foundUsers, setFoundUsers] = useState([]);
    const userOptions = Array.isArray(foundUsers)
        ? foundUsers.map((user) => ({
            label: user.displayName,
            value: user.status,
            image: user.image,
        }))
        : [];
    const debouncedSearch = debounce(async (query) => {
        const results = await searchGraphUsers(query);
        setFoundUsers(results);

    }, 500);
    const getInitials = (name) => {
        if (name === null) return '';
        const words = name.trim().split(/\s+/);
        if (words.length === 0) return '';
        const first = words[0][0];
        const last = words[words.length - 1][0];
        return (first + last).toUpperCase();
    }

    const handleGridReady = (params) => {
        setGridApi(params.api);
        setGridColumnApi(params.columnApi);
        enforceRightPinnedActionColumns(params.columnApi);
        try {
            const savedFilterModel = savedGridFilterModelRef.current;
            if (savedFilterModel && Object.keys(savedFilterModel).length > 0) {
                params.api.setFilterModel(savedFilterModel);
                params.api.onFilterChanged();
            }
        } catch { }
        try {
            const totalPages = params.api.paginationGetTotalPages?.() || 0;
            if (totalPages > 0) {
                const targetPage = Math.min(persistedGridPageRef.current, Math.max(0, totalPages - 1));
                if (targetPage > 0) {
                    isRestoringGridPageRef.current = true;
                    params.api.paginationGoToPage(targetPage);
                }
            }
        } catch { }
        // Restore tool panel state if previously open
        try {
            const opened = params.api.getOpenedToolPanel && params.api.getOpenedToolPanel();
            if (!opened && toolPanelState.open && toolPanelState.last) {
                params.api.setSideBarVisible(true);
                params.api.openToolPanel(toolPanelState.last);
            }
        } catch { }
    };
    const handleGridPaginationChanged = useCallback((params) => {
        if (!params?.api) return;
        if (isRestoringGridPageRef.current) {
            isRestoringGridPageRef.current = false;
            return;
        }
        if (params?.newData) return;
        persistedGridPageRef.current = params.api.paginationGetCurrentPage?.() || 0;
    }, []);
    // Full option sets for the set-filter columns whose options come from a fixed list rather than the
    // row data. The applied-filter chips read this directly, and each fixed-list column's
    // narrowedSetFilterParams values callback reads it via the grid context, so the popup list and the
    // chip always agree. Columns not listed here (partnerName, transactionType, dataSource, pendingFiles)
    // derive their options from the row data and have no values callback — AG Grid narrows them natively.
    const staticFilterOptionSets = React.useMemo(() => {
        const flatten = (obj, pick = (x) => x) =>
            Object.values(obj || {}).flatMap((arr) => arr.map(pick));
        return buildStaticOptionSets({
            targetRegion: userData?.areaRegionCountryMappings?.map((i) => i.regionName),
            targetCountry: flatten(regionToCountriesMap),
            serviceName: serviceNameOptionsMap,
            competency: competencyOptionsMap,
            practice: flatten(competencyToPracticesMap, (p) => p.name),
            gicsSector: gicsHierarchy?.sectors,
            industryGroup: gicsHierarchy?.industryGroups,
            industry: gicsHierarchy?.industries,
            subindustry: gicsHierarchy?.subIndustries,
            revenueRange: revenueRangeOptionsMap,
        });
    }, [userData, regionToCountriesMap, serviceNameOptionsMap, competencyOptionsMap, competencyToPracticesMap, gicsHierarchy, revenueRangeOptionsMap]);

    const {
        chips: appliedFilterChips,
        onFilterChanged: handleGridFilterChanged,
        removeFilter,
        savedFilterModelRef: savedGridFilterModelRef,
    } = useAppliedFilterChips(staticFilterOptionSets);
    const removeAppliedFilter = (colId) => removeFilter(gridApi, colId);
    const handleSelectionChange = () => {
        const selectedNodes = gridApi?.getSelectedNodes?.();
        const selectedIds = selectedNodes?.map(node => node.data.engagementId) || [];

        setCheckedEngIds(selectedIds);
    };
    const [checkedItems, setCheckedItems] = useState({});

    const handleSelectAllChange = (email, engagements, isChecked) => {
        setCheckedItems((prev) => ({
            ...prev,
            [email]: isChecked ? new Set(engagements) : new Set(),
        }));
    };
    const handleDeleteSelected = (email, mode) => {
        const selectedEngagements = Array.from(checkedItems[email] || []);
        SetSelectedEngagementToRevoke(selectedEngagements);
        SetDeleteOption(mode);
        SetUploaderToDelete(email);
        setOpenMDDialog(true);


    };


    const handleRemoveAll = () => {
        SetDeleteOption('All');
        setOpenMDDialog(true);
    }
    const handleEngCheckboxChange = (email, id, isChecked) => {
        setCheckedItems((prev) => {
            const currentSet = new Set(prev[email] || []);
            if (isChecked) {
                currentSet.add(id);
            } else {
                currentSet.delete(id);
            }
            return {
                ...prev,
                [email]: currentSet,
            };
        });
    };
    const handleMDDialogClose = () => {
        setOpenMDDialog(false);
    }
    const handleMDDialogConfirm = async () => {
        await revokeAccess();

    };

    const [fileStatus, setFileStatus] = useState([]);
    const fileStatusRef = useRef([]);
    const previousFileStatusRef = useRef([]);
    // Track engagements for which we've already triggered a completion refresh to avoid duplicate dispatches
    const completedOnceRef = useRef(new Set());
    const arcPostProcessingPollRef = useRef(new Map());
    const arcTrackedStatusSnapshotRef = useRef(null);

    useEffect(() => {
        fileStatusRef.current = fileStatus;
    }, [fileStatus]);

    useEffect(() => {
        if (!isDataUploadTabActive) return;
        if (!gridApi?.refreshCells) return;
        gridApi.refreshCells({
            columns: ["pendingFiles", "actions", "noOfUploadedFiles"],
            force: true,
        });
    }, [gridApi, uploadPercentage, fileStatus, isDataUploadTabActive]);



    const fetchFileStatus = async () => {
        if (!isDataUploadTabActive) return;
        await apiQueryWithToken.post('api/partners/GetFileProcessedCount', { userEmailId: getAccount()?.username, "isEngagementAdmin": userProfileDetails?.isEngagementAdmin === null ? '' : userProfileDetails?.isEngagementAdmin })
            .then((response) => {
                const statusData = Array.isArray(response?.data)
                    ? response.data
                    : Array.isArray(response?.data?.data)
                        ? response.data.data
                        : [];

                // Store previous status before updating
                previousFileStatusRef.current = Array.isArray(fileStatusRef.current)
                    ? [...fileStatusRef.current]
                    : [];

                setFileStatus(statusData);
                fileStatusRef.current = statusData;
                setProcessedEngagements(
                    statusData.filter(item => Number(item?.totalFileProcessed || 0) === Number(item?.totalFileUploaded || 0)).length
                );
                gridApi?.refreshCells?.({ columns: ["pendingFiles", "actions"], force: true });
            })
            .catch((error) => {
                logger.error("An error occurred:", error);
            });
    };

    useEffect(() => {
        if (!isDataUploadTabActive) return;
        fetchFileStatus();

        const interval = setInterval(() => {
            // Only poll if AddFiles modal is NOT open
            if (isAddFilesOpen === false || isAddFilesOpen === null) {
                const statusList = Array.isArray(fileStatusRef.current) ? fileStatusRef.current : [];
                const shouldRefetch = statusList.some(
                    status => status.totalFileUploaded !== status.totalFileProcessed
                );

                if (shouldRefetch || statusList.length === 0) {
                    fetchFileStatus();
                }
            }
        }, 10000); // Check every 10 seconds 10000

        return () => clearInterval(interval); // Cleanup on unmount
    }, [isAddFilesOpen, isDataUploadTabActive]); // Add isAddFilesOpen as a dependency

    // Detect transitions where an engagement's processed count catches up to uploaded count
    useEffect(() => {
        if (!isDataUploadTabActive) return;
        if (!previousFileStatusRef.current.length) return; // skip on initial load to avoid mass dispatch

        // Build quick lookup of previous status by engagementGuid
        const prevMap = new Map(previousFileStatusRef.current.map(p => [normalizeGuid(getStatusGuid(p)), p]));
        // This effect also re-runs when fileData changes; only a new status snapshot is a real
        // completion transition for ARC tracking.
        const isNewStatusSnapshot = arcTrackedStatusSnapshotRef.current !== fileStatus;
        arcTrackedStatusSnapshotRef.current = fileStatus;
        fileStatus.forEach(curr => {
            const currGuid = normalizeGuid(getStatusGuid(curr));
            const prev = prevMap.get(currGuid);
            const currUploaded = Number(curr?.totalFileUploaded || 0);
            const currProcessed = Number(curr?.totalFileProcessed || 0);
            const prevUploaded = Number(prev?.totalFileUploaded || 0);
            const prevProcessed = Number(prev?.totalFileProcessed || 0);
            const nowComplete = currUploaded > 0 && currProcessed === currUploaded;
            const wasIncomplete = !prev || prevProcessed !== prevUploaded;
            if (!nowComplete || !wasIncomplete) return;
            const row = Array.isArray(fileData)
                ? fileData.find(r => normalizeGuid(r?.engagementId_GUID) === currGuid)
                : undefined;
            // Tracked on every completion (not only the first) so a repeated ARC download in
            // the same session is polled again. Only counts fetched after this point may settle
            // the poll, because the cached record can still hold a pre-processing status.
            if (isNewStatusSnapshot && row?.engagementId_GUID && String(row?.dataSource || "").toUpperCase() === "ARC") {
                arcPostProcessingPollRef.current.set(currGuid, {
                    engagementId_GUID: row.engagementId_GUID,
                    area: row.area,
                    startVersion: Number(uploadCountsRef.current?.[row.engagementId_GUID]?._version || 0),
                });
            }
            if (!completedOnceRef.current.has(currGuid)) {
                completedOnceRef.current.add(currGuid);
                const engagementId = row?.engagementId;
                if (engagementId) {
                    triggerEngagementUpdate(engagementId);
                }
            }
        });
    }, [fileStatus, triggerEngagementUpdate, fileData, isDataUploadTabActive]);

    useEffect(() => {
        if (!isDataUploadTabActive) return;
        const interval = setInterval(() => {
            arcPostProcessingPollRef.current.forEach((entry) => {
                dispatch(partnersUploadCountSingleRequest({
                    engagementId_GUID: entry.engagementId_GUID,
                    area: entry.area,
                }));
            });
        }, ARC_POST_PROCESSING_POLL_INTERVAL_MS);
        return () => clearInterval(interval);
    }, [dispatch, isDataUploadTabActive]);

    useEffect(() => {
        const tracked = arcPostProcessingPollRef.current;
        if (tracked.size === 0) return;
        tracked.forEach((entry, guid) => {
            const rec = uploadCounts[entry.engagementId_GUID];
            if (Number(rec?._version || 0) > entry.startVersion && isArcPostProcessingSettled(rec)) {
                tracked.delete(guid);
            }
        });
    }, [uploadCounts]);
    const regionList = React.useMemo(
        () =>
            Array.from(
                new Set(
                    userData?.areaRegionCountryMappings?.map(item => item.regionName)
                )
            ),
        [userData?.areaRegionCountryMappings]
    );
    const memoizedColumnDefs = React.useMemo(() => columnDefs, [columnDefs]);
    const memoizedFilteredData = React.useMemo(() => filteredData, [filteredData]);
    const dynamicPageSizeSelector = React.useMemo(() => {
        const total = filteredData?.length || 0;
        const base = [8, 20, 50, 100];
        const options = base.filter(size => size < total);
        // Add increments of 1000 between 100 and total
        for (let step = 1000; step < total; step += 1000) {
            if (!options.includes(step)) options.push(step);
        }
        // Always add total as last option (All)
        if (total > 0 && !options.includes(total)) {
            options.push(total);
        }
        return options.length > 0 ? options : [8];
    }, [filteredData?.length]);
    const memoizedRegionList = React.useMemo(() => regionList, [regionList]);
    const memoizedRegionToCountriesMap = React.useMemo(() => regionToCountriesMap, [regionToCountriesMap]);
    const memoizedRevenueRangeOptionsMap = React.useMemo(() => revenueRangeOptionsMap, [revenueRangeOptionsMap]);
    const memoizedSslOptionsMap = React.useMemo(() => sslOptionsMap, [sslOptionsMap]);
    const memoizedServiceNameOptionsMap = React.useMemo(() => serviceNameOptionsMap, [serviceNameOptionsMap]);
    const memoizedCompetenciesMap = React.useMemo(() => competenciesMap, [competenciesMap]);
    const memoizedCompetencyOptionsMap = React.useMemo(() => competencyOptionsMap, [competencyOptionsMap]);
    const memoizedCompetencyToPracticesMap = React.useMemo(() => competencyToPracticesMap, [competencyToPracticesMap]);
    const memoizedAdditionalTagsOptionsMap = React.useMemo(() => additionalTagsOptionsMap, [additionalTagsOptionsMap]);
    const memoizedDefaultColDef = React.useMemo(() => defaultColDef, [defaultColDef]);
    const sideBarConfig = React.useMemo(() => ({
        toolPanels: [
            {
                id: 'columns',
                labelDefault: 'Columns',
                labelKey: 'columns',
                iconKey: 'columns',
                toolPanel: 'agColumnsToolPanel',
                toolPanelParams: {
                    suppressRowGroups: true,
                    suppressValues: true,
                    suppressPivots: true,
                    suppressPivotMode: true,
                },
            },
            'filters',
        ],
    }), []);
    const enforceRightPinnedActionColumns = React.useCallback((columnApi) => {
        if (!columnApi?.applyColumnState) return;
        columnApi.applyColumnState({
            state: [
                { colId: "pendingFiles", pinned: "right" },
                { colId: "actions", pinned: "right" },
            ],
        });
    }, []);
    useEffect(() => {
        // Re-apply saved column state after data/model refreshes to prevent UI resetting
        if (gridColumnApi && savedColumnState && Array.isArray(savedColumnState)) {
            try {
                gridColumnApi.applyColumnState({ state: savedColumnState, applyOrder: true });
                enforceRightPinnedActionColumns(gridColumnApi);
                if (toolPanelState.open && gridApi) {
                    gridApi.setSideBarVisible(true);
                    gridApi.openToolPanel(toolPanelState.last || 'columns');
                }
            } catch { }
        }
    }, [gridColumnApi, savedColumnState, gridApi, memoizedFilteredData, toolPanelState.open, toolPanelState.last, enforceRightPinnedActionColumns]);

    useEffect(() => {
        if (!gridApi) return;
        try {
            const totalPages = gridApi.paginationGetTotalPages?.() || 0;
            if (totalPages <= 0) return;
            const targetPage = Math.min(persistedGridPageRef.current, Math.max(0, totalPages - 1));
            const current = gridApi.paginationGetCurrentPage?.() || 0;
            if (current !== targetPage) {
                isRestoringGridPageRef.current = true;
                gridApi.paginationGoToPage(targetPage);
            }
        } catch { }
    }, [gridApi, memoizedFilteredData]);
    return (
        <>
            <div className="partnerFiles-container partner-upload-page-container">
                <Dialog
                    open={openAlertDialog}
                    onClose={handleAlertDialogClose}
                    aria-labelledby="alert-dialog-title"
                    aria-describedby="alert-dialog-description"
                >
                    <DialogTitle>
                        <IconButton
                            onClick={handleAlertDialogClose}
                            sx={{
                                position: "absolute",
                                right: 8,
                                top: 8,
                            }}
                        >
                            <CloseIcon />
                        </IconButton>
                        <div className="heading">Alert</div>
                    </DialogTitle>
                    <DialogContent dividers className="modal-content">
                        <p>{alertMessage}</p>
                    </DialogContent>
                    <DialogActions>
                        <MotifButton onClick={handleAlertDialogClose} color="primary" autoFocus>
                            Close
                        </MotifButton>
                    </DialogActions>
                </Dialog>

                <Dialog
                    open={isTagsDialogOpen}
                    onClose={() => setIsTagsDialogOpen(false)}
                    aria-labelledby="tags-dialog-title"
                    maxWidth="sm"
                    fullWidth
                >
                    <DialogTitle>
                        <div className="tags-dialog-header">
                            <div>
                                <div className="heading">Edit Additional Tags</div>
                                {tagsDialogRow && (
                                    <div className="tags-dialog-subtitle">
                                        Engagement ID: {tagsDialogRow.engagementId}
                                    </div>
                                )}
                            </div>
                            <IconButton
                                onClick={() => setIsTagsDialogOpen(false)}
                                sx={{ position: "absolute", right: 8, top: 8 }}
                            >
                                <CloseIcon />
                            </IconButton>
                        </div>
                    </DialogTitle>
                    <DialogContent dividers>
                        <div className="tags-dialog-body field">
                            <div className="tags-dialog-label-row">
                                <MotifLabel className="field__label-additional-tags">
                                    Additional tags (upto 15)
                                </MotifLabel>
                                <MotifTooltip
                                    allowClick allowHover closeButtonProps={{}} flip
                                    id="tags-dialog-tooltip" placement="top"
                                    trigger={<MotifIcon style={{ marginLeft: '2px', cursor: 'pointer' }} src={infoIcon} />}
                                    variant="default"
                                >
                                    Additional tags may include sector, industry,<br /> business model, etc. Please ensure no PII or<br /> client identifiers are included.
                                </MotifTooltip>
                            </div>
                            <MotifFormField
                                aria-label="tagsDialogInput"
                                role="group"
                                style={{ position: 'relative' }}
                            >
                                <MotifInput
                                    aria-label="tagsDialogInput"
                                    id="tagsDialogInput"
                                    label="tagsDialogInput"
                                    type="text"
                                    maxLength="501"
                                    placeholder="Enter tags"
                                    hideClearButton={true}
                                    value={tagsDialogInput}
                                    onChange={(e) => {
                                        const value = e.target.value.trimStart().replace(/\s+/g, ' ').replace(/[^a-zA-Z ]/g, '');
                                        setTagsDialogInput(value);
                                        setTagsDialogError('');
                                    }}
                                    onKeyDown={(e) => { if (e.key === 'Enter') { e.preventDefault(); addTagInDialog(); } }}
                                    style={{ paddingRight: '50px' }}
                                />
                                {tagsDialogInput && <MotifButton
                                    onClick={addTagInDialog}
                                    className="tag-button"
                                >
                                    <MotifIcon
                                        src={IconoirCheck}
                                        style={{
                                            width: "20px",
                                            height: "20px",
                                            marginRight: "4px",
                                        }}
                                    />
                                </MotifButton>}
                            </MotifFormField>
                            {tagsDialogError && (
                                <MotifErrorMessage id="tags-dialog-error">{tagsDialogError}</MotifErrorMessage>
                            )}
                            {tagsDialogList.length > 0 && (
                                <div className="tags-dialog-chips-area">
                                    <div className="tags-dialog-chips">
                                        {tagsDialogList.map((tag, index) => (
                                            <div key={index} className="tags-dialog-chip">
                                                <span className="tags-dialog-chip-text" title={tag}>{tag}</span>
                                                <button onClick={() => removeTagInDialog(index)} className="tags-dialog-chip-remove">&times;</button>
                                            </div>
                                        ))}
                                    </div>
                                    <span className="tags-dialog-clear-all" onClick={clearAllTagsInDialog}>Clear all</span>
                                </div>
                            )}
                        </div>
                    </DialogContent>
                    <DialogActions>
                        <MotifButton variant="secondary" onClick={() => setIsTagsDialogOpen(false)}>Cancel</MotifButton>
                        <MotifButton variant="primary" onClick={saveTagsDialog}>Save</MotifButton>
                    </DialogActions>
                </Dialog>

                <Dialog
                    open={openConvertClientDialog}
                    onClose={handleConvertClientDialogClose}
                    aria-labelledby="alert-dialog-title"
                    aria-describedby="alert-dialog-description"
                // className='deleteDialogBox'
                >
                    <DialogTitle>
                        <IconButton
                            onClick={handleConvertClientDialogClose}
                            sx={{
                                position: "absolute",
                                right: 8,
                                top: 8,
                            }}
                        >
                            <CloseIcon />
                        </IconButton>
                        <div className="warning-triangle-container">
                            <img src={require("../../common/images/warning-triangle.png")} alt={"Note"} />
                        </div>
                    </DialogTitle>
                    <DialogContent>
                        <span id="alert-dialog-description">
                            <strong>Convert to Client Engagement?</strong>
                            <p>This will allow selected Engagement(s) to ingest                                Client Data & EY-Owned data. This action cannot be reversed.</p>
                        </span>
                    </DialogContent>
                    <DialogActions>
                        <MotifButton onClick={handleConvertClientDialogClose} color="secondary" variant='secondary' autoFocus>
                            Cancel
                        </MotifButton>
                        <MotifButton onClick={handleConvertClientDialogConfirm} color="primary" autoFocus>
                            Confirm
                        </MotifButton>
                    </DialogActions>
                </Dialog>

                {isConvertToastVisible && (
                    <MotifToast
                        variant={isConvertClientSuccessful && clientConversionMissingIds === '' ? 'success' : 'warning'}
                        className="client-conversion-toast"
                        onClick={() => setIsConvertToastVisible(false)}
                        position="top"
                        style={{ textAlign: 'left' }}
                    >
                        <div style={{ textAlign: 'left' }}>
                            <strong>{isConvertClientSuccessful && clientConversionMissingIds === '' ? 'Converted successfully' : isConvertClientPartialSuccessful || (isConvertClientSuccessful && clientConversionMissingIds !== '') ? 'Partially converted' : 'Conversion failed'}</strong><br />
                            {isConvertClientSuccessful && clientConversionMissingIds === '' ? 'Selected Engagement(s) are converted to Client Data & EY-owned data' : isConvertClientPartialSuccessful || (isConvertClientSuccessful && clientConversionMissingIds !== '') ? `Some Engagement(s) were not converted: ${clientConversionMissingIds}. Please retry.` : 'No Engagement(s) were converted. Please retry.'}
                        </div>
                    </MotifToast>
                )}
                {isEmailReminderToastVisible && (
                    <MotifToast
                        variant={isEmailReminderSuccessful ? 'success' : 'warning'}
                        className="client-conversion-toast"
                        onClick={() => setIsEmailReminderToastVisible(false)}
                        position="top"
                        style={{ textAlign: 'left' }}
                    >
                        <div style={{ textAlign: 'left' }}>
                            <strong>{isEmailReminderSuccessful ? 'Updated successfully' : 'Updation failed'}</strong><br />
                            {isEmailReminderSuccessful ? 'Email reminders are updated for selected Engagement(s)' : 'No Engagement(s) were updated. Please retry.'}
                        </div>
                    </MotifToast>
                )}
                {isContactToastVisible && (
                    <MotifToast
                        variant={isContactToastSuccess ? 'success' : 'warning'}
                        className="client-conversion-toast-ssp"
                        onClick={() => setIsContactToastVisible(false)}
                        position="top"
                        style={{ textAlign: 'left', maxWidth: '400px', right: '1.5rem', left: 'auto' }}
                    >
                        <div style={{ textAlign: 'left' }}>
                            <strong>{isContactToastSuccess ? 'The query has been submitted successfully' : 'Submission failed'}</strong><br />
                            {contactToastMessage}
                        </div>
                    </MotifToast>
                )}
                <Dialog
                    open={isImportModalOpen}
                    onClose={closeImportModal}
                    maxWidth="md"
                    fullWidth
                    aria-labelledby="engagement-import-title"
                >
                    <DialogTitle id="engagement-import-title" style={{ display: "flex", justifyContent: "space-between", alignItems: "center", color: "#2E2E38" }}>
                        Import Engagement
                        <IconButton
                            aria-label="Close"
                            onClick={closeImportModal}
                            size="small"
                            disabled={isImportValidationLoading || isImportApplying}
                        >
                            <CloseIcon fontSize="small" />
                        </IconButton>
                    </DialogTitle>
                    <DialogContent dividers>
                        <div style={{ marginBottom: "0.75rem", color: "#2E2E38" }}>
                            Use exported file to update engagements.
                        </div>
                        <div style={{ marginBottom: "0.75rem", fontSize: "12px" }}>
                            <span style={{ fontWeight: "600" }}>Required columns:</span>
                            <span style={{ color: "#2E2E38" }}>
                                {" "}Target Region, Target Country, Sector, Industry Group, Industry, Sub Industry, Reported Revenue Range.
                            </span>
                        </div>
                        <input
                            type="file"
                            accept=".xlsx,.csv"
                            onChange={onImportFileChange}
                            disabled={isImportValidationLoading || isImportApplying}
                        />
                        {importFile && (
                            <div style={{ marginTop: "0.5rem", fontSize: "12px" }}>
                                <span style={{ fontWeight: "600" }}>Selected file:</span> {importFile.name}
                            </div>
                        )}
                        {importModalError && (
                            <div style={{ marginTop: "0.75rem" }}>
                                <MotifErrorMessage>{importModalError}</MotifErrorMessage>
                            </div>
                        )}

                        {importValidationResult?.summary && !importProcessResult?.summary && (
                            <div style={{ marginTop: "1rem", fontSize: "12px", border: "1px solid #d8d8de", padding: "10px", borderRadius: "4px" }}>
                                <div style={{ fontWeight: "600" }}>Validation Summary</div>
                                <div><span style={{ fontWeight: "600" }}>Total rows:</span> {importValidationResult.summary.totalRecords}</div>
                                <div><span style={{ fontWeight: "600" }}>Ready to import:</span> {importValidationResult.summary.validRecords}</div>
                                <div><span style={{ fontWeight: "600" }}>Errors:</span> {importValidationResult.summary.errorRecords}</div>
                            </div>
                        )}

                        {importValidationResult?.failedRows?.length > 0 && !importProcessResult?.summary && (
                            <div style={{ marginTop: "0.75rem", border: "1px solid #d8d8de", padding: "10px", borderRadius: "4px" }}>
                                <div style={{ fontWeight: "600", marginBottom: "0.5rem" }}>Validation Errors</div>
                                <div style={{ maxHeight: "220px", overflowY: "auto", overflowX: "auto", position: "relative" }}>
                                    <table style={{ width: "100%", borderCollapse: "separate", borderSpacing: 0, fontSize: "12px" }}>
                                        <thead style={{ position: "sticky", top: 0, zIndex: 3 }}>
                                            <tr>
                                                <th
                                                    style={{
                                                        border: "1px solid #d8d8de",
                                                        padding: "6px",
                                                        textAlign: "left",
                                                        backgroundColor: "#f5f5f7",
                                                        fontWeight: "600",
                                                        whiteSpace: "nowrap",
                                                        position: "sticky",
                                                        top: 0,
                                                        zIndex: 4,
                                                        boxShadow: "0 1px 0 #d8d8de",
                                                    }}
                                                >
                                                    Engagement ID
                                                </th>
                                                <th
                                                    style={{
                                                        border: "1px solid #d8d8de",
                                                        padding: "6px",
                                                        textAlign: "left",
                                                        backgroundColor: "#f5f5f7",
                                                        fontWeight: "600",
                                                        minWidth: "220px",
                                                        position: "sticky",
                                                        top: 0,
                                                        zIndex: 4,
                                                        boxShadow: "0 1px 0 #d8d8de",
                                                    }}
                                                >
                                                    Validation Message
                                                </th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {importValidationResult.failedRows.map((item) => (
                                                <tr key={`${item.rowNumber}-${item.engagementId || "na"}`}>
                                                    <td style={{ border: "1px solid #d8d8de", padding: "6px", verticalAlign: "top" }}>
                                                        {String(item?.engagementId || item?.row?.engagementId || "")}
                                                    </td>
                                                    <td style={{ border: "1px solid #d8d8de", padding: "6px", verticalAlign: "top" }}>
                                                        {`Row ${item.rowNumber}: ${(item.errors || []).join(" | ")}`}
                                                    </td>
                                                </tr>
                                            ))}
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                        )}

                        {importProcessResult?.summary && (
                            <div style={{ marginTop: "1rem", fontSize: "12px", border: "1px solid #d8d8de", padding: "10px", borderRadius: "4px" }}>
                                <div style={{ fontWeight: "600" }}>Import Summary</div>
                                <div><span style={{ fontWeight: "600" }}>Total rows:</span> {importProcessResult.summary.totalRows}</div>
                                <div><span style={{ fontWeight: "600" }}>Imported:</span> {importProcessResult.summary.importedRows}</div>
                                <div><span style={{ fontWeight: "600" }}>Failed:</span> {importProcessResult.summary.failedRows}</div>
                            </div>
                        )}
                        {importProcessResult?.logs?.length > 0 && (
                            <div style={{ marginTop: "0.75rem", border: "1px solid #d8d8de", padding: "10px", borderRadius: "4px" }}>
                                <div style={{ fontWeight: "600", marginBottom: "0.5rem" }}>Import Log</div>
                                <div style={{ maxHeight: "180px", overflowY: "auto", overflowX: "auto", position: "relative" }}>
                                    <table style={{ width: "100%", borderCollapse: "separate", borderSpacing: 0, fontSize: "12px" }}>
                                        <thead style={{ position: "sticky", top: 0, zIndex: 3 }}>
                                            <tr>
                                                <th style={{ border: "1px solid #d8d8de", padding: "6px", textAlign: "left", backgroundColor: "#f5f5f7", fontWeight: "600", whiteSpace: "nowrap", position: "sticky", top: 0, zIndex: 4, boxShadow: "0 1px 0 #d8d8de" }}>
                                                    Status
                                                </th>
                                                <th style={{ border: "1px solid #d8d8de", padding: "6px", textAlign: "left", backgroundColor: "#f5f5f7", fontWeight: "600", whiteSpace: "nowrap", position: "sticky", top: 0, zIndex: 4, boxShadow: "0 1px 0 #d8d8de" }}>
                                                    Row Number
                                                </th>
                                                <th style={{ border: "1px solid #d8d8de", padding: "6px", textAlign: "left", backgroundColor: "#f5f5f7", fontWeight: "600", whiteSpace: "nowrap", position: "sticky", top: 0, zIndex: 4, boxShadow: "0 1px 0 #d8d8de" }}>
                                                    Engagement ID
                                                </th>
                                                <th style={{ border: "1px solid #d8d8de", padding: "6px", textAlign: "left", backgroundColor: "#f5f5f7", fontWeight: "600", minWidth: "240px", position: "sticky", top: 0, zIndex: 4, boxShadow: "0 1px 0 #d8d8de" }}>
                                                    Message
                                                </th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {importProcessResult.logs.slice(0, 25).map((item, index) => (
                                                <tr key={`${item.rowNumber}-${item.engagementId || "na"}-${index}`}>
                                                    <td style={{ border: "1px solid #d8d8de", padding: "6px", verticalAlign: "top" }}>
                                                        {String(item?.status || "")}
                                                    </td>
                                                    <td style={{ border: "1px solid #d8d8de", padding: "6px", verticalAlign: "top" }}>
                                                        {String(item?.rowNumber ?? "")}
                                                    </td>
                                                    <td style={{ border: "1px solid #d8d8de", padding: "6px", verticalAlign: "top" }}>
                                                        {String(item?.engagementId || "N/A")}
                                                    </td>
                                                    <td style={{ border: "1px solid #d8d8de", padding: "6px", verticalAlign: "top" }}>
                                                        {String(item?.message || "")}
                                                    </td>
                                                </tr>
                                            ))}
                                        </tbody>
                                    </table>
                                </div>
                                {importProcessResult.logs.length > 25 && (
                                    <div style={{ fontSize: "12px", color: "#2E2E38" }}>
                                        ... {importProcessResult.logs.length - 25} more log entries.
                                    </div>
                                )}
                            </div>
                        )}
                    </DialogContent>
                    <DialogActions>
                        <MotifButton variant="secondary" onClick={closeImportModal} disabled={isImportValidationLoading || isImportApplying}>
                            Close
                        </MotifButton>
                        <MotifButton
                            variant="secondary"
                            onClick={handleValidateImportFile}
                            disabled={!importFile || isImportValidationLoading || isImportApplying || isImportCompleted}
                        >
                            {isImportValidationLoading ? "Validating..." : "Validate"}
                        </MotifButton>
                        <MotifButton
                            variant="secondary"
                            onClick={handleImportSummaryDownload}
                            disabled={!importProcessResult?.logs?.length}
                        >
                            Download Summary
                        </MotifButton>
                        <MotifButton
                            variant="primary"
                            onClick={handleApplyImportFile}
                            disabled={!importFile || isImportValidationLoading || isImportApplying || isImportCompleted}
                        >
                            {isImportApplying ? "Importing..." : "Import"}
                        </MotifButton>
                    </DialogActions>
                </Dialog>

                {filteredData && (
                    <div className="grid-wrapper partner-upload-layout">
                        {showOutageToast && (
                            <OutageToast
                                onClose={() => {
                                    outageDismissedRef.current = true;
                                    setShowOutageToast(false);
                                }}
                                message={outageInfo?.message}
                                supportingMessage={outageInfo?.supportingMessage}
                                outageStartsUtc={outageInfo?.outageStartsUtc}
                                outageEndsUtc={outageInfo?.outageEndsUtc}
                            />
                        )}
                        <div className={activeTab === "dataUpload" ? "partner-tabs data-upload-active" : "partner-tabs"}>
                            <div className="partner-tab-group" role="tablist" aria-label="Partner upload tabs">
                                {canAccessEngagementQualification && (
                                    <button
                                        type="button"
                                        className={activeTab === "engagementQualification" ? "partner-tab active" : "partner-tab"}
                                        onClick={() => setActiveTab("engagementQualification")}
                                        role="tab"
                                        aria-selected={activeTab === "engagementQualification"}
                                    >
                                        Engagement Qualification
                                    </button>
                                )}
                                <button
                                    type="button"
                                    className={activeTab === "dataUpload" ? "partner-tab active" : "partner-tab"}
                                    onClick={() => setActiveTab("dataUpload")}
                                    role="tab"
                                    aria-selected={activeTab === "dataUpload"}
                                >
                                    Data Upload
                                </button>
                            </div>
                            {canAccessEngagementQualification && activeTab === "engagementQualification" && <MotifButton
                                variant='secondary'
                                className="contact-us-btn"
                                onClick={openContactUs}

                            >
                                <img
                                    loading='lazy'
                                    src={require("../../common/images/contact-us.png")}
                                    color="Secondary"
                                    autoFocus
                                    className='contact-us-icon'
                                />
                                Contact Us
                            </MotifButton>
                            }
                            {activeTab === "dataUpload" && (
                                <div className="partner-tabs-search">
                                    <MotifFormField>
                                        <MotifSearch
                                            aria-label="Search engagements"
                                            onChange={(event) => onFilterTextBoxChanged(event.target?.value)}
                                            placeholder="Search"
                                            value={searchValue}
                                        />
                                    </MotifFormField>
                                </div>
                            )}
                            <Dialog
                                open={isContactUsOpen}
                                onClose={closeContactUs}
                                className="contact-us-dialog"
                                aria-labelledby="contact-us-title"
                            >
                                <DialogTitle id="contact-us-title" className="contact-us-title">
                                    Contact Support
                                    <IconButton
                                        aria-label="Close"
                                        onClick={closeContactUs}
                                        className="contact-us-close"
                                        size="small"
                                    >
                                        <CloseIcon fontSize="small" />
                                    </IconButton>
                                </DialogTitle>
                                <DialogContent className="contact-us-content">
                                    <div className="contact-us-options">
                                        <label className={`contact-us-option ${contactMethod === 'email' ? 'selected' : ''}`}>
                                            <img
                                                loading='lazy'
                                                src={require("../../common/images/contact-us-mail.png")}
                                                color="Secondary"
                                                autoFocus
                                                className='contact-us-option-icon'
                                            />
                                            <div className="contact-us-option-text">
                                                <span className="contact-us-option-title">E-mail</span>
                                                <span className="contact-us-option-subtitle">Request e-mail support</span>
                                            </div>
                                            <input
                                                type="radio"
                                                name="contactMethod"
                                                value="email"
                                                checked={contactMethod === 'email'}
                                                onChange={() => setContactMethod('email')}
                                            />
                                        </label>
                                        <label className={`contact-us-option ${contactMethod === 'call' ? 'selected' : ''}`}>
                                            <img
                                                loading='lazy'
                                                src={require("../../common/images/phone.png")}
                                                color="Secondary"
                                                autoFocus
                                                className='contact-us-option-icon'
                                            />
                                            <div className="contact-us-option-text">
                                                <span className="contact-us-option-title">Call</span>
                                                <span className="contact-us-option-subtitle">Request a call</span>
                                            </div>
                                            <input
                                                type="radio"
                                                name="contactMethod"
                                                value="call"
                                                checked={contactMethod === 'call'}
                                                onChange={() => setContactMethod('call')}
                                            />
                                        </label>
                                    </div>
                                    <textarea
                                        id="contact-us-notes"
                                        className="contact-us-notes"
                                        rows={3}
                                        value={contactNotes}
                                        onChange={(event) => setContactNotes(event.target.value)}
                                        placeholder=" Please specify support required"
                                        disabled={isContactSubmitting || !contactMethod}
                                    />
                                    {/* <div className="contact-us-country">Country: {contactCountry || userProfileDetails?.country || '-'}</div> */}
                                </DialogContent>
                                <DialogActions className="contact-us-actions">
                                    <MotifButton variant="secondary" onClick={closeContactUs} disabled={isContactSubmitting}>
                                        Cancel
                                    </MotifButton>
                                    <MotifButton
                                        variant="primary"
                                        onClick={handleContactSubmit}
                                        disabled={!contactMethod || !contactNotes.trim() || isContactSubmitting}
                                    >
                                        {isContactSubmitting ? 'Submitting...' : 'Submit'}
                                    </MotifButton>
                                </DialogActions>
                            </Dialog>


                        </div>

                        {canAccessEngagementQualification && activeTab === "engagementQualification" ? (
                            <div className="engagement-qualification-panel" role="tabpanel">
                                <EngagementQualification isEngagementAdmin={userProfileDetails?.isEngagementAdmin} />
                            </div>
                        ) : (
                            <div className="data-upload-panel">
                                <TableHeader
                                    onFilterTextBoxChanged={onFilterTextBoxChanged}
                                    searchValue={searchValue}
                                    navigation={navigation}
                                    engagementIdList={engagementIdList}
                                    manageAccess={manageAccess}

                                    isDisabled={checkedEngIds.length < 1}
                                    callingFrom={"partnerPage"}
                                    isConvertClientDisabled={
                                        checkedEngIds.length < 1 ||
                                        userProfileDetails?.isEngagementAdmin === false ||
                                        userProfileDetails?.isEngagementAdmin === null ||
                                        // Disable if any checked engagement already has clientData === true
                                        (checkedEngIds.some(id =>
                                            (utilityData?.data ?? []).some(item => item.engagementId === id && item.clientData === true)
                                        ))
                                    }
                                    convertClientEngagement={convertClientEngagement}
                                    toggleChecked={toggleChecked}
                                    isEngagementAdmin={userProfileDetails?.isEngagementAdmin}
                                    passwordReminder={passwordReminder}
                                    showExportExcel
                                    openExportExcel={handleEditableEngagementExport}
                                    isExportExcelLoading={isEditableExportLoading}
                                    isExportExcelDisabled={checkedEngIds.length < 1}
                                    showImportExcel
                                    openImportExcel={openImportModal}
                                    isImportExcelLoading={isImportApplying}
                                    showSearch={false}
                                    showDescription
                                    showDownloadFiles
                                    isDownloadFilesEnabled={canBulkDownloadArc}
                                    openDownloadFiles={startBulkArcDownload}
                                />

                                <AppliedFilterChips chips={appliedFilterChips} onRemove={removeAppliedFilter} />

                                <div className="grid-container">
                                    <div className={"ag-theme-quartz grid-container-inner inline-edit-cursor--text"}>
                                        <div className="data-upload-content">

                                                <div className="motif-table-wrap">
                                                    <div className="table-container">


                                                        {/* <div className="fixed-column">
                                                <MotifTable


                                                    columnDefs={fixedColumns} // First column
                                                    variant="alt"
                                                    description="Descriptive text that describes your page or content."
                                                    name="Default"
                                                    paginationPageSize={10}
                                                    paginationPageSizeSelector={[3, 4, 5]}
                                                    rowData={paginatedData}
                                                    zebra={false}
                                                    rowSelection="multiple"
                                                    onGridReady={handleGridReady}
                                                    onSelectionChanged={handleSelectionChange}
                                                    suppressRowClickSelection={true}
                                                    getRowClass={() => ''}

                                                />
                                            </div> */}
                                                        {/* <div className="scrollable-columns"> */}


                                                        {/* </div> */}
                                                        {/* <div className="fixed-column right">
                                                <MotifTable
                                                    columnDefs={lastTwoColumns} // Last two columns
                                                    variant="alt"
                                                    description="Descriptive text that describes your page or content."
                                                    name="Default"
                                                    paginationPageSize={10}
                                                    paginationPageSizeSelector={[3, 4, 5]}
                                                    rowData={paginatedData}
                                                    zebra={false}
                                                />
                                            </div> */}
                                                        <div className="scrollable-columns">
                                                            <AgGridReact
                                                                columnDefs={memoizedColumnDefs}
                                                                rowData={memoizedFilteredData}
                                                                defaultColDef={memoizedDefaultColDef}
                                                                floatingFilter={false}
                                                                suppressMenuHide={true}
                                                                sideBar={sideBarConfig}
                                                                pagination={true}
                                                                paginationPageSize={8}
                                                                paginationPageSizeSelector={dynamicPageSizeSelector}
                                                                rowSelection="multiple"
                                                                suppressRowClickSelection={true}
                                                                enableBrowserTooltips={false}
                                                                tooltipShowMode={'whenTruncated'}
                                                                tooltipShowDelay={0}
                                                                tooltipHideDelay={60000}
                                                                getRowHeight={getRowHeight}
                                                                headerHeight={44}
                                                                singleClickEdit={true}
                                                                suppressHorizontalScroll={false}
                                                                alwaysShowHorizontalScroll={false}
                                                                suppressScrollOnNewData={true}
                                                                onGridReady={handleGridReady}
                                                                onPaginationChanged={handleGridPaginationChanged}
                                                                onColumnPinned={(event) => {
                                                                    try { setSavedColumnState(event?.columnApi?.getColumnState?.()); } catch { }
                                                                }}
                                                                onColumnMoved={(event) => {
                                                                    try { setSavedColumnState(event?.columnApi?.getColumnState?.()); } catch { }
                                                                }}
                                                                onColumnVisible={(event) => {
                                                                    try { setSavedColumnState(event?.columnApi?.getColumnState?.()); } catch { }
                                                                }}
                                                                onToolPanelVisibleChanged={() => {
                                                                    try {
                                                                        const opened = gridApi?.getOpenedToolPanel?.();
                                                                        setToolPanelState(prev => ({
                                                                            open: !!opened,
                                                                            last: opened || prev.last || 'columns'
                                                                        }));
                                                                    } catch { }
                                                                }}
                                                                context={{
                                                                    regionList: memoizedRegionList,
                                                                    regionToCountriesMap: memoizedRegionToCountriesMap,
                                                                    gicsHierarchy: gicsHierarchy,
                                                                    revenueRangeOptionsMap: memoizedRevenueRangeOptionsMap,
                                                                    serviceNameOptionsMap: memoizedServiceNameOptionsMap,
                                                                    competenciesMap: memoizedCompetenciesMap,
                                                                    competencyOptionsMap: memoizedCompetencyOptionsMap,
                                                                    competencyToPracticesMap: memoizedCompetencyToPracticesMap,
                                                                    additionalTagsOptionsMap: memoizedAdditionalTagsOptionsMap,
                                                                    staticFilterOptionSets: staticFilterOptionSets
                                                                }}
                                                                suppressReactUi={false}
                                                                suppressNoRowsOverlay={true}
                                                                // Prevent table from re-rendering/fluctuating on uploadCounts/api changes
                                                                immutableData={true}
                                                                getRowId={params => params.data?.engagementId_GUID || params.data?.engagementId}
                                                                onSelectionChanged={onSelectionChanged}
                                                                onFilterChanged={handleGridFilterChanged}
                                                                getRowClass={getRowClass}
                                                                getContextMenuItems={() => [
                                                                    'copy',
                                                                ]}
                                                    />
                                                        </div>
                                                    </div>

                                                    {/* <MotifPagination
                                                allowInput
                                                aria-label="Pagination Navigation"
                                                currentPage={currentPage}
                                                firstButtonProps={{ title: 'Go to first page' }}
                                                lastButtonProps={{ title: 'Go to last page' }}
                                                max={Math.ceil(filteredData.length / rowsPerPage)}
                                                min={1}
                                                nextButtonProps={{ title: 'Go to next page' }}
                                                onPageChange={handlePageChange}
                                                prevButtonProps={{ title: 'Go to previous page' }}
                                                role="navigation"
                                                className="motif-pagination" // Add a class for styling
                                            /> */}


                                                </div>
                                                <Dialog
                                                    onClose={onEditModalClose}
                                                    open={isEditModalOpen}
                                                    className={
                                                        dialogMode === "submit"
                                                            ? ""
                                                            : dialogMode === "manageaccess" ? "manage-access" : dialogMode === "passwordReminder" ? "password-reminder" : "edit-dialog"
                                                    }


                                                >
                                                    <DialogTitle>
                                                        {dialogMode === "addTargetCompany" && <div className="heading">{`Add Target Company Info`}</div>}
                                                        {dialogMode === "addClientCompany" && <div className="heading">{`Add Client Company Info`}</div>}
                                                        {dialogMode === "edit" && <div className="heading">{`Update Engagement`}</div>}
                                                        {dialogMode !== "submit" && dialogMode !== "manageaccess" && dialogMode !== "passwordReminder" && <div className="ey-data-container-submit">{`Engagement Id : ${engagementId}`}</div>}
                                                        {dialogMode == "submit" && dialogMode === "manageaccess" && <div className="ey-data-container-submit">{`Note`}</div>}
                                                        {dialogMode === "manageaccess" && (
                                                            <>
                                                                <div className="heading">Manage Access</div>
                                                                <div className="ey-data-container-manage-access">Engagement ID: {checkedEngIds.join(", ")}</div>
                                                            </>
                                                        )}
                                                        {
                                                            dialogMode === "passwordReminder" &&
                                                            <div className="heading">
                                                                <div className="password-reminder-icon">
                                                                    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
                                                                        <path fillRule="evenodd" clipRule="evenodd" d="M9.61617 3.64141C10.6736 1.80247 13.3268 1.80247 14.3841 3.64141L22.4271 17.6291C23.4813 19.4625 22.1579 21.7499 20.0431 21.7499H3.95721C1.84242 21.7499 0.519055 19.4625 1.57322 17.6291L9.61617 3.64141ZM13.0838 4.38912C12.6032 3.55324 11.3972 3.55324 10.9165 4.38912L2.87358 18.3769C2.39441 19.2102 2.99594 20.2499 3.95721 20.2499H20.0431C21.0044 20.2499 21.6059 19.2102 21.1267 18.3769L13.0838 4.38912Z" fill="#dc8624ff" />
                                                                        <path fillRule="evenodd" clipRule="evenodd" d="M12.0002 8.24994C12.4144 8.24994 12.7502 8.58573 12.7502 8.99994V12.9999C12.7502 13.4142 12.4144 13.7499 12.0002 13.7499C11.5859 13.7499 11.2502 13.4142 11.2502 12.9999V8.99994C11.2502 8.58573 11.5859 8.24994 12.0002 8.24994Z" fill="#dc8624ff" />
                                                                        <path fillRule="evenodd" clipRule="evenodd" d="M12.5119 16.4414C12.8198 16.7185 12.8447 17.1927 12.5676 17.5006L12.5576 17.5117C12.2805 17.8195 11.8063 17.8445 11.4984 17.5674C11.1906 17.2903 11.1656 16.8161 11.4427 16.5082L11.4527 16.4971C11.7298 16.1892 12.204 16.1643 12.5119 16.4414Z" fill="#dc8624ff" />
                                                                    </svg>
                                                                </div>
                                                            </div>
                                                        }

                                                    </DialogTitle>

                                                    <IconButton
                                                        onClick={() => { setIsFormDirty(false); onEditModalClose(null, 'buttonClick') }}
                                                        sx={{
                                                            position: "absolute",
                                                            right: 8,
                                                            top: 8,
                                                        }}
                                                    >
                                                        <CloseIcon />
                                                    </IconButton>

                                                    <DialogContent dividers className="modal-content" style={dialogMode === "manageaccess" ? { minHeight: '400px' } : dialogMode === "passwordReminder" ? { minHeight: '125px', borderTop: 'none', borderBottom: 'none', marginTop: '-15px' } : {}}>     <span>
                                                        {dialogMode === "edit" && <p>Please provide below details to Add files </p>}
                                                        {dialogMode === "addTargetCompany" && <p>Please provide below details</p>}
                                                        {dialogMode === "addClientCompany" && <p>Please provide below details </p>}
                                                        {dialogMode === "passwordReminder" && <strong style={{ fontWeight: 500 }}>Email Reminder</strong>}
                                                    </span>
                                                        <div className="first-step">
                                                            {/* Area, Region, Country Fields for Add Target Company */}
                                                            {(dialogMode === "addTargetCompany" || (dialogMode === "edit" && transactionType?.toLowerCase() === "buy-side")) && (
                                                                <>
                                                                   

                                                                    <div className="field">
                                                                        <MotifLabel>{(dialogMode === "addTargetCompany" || (dialogMode === "edit" && transactionType?.toLowerCase() === "buy-side")) ? `Target Super Region` : `Super Region`} <img src={require("../../../src/common/images/asterisk.png")} alt="" /></MotifLabel>
                                                                        <MotifFormField key={"region"}>
                                                                            {userData?.regions?.length > 0 && (
                                                                                <MotifSelect
                                                                                    key={targetRegion}
                                                                                    ariaLabelledBy="select-label"
                                                                                    // onChange={(value) => {
                                                                                    //     setTargetRegion(value);
                                                                                    //     setTargetCountry("");
                                                                                    //     setIsSaveEnabled(true);
                                                                                    // }}
                                                                                    onChange={handleRegionChange}
                                                                                    placeholder="Select"
                                                                                    value={targetRegion ? targetRegion : ""}
                                                                                    triggerButtonProps={{
                                                                                        "aria-describedby": "select-error-reactive",
                                                                                    }}
                                                                                >
                                                                                    {(() => {
                                                                                        const uniqueRegions = new Set();
                                                                                        userData?.areaRegionCountryMappings
                                                                                            // ?.filter((areas) => areas.areaName === targetArea)
                                                                                            .forEach((item) => uniqueRegions.add(item.regionName));

                                                                                        return Array.from(uniqueRegions).sort().map((regionName) => (
                                                                                            <MotifOption key={regionName} value={regionName}>
                                                                                                {regionName}
                                                                                            </MotifOption>
                                                                                        ));
                                                                                    })()}
                                                                                </MotifSelect>
                                                                            )}
                                                                        </MotifFormField>
                                                                    </div>

                                                                    <div className="field">
                                                                        <MotifLabel>
                                                                            {(dialogMode === "addTargetCompany" || (dialogMode === "edit" && transactionType?.toLowerCase() === "buy-side")) ? `Target Country` : `Country`}
                                                                            <img src={require("../../../src/common/images/asterisk.png")} alt="" />
                                                                        </MotifLabel>
                                                                        <MotifFormField key={"country"}>
                                                                            {userData?.countries?.length > 0 && (
                                                                                <MotifSelect
                                                                                    key={targetCountry}
                                                                                    ariaLabelledBy="select-label"
                                                                                    onChange={(value) => { setTargetCountry(value); setIsSaveEnabled(true); setIsFormDirty(true) }}
                                                                                    placeholder="Select"
                                                                                    value={targetCountry ? targetCountry : ""}
                                                                                    triggerButtonProps={{
                                                                                        "aria-describedby": "select-error-reactive",
                                                                                    }}
                                                                                >
                                                                                    {Array.from(new Set(userData?.areaRegionCountryMappings
                                                                                        ?.filter((country) => country.regionName === targetRegion)
                                                                                        .map((item) => item.countryName)))
                                                                                        .sort((a, b) => a.localeCompare(b))
                                                                                        .map((countryName) => (
                                                                                            <MotifOption key={countryName} value={countryName}>
                                                                                                {countryName}
                                                                                            </MotifOption>
                                                                                        ))}
                                                                                </MotifSelect>
                                                                            )}
                                                                        </MotifFormField>
                                                                    </div>
                                                                   
                                                                </>
                                                            )}
                                                            {/* Sector, Industry Group, Industry, Sub Industry, Revenue Range Fields for Add Client Company and Edit */}
                                                            {(dialogMode === "addClientCompany" || dialogMode === "edit" || dialogMode === "addTargetCompany") && (
                                                                <>
                                                                    <div className="field">
                                                                        <MotifLabel>{`${gicsLabelPrefix}Sector`} <img src={require("../../../src/common/images/asterisk.png")} alt="" /></MotifLabel>
                                                                        <MotifFormField key={"sector"}>
                                                                            {gicsSectorOptions.length > 0 && (
                                                                                <MotifSelect
                                                                                    key={sectorId}
                                                                                    ariaLabelledBy="select-label"
                                                                                    onChange={(value) => {
                                                                                        const selectedSector = gicsSectorOptions.find(item => item.id === value);
                                                                                        if (selectedSector) {
                                                                                            setSectorName(selectedSector.name);
                                                                                        }
                                                                                        value !== sectorId && setIsSaveEnabled(true);
                                                                                        setSectorId(value);
                                                                                        setIndustryGroupId(0);
                                                                                        setIndustryGroupName("");
                                                                                        setIndustryId(0);
                                                                                        setIndustryName("");
                                                                                        setSubIndustryId(0);
                                                                                        setSubIndustryName("");
                                                                                    }}
                                                                                    placeholder="Select"
                                                                                    value={sectorId ? sectorId : ""}
                                                                                    triggerButtonProps={{
                                                                                        "aria-describedby": "select-error-reactive",
                                                                                    }}
                                                                                >
                                                                                    {gicsSectorOptions.map((item) => (
                                                                                        <MotifOption key={item.id} value={item.id}>
                                                                                            {item.name}
                                                                                        </MotifOption>
                                                                                    ))}
                                                                                </MotifSelect>
                                                                            )}
                                                                        </MotifFormField>
                                                                    </div>

                                                                    {/* Industry Group Selection */}
                                                                    <div className="field">
                                                                        <MotifLabel>{`${gicsLabelPrefix}Industry Group`} <img src={require("../../../src/common/images/asterisk.png")} alt="" /></MotifLabel>
                                                                        <MotifFormField key={"industryGroup"}>
                                                                            <MotifSelect
                                                                                key={`${sectorId}-${industryGroupId}`}
                                                                                ariaLabelledBy="select-label"
                                                                                onChange={(value) => {
                                                                                    const selectedIndustryGroup = gicsIndustryGroupOptions.find(item => item.id === value);
                                                                                    if (selectedIndustryGroup) {
                                                                                        setIndustryGroupName(selectedIndustryGroup.name);
                                                                                    }
                                                                                    value !== industryGroupId && setIsSaveEnabled(true);
                                                                                    setIndustryGroupId(value);
                                                                                    setIndustryId(0);
                                                                                    setIndustryName("");
                                                                                    setSubIndustryId(0);
                                                                                    setSubIndustryName("");
                                                                                }}
                                                                                placeholder="Select"
                                                                                value={industryGroupId ? industryGroupId : ""}
                                                                                disabled={!sectorId}
                                                                                triggerButtonProps={{
                                                                                    "aria-describedby": "select-error-reactive",
                                                                                }}
                                                                            >
                                                                                {gicsIndustryGroupOptions.map((item) => (
                                                                                    <MotifOption key={item.id} value={item.id}>
                                                                                        {item.name}
                                                                                    </MotifOption>
                                                                                ))}
                                                                            </MotifSelect>
                                                                        </MotifFormField>
                                                                    </div>

                                                                    {/* Industry Selection */}
                                                                    <div className="field">
                                                                        <MotifLabel>{`${gicsLabelPrefix}Industry`} <img src={require("../../../src/common/images/asterisk.png")} alt="" /></MotifLabel>
                                                                        <MotifFormField key={"industry"}>
                                                                            <MotifSelect
                                                                                key={`${industryGroupId}-${industryId}`}
                                                                                ariaLabelledBy="select-label"
                                                                                onChange={(value) => {
                                                                                    const selectedIndustry = gicsIndustryOptions.find(item => item.id === value);
                                                                                    if (selectedIndustry) {
                                                                                        setIndustryName(selectedIndustry.name);
                                                                                    }
                                                                                    value !== industryId && setIsSaveEnabled(true);
                                                                                    setIndustryId(value);
                                                                                    setSubIndustryId(0);
                                                                                    setSubIndustryName("");
                                                                                }}
                                                                                placeholder="Select"
                                                                                value={industryId ? industryId : ""}
                                                                                disabled={!industryGroupId}
                                                                                triggerButtonProps={{
                                                                                    "aria-describedby": "select-error-reactive",
                                                                                }}
                                                                            >
                                                                                {gicsIndustryOptions.map((item) => (
                                                                                    <MotifOption key={item.id} value={item.id}>
                                                                                        {item.name}
                                                                                    </MotifOption>
                                                                                ))}
                                                                            </MotifSelect>
                                                                        </MotifFormField>
                                                                    </div>

                                                                    {/* Sub Industry Selection */}
                                                                    <div className="field">
                                                                        <MotifLabel>{`${gicsLabelPrefix}Sub Industry`} <img src={require("../../../src/common/images/asterisk.png")} alt="" /></MotifLabel>
                                                                        <MotifFormField key={"subIndustry"}>
                                                                            <MotifSelect
                                                                                key={`${industryId}-${subIndustryId}`}
                                                                                ariaLabelledBy="select-label"
                                                                                onChange={(value) => {
                                                                                    setIsFormDirty(true)
                                                                                    const selectedSubIndustry = gicsSubIndustryOptions.find(item => item.id === value);
                                                                                    if (selectedSubIndustry) {
                                                                                        setSubIndustryName(selectedSubIndustry.name);
                                                                                    }
                                                                                    value !== subIndustryId && setIsSaveEnabled(true);
                                                                                    setSubIndustryId(value);
                                                                                }}
                                                                                placeholder="Select"
                                                                                value={subIndustryId ? subIndustryId : ""}
                                                                                disabled={!industryId}
                                                                                triggerButtonProps={{
                                                                                    "aria-describedby": "select-error-reactive",
                                                                                }}
                                                                            >
                                                                                {gicsSubIndustryOptions.map((item) => (
                                                                                    <MotifOption key={item.id} value={item.id}>
                                                                                        {item.name}
                                                                                    </MotifOption>
                                                                                ))}
                                                                            </MotifSelect>
                                                                        </MotifFormField>
                                                                    </div>

                                                                    {/* Revenue Range Selection */}
                                                                    <div className="field">
                                                                        <MotifLabel>{(dialogMode === "addTargetCompany" || (dialogMode === "edit" && transactionType?.toLowerCase() === "buy-side")) ? `Target Reported Revenue Range ` : `Reported Revenue Range `}
                                                                        </MotifLabel>
                                                                        <MotifTooltip
                                                                            allowClick
                                                                            allowHover
                                                                            closeButtonProps={{}}
                                                                            flip
                                                                            id="tooltip"
                                                                            placement="auto"
                                                                            trigger={<MotifIcon src={infoIcon} />}
                                                                            variant="default"
                                                                        >
                                                                            Select the reported revenue in USD<br /> for the target or business for the<br /> most recent fiscal year.
                                                                        </MotifTooltip>
                                                                        <img src={require("../../../src/common/images/asterisk.png")} alt="" />

                                                                        <MotifFormField key={"marketSize"}>
                                                                            {userData?.revenueRanges?.length > 0 && (
                                                                                <MotifSelect
                                                                                    key={marketSize}
                                                                                    ariaLabelledBy="select-label"
                                                                                    onChange={(value) => {
                                                                                        setIsFormDirty(true)
                                                                                        value !== marketSize && setIsSaveEnabled(true);
                                                                                        setMarketSize(value);
                                                                                    }}
                                                                                    placeholder="Select"
                                                                                    value={marketSize ? marketSize : ""}
                                                                                    triggerButtonProps={{
                                                                                        "aria-describedby": "select-error-reactive",
                                                                                    }}
                                                                                >
                                                                                    {userData?.revenueRanges
                                                                                        ?.filter(item => item.range !== "Others")
                                                                                        .map((item) => (
                                                                                            <MotifOption key={item.revenueRanges} value={item.range}>
                                                                                                {item.range}
                                                                                            </MotifOption>
                                                                                        ))}
                                                                                </MotifSelect>
                                                                            )}
                                                                        </MotifFormField>
                                                                    </div>
                                                                   
                                                                    <div className="field">
                                                                        <>
                                                                            <MotifLabel
                                                                                aria-label="additionalTags"
                                                                                htmlFor="additionalTags"
                                                                                className="field__label-additional-tags"
                                                                            >
                                                                                Additional Tags (up to 15)
                                                                            </MotifLabel>
                                                                            <MotifTooltip
                                                                                allowClick
                                                                                allowHover
                                                                                closeButtonProps={{}}
                                                                                flip
                                                                                id="tooltip"
                                                                                placement="auto"
                                                                                trigger={<MotifIcon src={infoIcon}

                                                                                //title="Additional tags may include sector, industry, business model, etc. Please ensure no PII or client identifiers are included." 
                                                                                />}
                                                                                variant="default"
                                                                            >
                                                                                Additional tags may include sector, industry,<br /> business model, etc. Please ensure no PII or<br /> client identifiers are included.
                                                                            </MotifTooltip>
                                                                            <MotifFormField
                                                                                aria-label="additionalTags"
                                                                                role="group"
                                                                                style={{ position: 'relative' }} // Set position relative for the container
                                                                            >
                                                                                <MotifInput
                                                                                    aria-label="additionalTags"
                                                                                    id="additionalTags"
                                                                                    label="additionalTags"
                                                                                    type="text"
                                                                                    maxLength="501"
                                                                                    onChange={onAdditionalTagsClick}
                                                                                    value={additionalTags}
                                                                                    style={{ paddingRight: '50px' }} // Add padding to make space for the button
                                                                                />
                                                                                {additionalTags && <MotifButton
                                                                                    onClick={addTag}
                                                                                    className="tag-button"
                                                                                >
                                                                                    <MotifIcon
                                                                                        src={IconoirCheck}
                                                                                        style={{
                                                                                            width: "20px",
                                                                                            height: "20px",
                                                                                            marginRight: "4px",
                                                                                        }}
                                                                                    />
                                                                                </MotifButton>}
                                                                            </MotifFormField>
                                                                            {/* {!ShowErrorMsg && <div className="additionalTags_label">Use the 'Add' button to add a new tag. </div>} */}
                                                                            {ShowErrorMsg && (
                                                                                <MotifErrorMessage id="select-error-reactive">
                                                                                    {toastMessage}
                                                                                </MotifErrorMessage>
                                                                            )}
                                                                            {<div style={{ display: 'flex', flexWrap: 'wrap', marginTop: '10px' }}>
                                                                                {tagsList.map((tag, index) => (
                                                                                    <div key={index} className="tag-item">
                                                                                        <div className="tag-text" title={tag}>
                                                                                            {tag}
                                                                                        </div>
                                                                                        <button onClick={() => removeTag(index)} className="tag-remove-button">
                                                                                            X
                                                                                        </button>
                                                                                    </div>
                                                                                ))}
                                                                            </div>}

                                                                        </>
                                                                    </div>
                                                                </>
                                                            )}
                                                            {(dialogMode === "passwordReminder") && (
                                                                <div className="password-reminder field">
                                                                    <p>Do you want to enable or disable Email Password reminders?</p>
                                                                    <p>Please select the correct option to proceed.</p>

                                                                    <div className="radio-group">
                                                                        <label className="radio-option enable">
                                                                            <input
                                                                                type="radio"
                                                                                name="passwordReminder"
                                                                                id="enable"
                                                                                value="true"
                                                                                checked={enableDisableEmailReminder === true}
                                                                                onChange={() => setEnableDisableEmailReminder(true)}
                                                                            />
                                                                            <strong>Enable</strong>
                                                                        </label>

                                                                        <label className="radio-option disable">
                                                                            <input
                                                                                type="radio"
                                                                                name="passwordReminder"
                                                                                id="disable"
                                                                                value="false"
                                                                                checked={enableDisableEmailReminder === false}
                                                                                onChange={() => setEnableDisableEmailReminder(false)}
                                                                            />
                                                                            <strong>Disable</strong>
                                                                        </label>
                                                                    </div>

                                                                </div>
                                                            )}
                                                        </div>
                                                        {
                                                            dialogMode === "manageaccess" && <>
                                                                {showManageAccessLoader && <div
                                                                    style={{
                                                                        position: 'absolute',
                                                                        inset: 0,
                                                                        backgroundColor: 'rgba(255,255,255,0.5)',
                                                                        zIndex: 9999,
                                                                        display: 'flex',
                                                                        alignItems: 'center',
                                                                        justifyContent: 'center',
                                                                    }}
                                                                ><MotifProgressLoader show variant="default" /></div>}

                                                                <MotifLabel htmlFor="input" aria-label={'Email Address'} >
                                                                    Add data uploaders to the selected engagements
                                                                </MotifLabel>
                                                                <div className="motif-col-lg-10 custom-motif-col-lg-10">
                                                                    <Select className="motif-select "
                                                                        isMulti
                                                                        value={selectedValue}
                                                                        onInputChange={(inputValue) => {
                                                                            debouncedSearch(inputValue);
                                                                        }}
                                                                        options={userOptions}
                                                                        onChange={(val) => {

                                                                            setValue(val);

                                                                        }}

                                                                        formatOptionLabel={(data, { context }) => {
                                                                            if (context === "menu") {
                                                                                // Show image + name + email in dropdown
                                                                                return (
                                                                                    <div className="image-wrapper">
                                                                                        {data.image ? <img
                                                                                            src={data.image}
                                                                                            alt=""
                                                                                            style={{ width: 24, height: 24, borderRadius: '50%', marginRight: 8 }}
                                                                                        /> :
                                                                                            <div class="avatar-wrapper">
                                                                                                <div class="avatar">{getInitials(data.label)}</div>

                                                                                            </div>}
                                                                                        <div>
                                                                                            <div>{data.label}</div>
                                                                                            <small style={{ color: '#666' }}>{data.value}</small>
                                                                                        </div>
                                                                                    </div>
                                                                                );
                                                                            }


                                                                            return data.label;
                                                                        }}
                                                                    />

                                                                </div>

                                                                <MotifLabel style={{ marginTop: '15px', marginBottom: '5px' }}>List of data uploaders <MotifBadge value={dataUploaderList.length} /></MotifLabel>

                                                                <div className="container-data-uploaders">
                                                                    <div className="top-section-uploader">

                                                                        <MotifSearch
                                                                            aria-label='Search'
                                                                            onChange={(e) => onUserFilterTextBoxChanged(e.target?.value)}
                                                                            placeholder='Search...'
                                                                            value={searchUser}
                                                                            style={{ flex: '2', height: '30px' }}
                                                                            className="dataUploader-Search"
                                                                            hideClearButton={true}

                                                                        />
                                                                        <MotifButton variant="text" onClick={() => handleRemoveAll()}>Remove All</MotifButton>


                                                                    </div>
                                                                    <div className="dv-datauploaderlist">
                                                                        {dataUploaderList.length === 0 ? (
                                                                            <p>No uploaders found.</p>
                                                                        ) : (
                                                                            dataUploaderList.filter(item => item.email.includes(searchUser.toLowerCase())).map((uploader) => {
                                                                                const selected = checkedItems[uploader.email] || new Set();
                                                                                const allSelected = uploader.engagements.length > 0 && selected.size === uploader.engagements.length;

                                                                                return (

                                                                                    <MotifAccordion
                                                                                        style={{
                                                                                            flex: '1'
                                                                                        }}
                                                                                        variant="functional"
                                                                                        useChevronIcon={true}

                                                                                    >
                                                                                        <React.Fragment key={uploader.email}>
                                                                                            <MotifAccordionTrigger
                                                                                                icons={{
                                                                                                    collapseTitle: 'Collapse section',
                                                                                                    expandTitle: 'Expand section'
                                                                                                }}
                                                                                                style={{ borderRadius: '0' }}

                                                                                            >
                                                                                                <div className="image-wrapper-container">

                                                                                                    <div className="image-wrapper">
                                                                                                        {uploader.profilePhoto ? <img
                                                                                                            loading="lazy"
                                                                                                            src={uploader.profilePhoto}
                                                                                                            alt=""
                                                                                                            style={{ width: 24, height: 24, borderRadius: '50%', marginRight: 8 }}
                                                                                                        /> :
                                                                                                            <div class="avatar-wrapper">
                                                                                                                <div class="avatar">{getInitials(uploader.userName)}</div>

                                                                                                            </div>}
                                                                                                        <div>
                                                                                                            <div>{uploader.userName}</div>
                                                                                                            <small style={{ color: '#666' }}>{uploader.email}</small>
                                                                                                        </div>

                                                                                                    </div>
                                                                                                    <MotifButton variant="text" onClick={() => { handleDeleteSelected(uploader.email, 'User') }}>Remove</MotifButton>
                                                                                                </div>

                                                                                            </MotifAccordionTrigger>
                                                                                            <MotifAccordionContent className="cls-motifAccordionContent">
                                                                                                <div className="accordian-select-all-container">
                                                                                                    <label>
                                                                                                        <MotifCheckbox checked={allSelected}
                                                                                                            onChange={(e) =>
                                                                                                                handleSelectAllChange(uploader.email, uploader.engagements, e.target.checked)
                                                                                                            }
                                                                                                            id={uploader.email} /> Select all
                                                                                                    </label>
                                                                                                    <MotifButton variant="text" onClick={() =>
                                                                                                        allSelected
                                                                                                            ? handleDeleteSelected(uploader.email, 'User') // all engagements
                                                                                                            : handleDeleteSelected(uploader.email, 'Engagement') // only selected
                                                                                                    } disabled={!(checkedItems[uploader.email]?.size > 0)} >
                                                                                                        Delete
                                                                                                    </MotifButton>
                                                                                                </div>
                                                                                                <div className="id-checkboxes id-checkboxes-label-container">
                                                                                                    {uploader.engagements.map((id) => (
                                                                                                        <label key={id} className="id-checkboxes-label-content">
                                                                                                            <MotifCheckbox
                                                                                                                checked={selected.has(id)}
                                                                                                                onChange={(e) =>
                                                                                                                    handleEngCheckboxChange(uploader.email, id, e.target.checked)
                                                                                                                }
                                                                                                                value={id}
                                                                                                                id={`${uploader.email} ${id}`}
                                                                                                            />
                                                                                                            {id}
                                                                                                        </label>
                                                                                                    ))}
                                                                                                </div>
                                                                                            </MotifAccordionContent>
                                                                                        </React.Fragment>
                                                                                    </MotifAccordion>
                                                                                )
                                                                            })
                                                                        )}



                                                                    </div>
                                                                </div>
                                                            </>
                                                        }
                                                        {dialogMode === "submit" && <p >The uploaded files have been successfully submitted.</p>}
                                                    </DialogContent>

                                                    <DialogActions>
                                                        {dialogMode !== "submit" && <MotifButton
                                                            onClick={onEditModalClose}
                                                            size="medium"
                                                            type="button"
                                                            variant="secondary"
                                                        >
                                                            Cancel

                                                        </MotifButton>}

                                                        <MotifButton
                                                            onClick={dialogMode === "submit" ? onEditModalClose : dialogMode === "manageaccess" ? grantAccess : dialogMode === "passwordReminder" ? enableDisableEmailReminderAction : onSaveClick} size="medium"
                                                            type="button"
                                                            disabled={isConfirmButtonDisabled()}
                                                        >
                                                            {dialogMode === "submit" ? 'Close' : 'Confirm'}
                                                        </MotifButton>
                                                    </DialogActions>
                                                </Dialog>
                                                <Dialog
                                                    open={openMDDialog}
                                                    onClose={handleMDDialogClose}
                                                    aria-labelledby="alert-dialog-title"
                                                    aria-describedby="alert-dialog-description"
                                                    className='deleteDialogBox'
                                                >
                                                    <DialogTitle>
                                                        <IconButton
                                                            onClick={handleMDDialogClose}
                                                            sx={{
                                                                position: "absolute",
                                                                right: 8,
                                                                top: 8,
                                                            }}
                                                        >
                                                            <CloseIcon />
                                                        </IconButton>
                                                        <img src={require("../../common/images/warning-triangle.png")} alt={"Note"} />

                                                    </DialogTitle>
                                                    <DialogContent>
                                                        <span id="alert-dialog-description">
                                                            {deleteOption === 'All' ? (<>
                                                                <strong>Remove data upload access for all?</strong>
                                                                <p>
                                                                    All the data uploaders will be unable to upload files to the selected engagement.
                                                                </p>
                                                            </>
                                                            ) : (<>
                                                                <strong>
                                                                    Remove data upload access for {
                                                                        dataUploaderList.find(item => item.email === uploaderToDelete)?.userName || 'this user'
                                                                    }?
                                                                </strong>
                                                                <p>
                                                                    {
                                                                        dataUploaderList.find(item => item.email === uploaderToDelete)?.userName || 'This user'
                                                                    } will be unable to upload files to the {
                                                                        deleteOption === 'User'
                                                                            ? 'selected engagements'
                                                                            : `engagement${selectedEngagementToRevoke.length > 1 ? 's' : ''} ${selectedEngagementToRevoke.join(', ')}`
                                                                    }.
                                                                </p>   </>
                                                            )}
                                                        </span>
                                                        {showManageAccessLoader && <div
                                                            className="loader-overlay"
                                                        ><MotifProgressLoader show variant="default" /></div>}
                                                    </DialogContent>
                                                    <DialogActions>
                                                        <MotifButton onClick={handleMDDialogClose} color="secondary" variant='secondary' autoFocus>
                                                            Close
                                                        </MotifButton>
                                                        <MotifButton onClick={handleMDDialogConfirm} color="primary" autoFocus>
                                                            Confirm
                                                        </MotifButton>
                                                    </DialogActions>
                                                </Dialog>

                                            </div>
                                        {isLoading && (
                                            <div className="page-loader-overlay">
                                                <MotifProgressLoader show variant="default" />
                                            </div>
                                        )}
                                    </div>
                                </div>
                            </div>
                        )}
                    </div>
                )}
                <ViewFiles
                    show={isMenuOpen}
                    onClose={onCloseMenu}
                    items={engagementData}
                    rowData={rowData}
                    searchValue={searchValue}
                    onAddMoreFilesClick={onAddMoreFilesClick}
                    handleRemoveFile={handleRemoveFile}
                    showToast={showToast}
                    handleCloseToast={handleCloseToast}
                    toastMessage={toastMessage}
                    handleViewFilecontent={handleViewFilecontent}
                    handleDownloadFileContent={handleDownloadFileContent}
                    isLoading={isViewLoading || isLoading}
                    fileName={fileName}
                    setOpenDialog={deleteDialogOpen}
                    isFileViewerOpen={isFileViewerOpen}
                    setFileViewerOpen={setFileViewerOpen}
                    fileUrl={decryptedFileUrl}
                    deleteTempFiles={deleteTempFiles}
                    baseURL={baseURL}
                />

                <AddFiles
                    setFailedUploadLoadData={setFailedUploadLoadData}
                    openFailedUploadBadge={openFailedUploadBadge}
                    failedUploads={failedUploads.filter(
                        item => item.engagementID === rowData.engagementId)}
                    setFailedUploads={setFailedUploads}
                    failedUploadData={failedUploadData.filter(item => item.errorId)}
                    show={isAddFilesOpen}
                    onClose={onAdddFilesClose}
                    items={engagementData}
                    rowData={rowData}
                    searchValue={searchValue}
                    onAddMoreFilesClick={onAddFilesClick}
                    triggerEngagementUpdate={triggerEngagementUpdate}
                    isToastVisible={isToastVisible}
                    setIsToastVisible={setIsToastVisible}
                    setTotalPendingCount={setTotalPendingCount}
                    onPendingFilesClose={onPendingFilesClose}
                    isPendingFileOpen={isPendingFileOpen}
                    handleRemoveFile={handleRemoveFile}
                    uploadPercentage={uploadPercentage}
                    setUploadPercentage={setUploadPercentage}
                    fileStatus={fileStatus}
                    engagementPauseStatus={engagementPauseStatus}
                    initiateAutoProcess={initiateAutoProcess}
                    isAddFilesOpen={isAddFilesOpen}
                    setAlertMessage={setAlertMessage}
                    setOpenAlertDialog={setOpenAlertDialog}
                />
                <FailedFilesUpload
                    // UploadFolders={UploadFolders}
                    failedUploadData={failedUploadData}
                    failedUploads={failedUploads}
                    setFailedUploads={setFailedUploads}
                    show={isFailedUploadOpen}
                    // show={isAddFilesOpen}
                    onClose={failedUploadClose}
                    items={engagementData}
                    rowData={rowData}
                    onFailUploadClick={onFailedUploadClick}
                    onDownloadArcFilesClick={onDownloadArcFilesClick}
                    isRetryDownloadDisabled={isArcGuidDownloading(partnersDownloadArcArchivesData?.data, rowData?.engagementId_GUID) || isArcMetadataMissing(rowData)}
                    // searchValue={searchValue}
                    // onAddMoreFilesClick={onAddFilesClick}
                    // refreshData={getData}
                    setInteraction={setInteraction}
                    triggerEngagementUpdate={triggerEngagementUpdate}
                // isToastVisible={isToastVisible}
                // setIsToastVisible={setIsToastVisible}

                />


                <PendingFiles
                    show={isPendingFileOpen}
                    onClose={onPendingFilesClose}
                    items={pendingFilesData}
                    protectedFiles={pendingFilesData}
                    rowData={rowData}
                    searchValue={searchValue}
                    onAddMoreFilesClick={onPendingFilesClick}
                    setTotalPendingCount={setTotalPendingCount}
                    setInteraction={setInteraction}
                    triggerEngagementUpdate={triggerEngagementUpdate}
                    handleRemoveFile={handleRemoveFile}
                    isPendingFilesLoading={isPendingFilesLoading || isLoading}
                />
                {isDelegateToastVisible && ( // Render toast only if visible
                    <MotifToast variant={delegateAction == "Grant" ? 'success' : 'warning'} className="motif-toast-container">
                        <div className="result">{manageDelegateMsg}</div>
                    </MotifToast>
                )}
                <PartnerUploadFooter showNetworkStatus={!isLoading} />
            </div>
        </>
    );
};